var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12079.638 7142.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GrassFloor"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "12074.084 3225.721 5681.627 6948.255 0 3700.587 6457.673 0 12074.084 3225.721",
    fill: "#97c941"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.553 3700.587 13.553 3889.955 5679.144 7142.146 5679.154 6952.772 13.553 3700.587",
    fill: "#7ba826"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12079.638 3411.976 12079.638 3222.603 5677.366 6942.06 5677.356 7131.433 12079.638 3411.976",
    fill: "#6f961b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8872.548 3238.128 5021.399 5453.084 2998.539 4274.337 6865.928 2060.472 8872.548 3238.128",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.237 3951.016 6847.177 228.482 7208.588 427.258 838.719 4158.827 459.237 3951.016",
    fill: "#3ba4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2562.762,3042.406s50.823-94.87,215.153-99.953c0,0,45.741,3.388,99.953-52.518,0,0-3.388,60.988-118.588,79.623,0,0-54.212-28.8-196.517,72.847Z",
    fill: "#1081c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2001.394,3284.905s-158.023,9.624-455.026,274.364c0,0-79.265,77.41-215.704,122.75,0,0,49.302,41.692,268.199-132.226,0,0,76.366-110.94,402.53-264.887Z",
    fill: "#4dbff7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5430.828,1233.359s-158.023,9.624-455.026,274.364c0,0-79.265,77.41-215.704,122.75,0,0,49.302,41.692,268.199-132.226,0,0,76.366-110.94,402.53-264.887Z",
    fill: "#4dbff7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3784.219,2204.949s-191.85-4.573-391.724,270.341c0,0-48.941,81.135-190.46,119.75,0,0,88.976,52.8,250.101-125.449,0,0,23.462-119.961,332.083-264.643Z",
    fill: "#1081c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3643.607,2376.054s50.823-94.87,215.153-99.953c0,0,45.741,3.388,99.953-52.518,0,0-3.388,60.988-118.588,79.623,0,0-54.212-28.8-196.517,72.847Z",
    fill: "#1081c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5234.38,1254.551s50.823-94.87,215.153-99.953c0,0,45.741,3.388,99.953-52.518,0,0-3.388,60.988-118.588,79.623,0,0-54.212-28.8-196.517,72.847Z",
    fill: "#4dbff7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3969.442,2026.502s270.751-123.511,365.622-231.935c0,0-293.339,236.452-365.622,231.935Z",
    fill: "#1081c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5573.73,1248.025s311.984-158.642,421.303-297.905c0,0-338.012,303.707-421.303,297.905Z",
    fill: "#4dbff7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3242.563,2488.954s-158.023,9.624-455.026,274.364c0,0-79.265,77.41-215.704,122.75,0,0,49.302,41.692,268.199-132.226,0,0,76.366-110.94,402.53-264.887Z",
    fill: "#4dbff7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2413.152,3044.868s-191.85-4.573-391.724,270.341c0,0-48.941,81.135-190.46,119.75,0,0,88.976,52.8,250.101-125.449,0,0,23.462-119.961,332.083-264.643Z",
    fill: "#1081c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4687.45,1667.296s-191.85-4.573-391.724,270.341c0,0-48.941,81.135-190.46,119.75,0,0,88.976,52.8,250.101-125.449,0,0,23.462-119.961,332.083-264.643Z",
    fill: "#4dbff7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5729.626,973.328s50.823-94.87,215.153-99.953c0,0,45.741,3.388,99.953-52.518,0,0-3.388,60.988-118.588,79.623,0,0-54.212-28.8-196.517,72.847Z",
    fill: "#1081c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4769.064,1381.915c7.661,0,7.674-11.906,0-11.906s-7.674,11.906,0,11.906h0Z",
    fill: "#4dbff7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6176.308,847.963s50.823-94.87,215.153-99.953c0,0,45.741,3.388,99.953-52.518,0,0-3.388,60.988-118.588,79.623,0,0-54.212-28.8-196.517,72.847Z",
    fill: "#4dbff7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6360.966,707.917s50.823-94.87,215.153-99.953c0,0,45.741,3.388,99.953-52.518,0,0-3.388,60.988-118.588,79.623,0,0-54.212-28.8-196.517,72.847Z",
    fill: "#1081c6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7400.374 555.797 12079.638 3222.603 10526.793 4129.463 5936.659 1402.854 7400.374 555.797",
    fill: "#959597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3994.289,4983.296l393.035,223.623s-210.07,88.094-33.882,189.741l1423.056,840.281s88.094,74.541,250.729-33.882l4716.414-2683.477,352.376,264.282-5425.426,3151.42L1602.199,4617.367l717.998-405.035,1441.433,820.658s94.87,106.164,232.658-49.694Z",
    fill: "#959597"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6647.272,
    y1: 1990.147,
    x2: 9357.854,
    y2: 3580.356,
    fill: "none",
    stroke: "#f3ff00",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7137.098,3525.881c-47.645,27.476-125.525,27.329-173.066-.327l-1236.627-719.384c-47.541-27.656-47.44-72.737,.224-100.18l944.791-543.971c47.664-27.443,125.381-26.966,172.705,1.061l1223.865,724.813c47.323,28.027,47.06,73.438-.585,100.914l-931.308,537.073Z",
    fill: "#895f02"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 4453.958,
    y1: 4894.073,
    x2: 4483.323,
    y2: 5247.578,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4482.758,
    y1: 4911.014,
    x2: 4512.123,
    y2: 5264.519,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4507.747,
    y1: 4925.132,
    x2: 4537.111,
    y2: 5278.637,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4534.429,
    y1: 4940.379,
    x2: 4563.794,
    y2: 5293.884,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4561.535,
    y1: 4955.626,
    x2: 4590.899,
    y2: 5309.131,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4589.488,
    y1: 4971.72,
    x2: 4618.852,
    y2: 5325.225,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4618.288,
    y1: 4987.814,
    x2: 4647.652,
    y2: 5341.319,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4647.935,
    y1: 5006.449,
    x2: 4677.299,
    y2: 5359.954,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4677.582,
    y1: 5024.237,
    x2: 4706.946,
    y2: 5377.742,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4707.229,
    y1: 5040.331,
    x2: 4736.593,
    y2: 5393.836,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4735.181,
    y1: 5058.12,
    x2: 4764.546,
    y2: 5411.625,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4758.899,
    y1: 5070.825,
    x2: 4788.264,
    y2: 5424.331,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4785.158,
    y1: 5086.919,
    x2: 4814.522,
    y2: 5440.425,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4815.652,
    y1: 5105.555,
    x2: 4845.016,
    y2: 5459.06,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4841.911,
    y1: 5119.108,
    x2: 4857.44,
    y2: 5391.578,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4866.758,
    y1: 5131.531,
    x2: 4688.029,
    y2: 5367.013,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4846.428,
    y1: 5117.978,
    x2: 4667.699,
    y2: 5353.46,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4823.558,
    y1: 5107.814,
    x2: 4644.829,
    y2: 5343.295,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4802.381,
    y1: 5095.955,
    x2: 4623.652,
    y2: 5331.437,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4783.322,
    y1: 5082.402,
    x2: 4604.593,
    y2: 5317.884,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4762.993,
    y1: 5068.849,
    x2: 4584.264,
    y2: 5304.331,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4740.123,
    y1: 5058.684,
    x2: 4561.394,
    y2: 5294.166,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4718.946,
    y1: 5046.825,
    x2: 4540.217,
    y2: 5282.307,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4698.617,
    y1: 5033.273,
    x2: 4519.888,
    y2: 5268.754,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4678.287,
    y1: 5019.72,
    x2: 4499.558,
    y2: 5255.201,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4655.417,
    y1: 5009.555,
    x2: 4476.688,
    y2: 5245.037,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4634.24,
    y1: 4997.696,
    x2: 4455.511,
    y2: 5233.178,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4614.758,
    y1: 4984.99,
    x2: 4442.382,
    y2: 5202.684,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4594.429,
    y1: 4971.437,
    x2: 4430.523,
    y2: 5177.272,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4571.558,
    y1: 4961.273,
    x2: 4429.676,
    y2: 5142.543,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4550.382,
    y1: 4949.414,
    x2: 4427.982,
    y2: 5101.884,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4528.358,
    y1: 4936.708,
    x2: 4431.37,
    y2: 5055.296,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4508.029,
    y1: 4923.155,
    x2: 4429.676,
    y2: 5022.261,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4485.158,
    y1: 4912.99,
    x2: 4429.676,
    y2: 4986.684,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4463.982,
    y1: 4901.132,
    x2: 4425.441,
    y2: 4947.72,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4972.428,
    y1: 5193.366,
    x2: 4793.699,
    y2: 5428.848,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4952.099,
    y1: 5179.813,
    x2: 4773.37,
    y2: 5415.295,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4929.228,
    y1: 5169.649,
    x2: 4750.499,
    y2: 5405.131,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4908.052,
    y1: 5157.79,
    x2: 4729.323,
    y2: 5393.272,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4888.993,
    y1: 5144.237,
    x2: 4710.264,
    y2: 5379.719,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 4899.51,
    y1: 5151.578,
    x2: 4928.875,
    y2: 5505.083,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4928.31,
    y1: 5168.519,
    x2: 4957.675,
    y2: 5522.024,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4953.299,
    y1: 5182.637,
    x2: 4982.663,
    y2: 5536.142,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4979.981,
    y1: 5197.884,
    x2: 5009.346,
    y2: 5551.389,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5007.087,
    y1: 5213.131,
    x2: 5036.451,
    y2: 5566.636,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5035.04,
    y1: 5229.225,
    x2: 5064.404,
    y2: 5582.73,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5063.84,
    y1: 5245.319,
    x2: 5093.204,
    y2: 5598.824,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5093.487,
    y1: 5263.954,
    x2: 5122.851,
    y2: 5617.46,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5123.134,
    y1: 5281.743,
    x2: 5152.498,
    y2: 5635.248,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5152.781,
    y1: 5297.837,
    x2: 5182.145,
    y2: 5651.342,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5180.733,
    y1: 5315.625,
    x2: 5210.098,
    y2: 5669.13,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5204.451,
    y1: 5328.331,
    x2: 5233.816,
    y2: 5681.836,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5230.71,
    y1: 5344.425,
    x2: 5260.074,
    y2: 5697.93,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5261.204,
    y1: 5363.06,
    x2: 5290.569,
    y2: 5716.565,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5287.463,
    y1: 5376.613,
    x2: 5302.992,
    y2: 5649.083,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5312.31,
    y1: 5389.037,
    x2: 5133.581,
    y2: 5624.518,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5291.98,
    y1: 5375.484,
    x2: 5113.251,
    y2: 5610.965,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5269.11,
    y1: 5365.319,
    x2: 5090.381,
    y2: 5600.801,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5247.933,
    y1: 5353.46,
    x2: 5069.204,
    y2: 5588.942,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5228.875,
    y1: 5339.907,
    x2: 5050.145,
    y2: 5575.389,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5208.545,
    y1: 5326.354,
    x2: 5029.816,
    y2: 5561.836,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5185.675,
    y1: 5316.19,
    x2: 5006.946,
    y2: 5551.671,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5164.498,
    y1: 5304.331,
    x2: 4985.769,
    y2: 5539.813,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5144.169,
    y1: 5290.778,
    x2: 4965.44,
    y2: 5526.26,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5123.839,
    y1: 5277.225,
    x2: 4945.11,
    y2: 5512.707,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5100.969,
    y1: 5267.06,
    x2: 4922.24,
    y2: 5502.542,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5079.792,
    y1: 5255.201,
    x2: 4901.063,
    y2: 5490.683,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5060.31,
    y1: 5242.496,
    x2: 4887.934,
    y2: 5460.189,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5039.981,
    y1: 5228.943,
    x2: 4876.075,
    y2: 5434.778,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5017.11,
    y1: 5218.778,
    x2: 4875.228,
    y2: 5400.048,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4995.934,
    y1: 5206.919,
    x2: 4873.534,
    y2: 5359.39,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4973.91,
    y1: 5194.213,
    x2: 4876.922,
    y2: 5312.801,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4953.581,
    y1: 5180.66,
    x2: 4875.228,
    y2: 5279.766,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4930.71,
    y1: 5170.496,
    x2: 4875.228,
    y2: 5244.19,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4909.534,
    y1: 5158.637,
    x2: 4870.993,
    y2: 5205.225,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5417.98,
    y1: 5450.872,
    x2: 5239.251,
    y2: 5686.354,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5397.651,
    y1: 5437.319,
    x2: 5218.922,
    y2: 5672.801,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5374.78,
    y1: 5427.154,
    x2: 5196.051,
    y2: 5662.636,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5353.604,
    y1: 5415.295,
    x2: 5174.875,
    y2: 5650.777,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5334.545,
    y1: 5401.742,
    x2: 5155.816,
    y2: 5637.224,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4887.369,5481.036c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4861.393,5107.437s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4868.546,5507.248s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4880.028,5487.53c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 5324.82,
    y1: 5395.389,
    x2: 5354.184,
    y2: 5748.895,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5353.619,
    y1: 5412.331,
    x2: 5382.984,
    y2: 5765.836,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5378.608,
    y1: 5426.448,
    x2: 5407.972,
    y2: 5779.953,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5405.29,
    y1: 5441.695,
    x2: 5434.655,
    y2: 5795.2,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5432.396,
    y1: 5456.942,
    x2: 5461.76,
    y2: 5810.447,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5460.349,
    y1: 5473.036,
    x2: 5489.713,
    y2: 5826.542,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5489.149,
    y1: 5489.13,
    x2: 5518.513,
    y2: 5842.636,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5518.796,
    y1: 5507.766,
    x2: 5548.16,
    y2: 5861.271,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5548.443,
    y1: 5525.554,
    x2: 5577.807,
    y2: 5879.059,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5578.09,
    y1: 5541.648,
    x2: 5607.454,
    y2: 5895.153,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5606.042,
    y1: 5559.436,
    x2: 5635.407,
    y2: 5912.941,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5629.76,
    y1: 5572.142,
    x2: 5659.125,
    y2: 5925.647,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5656.019,
    y1: 5588.236,
    x2: 5685.384,
    y2: 5941.741,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5686.513,
    y1: 5606.871,
    x2: 5715.878,
    y2: 5960.377,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5712.772,
    y1: 5620.424,
    x2: 5728.301,
    y2: 5892.894,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5737.619,
    y1: 5632.848,
    x2: 5558.89,
    y2: 5868.33,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5717.289,
    y1: 5619.295,
    x2: 5538.56,
    y2: 5854.777,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5694.419,
    y1: 5609.13,
    x2: 5515.69,
    y2: 5844.612,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5673.242,
    y1: 5597.271,
    x2: 5494.513,
    y2: 5832.753,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5654.184,
    y1: 5583.718,
    x2: 5475.455,
    y2: 5819.2,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5633.854,
    y1: 5570.166,
    x2: 5455.125,
    y2: 5805.647,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5610.984,
    y1: 5560.001,
    x2: 5432.255,
    y2: 5795.483,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5589.807,
    y1: 5548.142,
    x2: 5411.078,
    y2: 5783.624,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5569.478,
    y1: 5534.589,
    x2: 5390.749,
    y2: 5770.071,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5549.148,
    y1: 5521.036,
    x2: 5370.419,
    y2: 5756.518,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5526.278,
    y1: 5510.872,
    x2: 5347.549,
    y2: 5746.353,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5505.102,
    y1: 5499.013,
    x2: 5326.372,
    y2: 5734.495,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5485.619,
    y1: 5486.307,
    x2: 5313.243,
    y2: 5704.001,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5465.29,
    y1: 5472.754,
    x2: 5301.384,
    y2: 5678.589,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5442.419,
    y1: 5462.589,
    x2: 5300.537,
    y2: 5643.86,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5421.243,
    y1: 5450.731,
    x2: 5298.843,
    y2: 5603.201,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5399.219,
    y1: 5438.025,
    x2: 5302.231,
    y2: 5556.613,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5378.89,
    y1: 5424.472,
    x2: 5300.537,
    y2: 5523.577,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5356.019,
    y1: 5414.307,
    x2: 5300.537,
    y2: 5488.001,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5334.843,
    y1: 5402.448,
    x2: 5296.302,
    y2: 5449.036,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5843.289,
    y1: 5694.683,
    x2: 5664.56,
    y2: 5930.165,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5822.96,
    y1: 5681.13,
    x2: 5644.231,
    y2: 5916.612,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5800.089,
    y1: 5670.965,
    x2: 5621.36,
    y2: 5906.447,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5778.913,
    y1: 5659.107,
    x2: 5600.184,
    y2: 5894.588,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5759.854,
    y1: 5645.554,
    x2: 5581.125,
    y2: 5881.036,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 5772.066,
    y1: 5651.201,
    x2: 5801.43,
    y2: 6004.706,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5800.866,
    y1: 5668.142,
    x2: 5830.23,
    y2: 6021.647,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5825.854,
    y1: 5682.259,
    x2: 5855.218,
    y2: 6035.765,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5852.536,
    y1: 5697.506,
    x2: 5881.901,
    y2: 6051.012,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5879.642,
    y1: 5712.754,
    x2: 5909.007,
    y2: 6066.259,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5907.595,
    y1: 5728.848,
    x2: 5936.959,
    y2: 6082.353,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5936.395,
    y1: 5744.942,
    x2: 5965.759,
    y2: 6098.447,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5966.042,
    y1: 5763.577,
    x2: 5995.406,
    y2: 6117.082,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5995.689,
    y1: 5781.365,
    x2: 6025.053,
    y2: 6134.87,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6025.336,
    y1: 5797.459,
    x2: 6054.7,
    y2: 6150.964,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6053.289,
    y1: 5815.247,
    x2: 6082.653,
    y2: 6168.753,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6077.006,
    y1: 5827.953,
    x2: 6106.371,
    y2: 6181.458,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6103.265,
    y1: 5844.047,
    x2: 6132.63,
    y2: 6197.553,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6133.759,
    y1: 5862.683,
    x2: 6163.124,
    y2: 6216.188,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6160.018,
    y1: 5876.236,
    x2: 6175.547,
    y2: 6148.706,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6184.865,
    y1: 5888.659,
    x2: 6006.136,
    y2: 6124.141,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6164.535,
    y1: 5875.106,
    x2: 5985.806,
    y2: 6110.588,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6141.665,
    y1: 5864.941,
    x2: 5962.936,
    y2: 6100.423,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6120.489,
    y1: 5853.083,
    x2: 5941.759,
    y2: 6088.565,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6101.43,
    y1: 5839.53,
    x2: 5922.701,
    y2: 6075.012,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6081.1,
    y1: 5825.977,
    x2: 5902.371,
    y2: 6061.459,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6058.23,
    y1: 5815.812,
    x2: 5879.501,
    y2: 6051.294,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6037.053,
    y1: 5803.953,
    x2: 5858.324,
    y2: 6039.435,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6016.724,
    y1: 5790.4,
    x2: 5837.995,
    y2: 6025.882,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5996.395,
    y1: 5776.847,
    x2: 5817.666,
    y2: 6012.329,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5973.524,
    y1: 5766.683,
    x2: 5794.795,
    y2: 6002.165,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5952.348,
    y1: 5754.824,
    x2: 5773.619,
    y2: 5990.306,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5932.865,
    y1: 5742.118,
    x2: 5760.489,
    y2: 5959.812,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5912.536,
    y1: 5728.565,
    x2: 5748.63,
    y2: 5934.4,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5889.665,
    y1: 5718.401,
    x2: 5747.783,
    y2: 5899.671,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5868.489,
    y1: 5706.542,
    x2: 5746.089,
    y2: 5859.012,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5846.466,
    y1: 5693.836,
    x2: 5749.477,
    y2: 5812.424,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5826.136,
    y1: 5680.283,
    x2: 5747.783,
    y2: 5779.389,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5803.266,
    y1: 5670.118,
    x2: 5747.783,
    y2: 5743.812,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5782.089,
    y1: 5658.259,
    x2: 5743.548,
    y2: 5704.848,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6290.535,
    y1: 5950.494,
    x2: 6111.806,
    y2: 6185.976,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6270.206,
    y1: 5936.941,
    x2: 6091.477,
    y2: 6172.423,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6247.335,
    y1: 5926.777,
    x2: 6068.606,
    y2: 6162.258,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6226.159,
    y1: 5914.918,
    x2: 6047.43,
    y2: 6150.4,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6207.1,
    y1: 5901.365,
    x2: 6028.371,
    y2: 6136.847,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 3523.844,
    y1: 4343.453,
    x2: 3553.209,
    y2: 4696.958,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3552.644,
    y1: 4360.394,
    x2: 3582.009,
    y2: 4713.9,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3577.632,
    y1: 4374.512,
    x2: 3606.997,
    y2: 4728.017,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3604.315,
    y1: 4389.759,
    x2: 3633.679,
    y2: 4743.264,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3631.42,
    y1: 4405.006,
    x2: 3660.785,
    y2: 4758.511,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3659.373,
    y1: 4421.1,
    x2: 3688.738,
    y2: 4774.605,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3688.173,
    y1: 4437.194,
    x2: 3717.538,
    y2: 4790.699,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3717.82,
    y1: 4455.83,
    x2: 3747.185,
    y2: 4809.335,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3747.467,
    y1: 4473.618,
    x2: 3776.832,
    y2: 4827.123,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3777.114,
    y1: 4489.712,
    x2: 3806.479,
    y2: 4843.217,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3805.067,
    y1: 4507.5,
    x2: 3834.432,
    y2: 4861.005,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3828.785,
    y1: 4520.206,
    x2: 3858.149,
    y2: 4873.711,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3855.044,
    y1: 4536.3,
    x2: 3884.408,
    y2: 4889.805,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3885.538,
    y1: 4554.935,
    x2: 3914.902,
    y2: 4908.44,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3911.796,
    y1: 4568.488,
    x2: 3927.326,
    y2: 4840.958,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3936.643,
    y1: 4580.912,
    x2: 3757.914,
    y2: 4816.394,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3916.314,
    y1: 4567.359,
    x2: 3737.585,
    y2: 4802.841,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3893.443,
    y1: 4557.194,
    x2: 3714.714,
    y2: 4792.676,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3872.267,
    y1: 4545.335,
    x2: 3693.538,
    y2: 4780.817,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3853.208,
    y1: 4531.782,
    x2: 3674.479,
    y2: 4767.264,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3832.879,
    y1: 4518.229,
    x2: 3654.15,
    y2: 4753.711,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3810.008,
    y1: 4508.065,
    x2: 3631.279,
    y2: 4743.547,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3788.832,
    y1: 4496.206,
    x2: 3610.103,
    y2: 4731.688,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3768.503,
    y1: 4482.653,
    x2: 3589.774,
    y2: 4718.135,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3748.173,
    y1: 4469.1,
    x2: 3569.444,
    y2: 4704.582,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3725.303,
    y1: 4458.935,
    x2: 3546.574,
    y2: 4694.417,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3704.126,
    y1: 4447.077,
    x2: 3525.397,
    y2: 4682.558,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3684.644,
    y1: 4434.371,
    x2: 3512.268,
    y2: 4652.064,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3664.315,
    y1: 4420.818,
    x2: 3500.409,
    y2: 4626.653,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3641.444,
    y1: 4410.653,
    x2: 3499.562,
    y2: 4591.923,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3620.268,
    y1: 4398.794,
    x2: 3497.868,
    y2: 4551.265,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3598.244,
    y1: 4386.088,
    x2: 3501.256,
    y2: 4504.676,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3577.915,
    y1: 4372.536,
    x2: 3499.562,
    y2: 4471.641,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3555.044,
    y1: 4362.371,
    x2: 3499.562,
    y2: 4436.065,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3533.868,
    y1: 4350.512,
    x2: 3495.327,
    y2: 4397.1,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3933.301,
    y1: 4785.085,
    x2: 3863.585,
    y2: 4878.229,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3929.912,
    y1: 4752.897,
    x2: 3843.255,
    y2: 4864.676,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3934.995,
    y1: 4703.767,
    x2: 3820.385,
    y2: 4854.511,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3934.995,
    y1: 4669.885,
    x2: 3799.208,
    y2: 4842.652,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3936.689,
    y1: 4624.144,
    x2: 3780.15,
    y2: 4829.099,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 3163.13,
    y1: 4133.839,
    x2: 3192.494,
    y2: 4487.344,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3191.93,
    y1: 4150.78,
    x2: 3221.294,
    y2: 4504.285,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3216.918,
    y1: 4164.898,
    x2: 3246.283,
    y2: 4518.403,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3243.6,
    y1: 4180.145,
    x2: 3272.965,
    y2: 4533.65,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3270.706,
    y1: 4195.392,
    x2: 3300.071,
    y2: 4548.897,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3298.659,
    y1: 4211.486,
    x2: 3328.024,
    y2: 4564.991,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3327.459,
    y1: 4227.58,
    x2: 3356.823,
    y2: 4581.085,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3357.106,
    y1: 4246.215,
    x2: 3386.47,
    y2: 4599.72,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3386.753,
    y1: 4264.003,
    x2: 3416.117,
    y2: 4617.509,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3416.4,
    y1: 4280.098,
    x2: 3445.764,
    y2: 4633.603,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3444.353,
    y1: 4297.886,
    x2: 3473.717,
    y2: 4651.391,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3468.07,
    y1: 4310.592,
    x2: 3497.435,
    y2: 4664.097,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3494.329,
    y1: 4326.686,
    x2: 3523.694,
    y2: 4680.191,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3524.823,
    y1: 4345.321,
    x2: 3554.188,
    y2: 4698.826,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3551.082,
    y1: 4358.874,
    x2: 3566.611,
    y2: 4631.344,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3575.929,
    y1: 4371.297,
    x2: 3397.2,
    y2: 4606.779,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3555.6,
    y1: 4357.744,
    x2: 3376.871,
    y2: 4593.226,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3532.729,
    y1: 4347.58,
    x2: 3354,
    y2: 4583.062,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3511.553,
    y1: 4335.721,
    x2: 3332.824,
    y2: 4571.203,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3492.494,
    y1: 4322.168,
    x2: 3313.765,
    y2: 4557.65,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3472.164,
    y1: 4308.615,
    x2: 3293.435,
    y2: 4544.097,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3449.294,
    y1: 4298.45,
    x2: 3270.565,
    y2: 4533.932,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3428.117,
    y1: 4286.592,
    x2: 3249.388,
    y2: 4522.074,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3407.788,
    y1: 4273.039,
    x2: 3229.059,
    y2: 4508.521,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3387.459,
    y1: 4259.486,
    x2: 3208.73,
    y2: 4494.968,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3364.588,
    y1: 4249.321,
    x2: 3185.859,
    y2: 4484.803,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3343.412,
    y1: 4237.462,
    x2: 3164.683,
    y2: 4472.944,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3323.929,
    y1: 4224.757,
    x2: 3151.553,
    y2: 4442.45,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3303.6,
    y1: 4211.204,
    x2: 3139.695,
    y2: 4417.038,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3280.73,
    y1: 4201.039,
    x2: 3138.847,
    y2: 4382.309,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3259.553,
    y1: 4189.18,
    x2: 3137.153,
    y2: 4341.65,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3237.53,
    y1: 4176.474,
    x2: 3140.542,
    y2: 4295.062,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3217.2,
    y1: 4162.921,
    x2: 3138.847,
    y2: 4262.027,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3194.33,
    y1: 4152.757,
    x2: 3138.847,
    y2: 4226.451,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3173.153,
    y1: 4140.898,
    x2: 3134.612,
    y2: 4187.486,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3681.599,
    y1: 4433.133,
    x2: 3502.87,
    y2: 4668.614,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3661.27,
    y1: 4419.58,
    x2: 3482.541,
    y2: 4655.062,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3638.399,
    y1: 4409.415,
    x2: 3459.67,
    y2: 4644.897,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3617.223,
    y1: 4397.556,
    x2: 3438.494,
    y2: 4633.038,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3598.164,
    y1: 4384.003,
    x2: 3419.435,
    y2: 4619.485,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3942.054,4925.367c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3916.077,4551.768s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3923.23,4951.579s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3934.712,4931.861c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3564.266,4716.991c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3538.29,4343.392s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3545.443,4743.203s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3556.925,4723.485c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 4539.229,
    y1: 2867.347,
    x2: 4697.346,
    y2: 3095.488,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4555.041,
    y1: 2852.665,
    x2: 4713.158,
    y2: 3080.806,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4582.711,
    y1: 2840.242,
    x2: 4740.828,
    y2: 3068.382,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4609.817,
    y1: 2825.559,
    x2: 4767.934,
    y2: 3053.7,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4633.535,
    y1: 2813.136,
    x2: 4791.652,
    y2: 3041.277,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4659.511,
    y1: 2797.324,
    x2: 4817.628,
    y2: 3025.465,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4685.487,
    y1: 2782.642,
    x2: 4833.158,
    y2: 3002.877,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4592.311,
    y1: 2835.724,
    x2: 4548.923,
    y2: 3194.782,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4621.346,
    y1: 2815.442,
    x2: 4577.958,
    y2: 3174.5,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4652.97,
    y1: 2793.983,
    x2: 4609.582,
    y2: 3153.041,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4683.464,
    y1: 2780.43,
    x2: 4640.076,
    y2: 3139.488,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4713.958,
    y1: 2764.618,
    x2: 4670.57,
    y2: 3123.676,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4745.581,
    y1: 2746.548,
    x2: 4702.193,
    y2: 3105.606,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4517.205,
    y1: 2879.771,
    x2: 4675.323,
    y2: 3107.912,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4499.135,
    y1: 2892.194,
    x2: 4657.252,
    y2: 3120.335,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4479.935,
    y1: 2903.489,
    x2: 4638.052,
    y2: 3131.629,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4459.605,
    y1: 2915.912,
    x2: 4617.723,
    y2: 3144.053,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4440.406,
    y1: 2926.077,
    x2: 4598.523,
    y2: 3154.217,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4421.206,
    y1: 2936.241,
    x2: 4579.323,
    y2: 3164.382,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4441.935,
    y1: 2915.371,
    x2: 4407.653,
    y2: 3231.582,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4470.97,
    y1: 2895.089,
    x2: 4427.582,
    y2: 3254.147,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4502.594,
    y1: 2873.63,
    x2: 4459.205,
    y2: 3232.688,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4533.088,
    y1: 2860.077,
    x2: 4489.7,
    y2: 3219.135,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4563.582,
    y1: 2844.265,
    x2: 4520.194,
    y2: 3203.323,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4400.17,
    y1: 2955.724,
    x2: 4558.288,
    y2: 3183.864,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4396.641,
    y1: 2992.712,
    x2: 4537.111,
    y2: 3196.57,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4400.876,
    y1: 3042.688,
    x2: 4509.652,
    y2: 3207.3,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4400.876,
    y1: 3095.206,
    x2: 4481.1,
    y2: 3223.253,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4777.487,
    y1: 2722.83,
    x2: 4734.099,
    y2: 3081.888,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4808.546,
    y1: 2704.195,
    x2: 4765.158,
    y2: 3063.253,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4832.875,
    y1: 2738.03,
    x2: 4800.734,
    y2: 3048.571,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4710.052,
    y1: 2769.654,
    x2: 4837.393,
    y2: 2965.606,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4729.393,
    y1: 2755.254,
    x2: 4831.746,
    y2: 2913.653,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4752.052,
    y1: 2746.359,
    x2: 4830.052,
    y2: 2869.042,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4770.44,
    y1: 2735.418,
    x2: 4832.875,
    y2: 2831.771,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4791.211,
    y1: 2724.865,
    x2: 4831.181,
    y2: 2785.465,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 4104.145,
    y1: 3113.42,
    x2: 4262.262,
    y2: 3341.56,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4119.956,
    y1: 3098.737,
    x2: 4278.074,
    y2: 3326.878,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4147.627,
    y1: 3086.314,
    x2: 4305.744,
    y2: 3314.455,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4174.733,
    y1: 3071.632,
    x2: 4332.85,
    y2: 3299.772,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4198.45,
    y1: 3059.208,
    x2: 4356.568,
    y2: 3287.349,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4224.427,
    y1: 3043.396,
    x2: 4382.544,
    y2: 3271.537,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4250.403,
    y1: 3028.714,
    x2: 4398.073,
    y2: 3248.949,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4157.227,
    y1: 3081.796,
    x2: 4113.839,
    y2: 3440.854,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4186.262,
    y1: 3061.514,
    x2: 4142.874,
    y2: 3420.572,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4217.885,
    y1: 3040.055,
    x2: 4174.497,
    y2: 3399.113,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4248.38,
    y1: 3026.502,
    x2: 4204.991,
    y2: 3385.56,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4278.874,
    y1: 3010.691,
    x2: 4235.485,
    y2: 3369.749,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4310.497,
    y1: 2992.62,
    x2: 4267.109,
    y2: 3351.678,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4082.121,
    y1: 3125.843,
    x2: 4240.238,
    y2: 3353.984,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4064.05,
    y1: 3138.267,
    x2: 4222.168,
    y2: 3366.407,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4044.851,
    y1: 3149.561,
    x2: 4202.968,
    y2: 3377.702,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4024.521,
    y1: 3161.984,
    x2: 4182.638,
    y2: 3390.125,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4005.321,
    y1: 3172.149,
    x2: 4163.439,
    y2: 3400.29,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3986.121,
    y1: 3182.314,
    x2: 4144.239,
    y2: 3410.454,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4006.851,
    y1: 3161.443,
    x2: 3972.568,
    y2: 3477.654,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4035.886,
    y1: 3141.161,
    x2: 3992.498,
    y2: 3500.219,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4067.509,
    y1: 3119.702,
    x2: 4024.121,
    y2: 3478.76,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4098.003,
    y1: 3106.149,
    x2: 4054.615,
    y2: 3465.207,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4128.497,
    y1: 3090.337,
    x2: 4085.109,
    y2: 3449.396,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3965.086,
    y1: 3201.796,
    x2: 4123.203,
    y2: 3429.937,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3961.557,
    y1: 3238.784,
    x2: 4102.027,
    y2: 3442.643,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3965.792,
    y1: 3288.761,
    x2: 4074.568,
    y2: 3453.372,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3965.792,
    y1: 3341.278,
    x2: 4046.015,
    y2: 3469.325,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4342.403,
    y1: 2968.902,
    x2: 4299.015,
    y2: 3327.961,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4373.462,
    y1: 2950.267,
    x2: 4330.073,
    y2: 3309.325,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4397.791,
    y1: 2984.102,
    x2: 4365.65,
    y2: 3294.643,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4274.968,
    y1: 3015.726,
    x2: 4402.309,
    y2: 3211.678,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4294.309,
    y1: 3001.326,
    x2: 4396.662,
    y2: 3159.726,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4316.968,
    y1: 2992.432,
    x2: 4394.967,
    y2: 3115.114,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4335.356,
    y1: 2981.491,
    x2: 4397.791,
    y2: 3077.843,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4356.126,
    y1: 2970.938,
    x2: 4396.097,
    y2: 3031.538,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 3656.681,
    y1: 3365.987,
    x2: 3814.798,
    y2: 3594.128,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3672.493,
    y1: 3351.305,
    x2: 3830.61,
    y2: 3579.445,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3700.163,
    y1: 3338.881,
    x2: 3858.281,
    y2: 3567.022,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3727.269,
    y1: 3324.199,
    x2: 3885.386,
    y2: 3552.339,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3750.987,
    y1: 3311.775,
    x2: 3909.104,
    y2: 3539.916,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3776.963,
    y1: 3295.964,
    x2: 3935.081,
    y2: 3524.104,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3802.94,
    y1: 3281.281,
    x2: 3950.61,
    y2: 3501.516,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3709.763,
    y1: 3334.363,
    x2: 3666.375,
    y2: 3693.422,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3738.799,
    y1: 3314.081,
    x2: 3695.41,
    y2: 3673.139,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3770.422,
    y1: 3292.622,
    x2: 3727.034,
    y2: 3651.68,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3800.916,
    y1: 3279.069,
    x2: 3757.528,
    y2: 3638.128,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3831.41,
    y1: 3263.258,
    x2: 3788.022,
    y2: 3622.316,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3863.034,
    y1: 3245.187,
    x2: 3819.645,
    y2: 3604.245,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3634.658,
    y1: 3378.41,
    x2: 3792.775,
    y2: 3606.551,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3616.587,
    y1: 3390.834,
    x2: 3774.704,
    y2: 3618.975,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3597.387,
    y1: 3402.128,
    x2: 3755.504,
    y2: 3630.269,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3577.058,
    y1: 3414.552,
    x2: 3735.175,
    y2: 3642.692,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3557.858,
    y1: 3424.716,
    x2: 3715.975,
    y2: 3652.857,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3538.658,
    y1: 3434.881,
    x2: 3696.775,
    y2: 3663.022,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3559.387,
    y1: 3414.01,
    x2: 3525.105,
    y2: 3730.221,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3588.422,
    y1: 3393.728,
    x2: 3545.034,
    y2: 3752.786,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3620.046,
    y1: 3372.269,
    x2: 3576.658,
    y2: 3731.327,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3650.54,
    y1: 3358.716,
    x2: 3607.152,
    y2: 3717.774,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3681.034,
    y1: 3342.905,
    x2: 3637.646,
    y2: 3701.963,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3517.623,
    y1: 3454.363,
    x2: 3675.74,
    y2: 3682.504,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3514.093,
    y1: 3491.351,
    x2: 3654.563,
    y2: 3695.21,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3518.328,
    y1: 3541.328,
    x2: 3627.105,
    y2: 3705.939,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3518.328,
    y1: 3593.845,
    x2: 3598.552,
    y2: 3721.892,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3894.939,
    y1: 3221.47,
    x2: 3851.551,
    y2: 3580.528,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3925.998,
    y1: 3202.834,
    x2: 3882.61,
    y2: 3561.892,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3950.328,
    y1: 3236.67,
    x2: 3918.186,
    y2: 3547.21,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3827.504,
    y1: 3268.293,
    x2: 3954.845,
    y2: 3464.246,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3846.845,
    y1: 3253.893,
    x2: 3949.198,
    y2: 3412.293,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3869.504,
    y1: 3244.999,
    x2: 3947.504,
    y2: 3367.681,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3887.892,
    y1: 3234.058,
    x2: 3950.328,
    y2: 3330.411,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3908.663,
    y1: 3223.505,
    x2: 3948.633,
    y2: 3284.105,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 3235.862,
    y1: 3604.927,
    x2: 3393.979,
    y2: 3833.067,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3251.674,
    y1: 3590.244,
    x2: 3409.791,
    y2: 3818.385,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3279.344,
    y1: 3577.821,
    x2: 3437.461,
    y2: 3805.962,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3306.45,
    y1: 3563.139,
    x2: 3464.567,
    y2: 3791.279,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3330.167,
    y1: 3550.715,
    x2: 3488.285,
    y2: 3778.856,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3356.144,
    y1: 3534.903,
    x2: 3514.261,
    y2: 3763.044,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3382.12,
    y1: 3520.221,
    x2: 3529.791,
    y2: 3740.456,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3288.944,
    y1: 3573.303,
    x2: 3245.556,
    y2: 3932.361,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3317.979,
    y1: 3553.021,
    x2: 3274.591,
    y2: 3912.079,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3349.603,
    y1: 3531.562,
    x2: 3306.215,
    y2: 3890.62,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3380.097,
    y1: 3518.009,
    x2: 3336.709,
    y2: 3877.067,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3410.591,
    y1: 3502.197,
    x2: 3367.203,
    y2: 3861.256,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3442.214,
    y1: 3484.127,
    x2: 3398.826,
    y2: 3843.185,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3213.838,
    y1: 3617.35,
    x2: 3371.956,
    y2: 3845.491,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3195.768,
    y1: 3629.774,
    x2: 3353.885,
    y2: 3857.914,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3176.568,
    y1: 3641.068,
    x2: 3334.685,
    y2: 3869.209,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3156.238,
    y1: 3653.491,
    x2: 3314.356,
    y2: 3881.632,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3137.038,
    y1: 3663.656,
    x2: 3295.156,
    y2: 3891.797,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3117.838,
    y1: 3673.821,
    x2: 3275.956,
    y2: 3901.961,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3138.568,
    y1: 3652.95,
    x2: 3104.286,
    y2: 3969.161,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3167.603,
    y1: 3632.668,
    x2: 3124.215,
    y2: 3991.726,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3199.227,
    y1: 3611.209,
    x2: 3155.838,
    y2: 3970.267,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3229.721,
    y1: 3597.656,
    x2: 3186.332,
    y2: 3956.714,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3260.215,
    y1: 3581.844,
    x2: 3216.827,
    y2: 3940.902,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3096.803,
    y1: 3693.303,
    x2: 3254.921,
    y2: 3921.444,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3093.274,
    y1: 3730.291,
    x2: 3233.744,
    y2: 3934.15,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3097.509,
    y1: 3780.268,
    x2: 3206.285,
    y2: 3944.879,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3097.509,
    y1: 3832.785,
    x2: 3177.732,
    y2: 3960.832,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3474.12,
    y1: 3460.409,
    x2: 3430.732,
    y2: 3819.467,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3505.179,
    y1: 3441.774,
    x2: 3461.791,
    y2: 3800.832,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3529.508,
    y1: 3475.609,
    x2: 3497.367,
    y2: 3786.15,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3406.685,
    y1: 3507.233,
    x2: 3534.026,
    y2: 3703.185,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3426.026,
    y1: 3492.833,
    x2: 3528.379,
    y2: 3651.232,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3448.685,
    y1: 3483.939,
    x2: 3526.685,
    y2: 3606.621,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3467.073,
    y1: 3472.998,
    x2: 3529.508,
    y2: 3569.35,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3487.844,
    y1: 3462.445,
    x2: 3527.814,
    y2: 3523.045,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 4972.633,
    y1: 2609.939,
    x2: 5130.75,
    y2: 2838.079,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4988.445,
    y1: 2595.256,
    x2: 5146.562,
    y2: 2823.397,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5016.115,
    y1: 2582.833,
    x2: 5174.232,
    y2: 2810.974,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5043.221,
    y1: 2568.151,
    x2: 5201.338,
    y2: 2796.291,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5066.939,
    y1: 2555.727,
    x2: 5225.056,
    y2: 2783.868,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5092.915,
    y1: 2539.915,
    x2: 5251.032,
    y2: 2768.056,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5118.891,
    y1: 2525.233,
    x2: 5266.562,
    y2: 2745.468,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5025.715,
    y1: 2578.315,
    x2: 4982.327,
    y2: 2937.373,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5054.75,
    y1: 2558.033,
    x2: 5011.362,
    y2: 2917.091,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5086.374,
    y1: 2536.574,
    x2: 5042.986,
    y2: 2895.632,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5116.868,
    y1: 2523.021,
    x2: 5073.48,
    y2: 2882.079,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5147.362,
    y1: 2507.21,
    x2: 5103.974,
    y2: 2866.268,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5178.985,
    y1: 2489.139,
    x2: 5135.597,
    y2: 2848.197,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4950.609,
    y1: 2622.362,
    x2: 5108.727,
    y2: 2850.503,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4932.539,
    y1: 2634.786,
    x2: 5090.656,
    y2: 2862.926,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4913.339,
    y1: 2646.08,
    x2: 5071.456,
    y2: 2874.221,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4893.01,
    y1: 2658.503,
    x2: 5051.127,
    y2: 2886.644,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4873.81,
    y1: 2668.668,
    x2: 5031.927,
    y2: 2896.809,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4854.61,
    y1: 2678.833,
    x2: 5012.727,
    y2: 2906.973,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4875.339,
    y1: 2657.962,
    x2: 4841.057,
    y2: 2974.173,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4904.374,
    y1: 2637.68,
    x2: 4860.986,
    y2: 2996.738,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4935.998,
    y1: 2616.221,
    x2: 4892.61,
    y2: 2975.279,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4966.492,
    y1: 2602.668,
    x2: 4923.104,
    y2: 2961.726,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4996.986,
    y1: 2586.856,
    x2: 4953.598,
    y2: 2945.915,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4833.574,
    y1: 2698.315,
    x2: 4991.692,
    y2: 2926.456,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4830.045,
    y1: 2735.303,
    x2: 4970.515,
    y2: 2939.162,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4834.28,
    y1: 2785.28,
    x2: 4943.056,
    y2: 2949.891,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4834.28,
    y1: 2837.797,
    x2: 4914.504,
    y2: 2965.844,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5210.891,
    y1: 2465.421,
    x2: 5167.503,
    y2: 2824.479,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5241.95,
    y1: 2446.786,
    x2: 5198.562,
    y2: 2805.844,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5266.279,
    y1: 2480.621,
    x2: 5234.138,
    y2: 2791.162,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5143.456,
    y1: 2512.245,
    x2: 5270.797,
    y2: 2708.197,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5162.797,
    y1: 2497.845,
    x2: 5265.15,
    y2: 2656.245,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5185.456,
    y1: 2488.951,
    x2: 5263.456,
    y2: 2611.633,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5203.844,
    y1: 2478.01,
    x2: 5266.279,
    y2: 2574.362,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5224.615,
    y1: 2467.457,
    x2: 5264.585,
    y2: 2528.057,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 5411.284,
    y1: 2356.734,
    x2: 5569.401,
    y2: 2584.875,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5427.095,
    y1: 2342.052,
    x2: 5585.213,
    y2: 2570.192,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5454.766,
    y1: 2329.628,
    x2: 5612.883,
    y2: 2557.769,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5481.872,
    y1: 2314.946,
    x2: 5639.989,
    y2: 2543.086,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5505.589,
    y1: 2302.522,
    x2: 5663.707,
    y2: 2530.663,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5531.566,
    y1: 2286.711,
    x2: 5689.683,
    y2: 2514.851,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5557.542,
    y1: 2272.028,
    x2: 5705.212,
    y2: 2492.263,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5464.366,
    y1: 2325.11,
    x2: 5420.978,
    y2: 2684.169,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5493.401,
    y1: 2304.828,
    x2: 5450.013,
    y2: 2663.886,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5525.024,
    y1: 2283.369,
    x2: 5481.636,
    y2: 2642.427,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5555.519,
    y1: 2269.816,
    x2: 5512.13,
    y2: 2628.875,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5586.013,
    y1: 2254.005,
    x2: 5542.624,
    y2: 2613.063,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5617.636,
    y1: 2235.934,
    x2: 5574.248,
    y2: 2594.992,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5389.26,
    y1: 2369.157,
    x2: 5547.377,
    y2: 2597.298,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5371.189,
    y1: 2381.581,
    x2: 5529.307,
    y2: 2609.722,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5351.99,
    y1: 2392.875,
    x2: 5510.107,
    y2: 2621.016,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5331.66,
    y1: 2405.299,
    x2: 5489.777,
    y2: 2633.439,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5312.46,
    y1: 2415.463,
    x2: 5470.578,
    y2: 2643.604,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5293.26,
    y1: 2425.628,
    x2: 5451.378,
    y2: 2653.769,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5313.99,
    y1: 2404.757,
    x2: 5279.707,
    y2: 2720.968,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5343.025,
    y1: 2384.475,
    x2: 5299.637,
    y2: 2743.533,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5374.648,
    y1: 2363.016,
    x2: 5331.26,
    y2: 2722.074,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5405.142,
    y1: 2349.463,
    x2: 5361.754,
    y2: 2708.521,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5435.636,
    y1: 2333.652,
    x2: 5392.248,
    y2: 2692.71,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5272.225,
    y1: 2445.11,
    x2: 5430.342,
    y2: 2673.251,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5268.696,
    y1: 2482.098,
    x2: 5409.166,
    y2: 2685.957,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5272.931,
    y1: 2532.075,
    x2: 5381.707,
    y2: 2696.686,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5272.931,
    y1: 2584.592,
    x2: 5353.154,
    y2: 2712.639,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5649.542,
    y1: 2212.217,
    x2: 5606.154,
    y2: 2571.275,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5680.601,
    y1: 2193.581,
    x2: 5637.212,
    y2: 2552.639,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5704.93,
    y1: 2227.417,
    x2: 5672.789,
    y2: 2537.957,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5582.107,
    y1: 2259.04,
    x2: 5709.448,
    y2: 2454.993,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5601.448,
    y1: 2244.64,
    x2: 5703.801,
    y2: 2403.04,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5624.107,
    y1: 2235.746,
    x2: 5702.106,
    y2: 2358.428,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5642.495,
    y1: 2224.805,
    x2: 5704.93,
    y2: 2321.158,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5663.265,
    y1: 2214.252,
    x2: 5703.236,
    y2: 2274.852,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 5846.368,
    y1: 2107.095,
    x2: 6004.485,
    y2: 2335.236,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5862.18,
    y1: 2092.413,
    x2: 6020.297,
    y2: 2320.554,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5889.85,
    y1: 2079.99,
    x2: 6047.967,
    y2: 2308.13,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5916.956,
    y1: 2065.307,
    x2: 6075.073,
    y2: 2293.448,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5940.674,
    y1: 2052.884,
    x2: 6098.791,
    y2: 2281.024,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5966.65,
    y1: 2037.072,
    x2: 6124.767,
    y2: 2265.213,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5992.626,
    y1: 2022.39,
    x2: 6140.297,
    y2: 2242.624,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5899.45,
    y1: 2075.472,
    x2: 5856.062,
    y2: 2434.53,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5928.485,
    y1: 2055.19,
    x2: 5885.097,
    y2: 2414.248,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5960.109,
    y1: 2033.731,
    x2: 5916.721,
    y2: 2392.789,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5990.603,
    y1: 2020.178,
    x2: 5947.215,
    y2: 2379.236,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6021.097,
    y1: 2004.366,
    x2: 5977.709,
    y2: 2363.424,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6052.72,
    y1: 1986.296,
    x2: 6009.332,
    y2: 2345.354,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5824.344,
    y1: 2119.519,
    x2: 5982.462,
    y2: 2347.66,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5806.274,
    y1: 2131.942,
    x2: 5964.391,
    y2: 2360.083,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5787.074,
    y1: 2143.236,
    x2: 5945.191,
    y2: 2371.377,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5766.744,
    y1: 2155.66,
    x2: 5924.862,
    y2: 2383.801,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5747.545,
    y1: 2165.825,
    x2: 5905.662,
    y2: 2393.965,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5728.345,
    y1: 2175.989,
    x2: 5886.462,
    y2: 2404.13,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5749.074,
    y1: 2155.119,
    x2: 5714.792,
    y2: 2471.33,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5778.109,
    y1: 2134.836,
    x2: 5734.721,
    y2: 2493.895,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5809.733,
    y1: 2113.378,
    x2: 5766.344,
    y2: 2472.436,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5840.227,
    y1: 2099.825,
    x2: 5796.839,
    y2: 2458.883,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5870.721,
    y1: 2084.013,
    x2: 5827.333,
    y2: 2443.071,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5707.309,
    y1: 2195.472,
    x2: 5865.427,
    y2: 2423.612,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5703.78,
    y1: 2232.46,
    x2: 5844.25,
    y2: 2436.318,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5708.015,
    y1: 2282.436,
    x2: 5816.791,
    y2: 2447.048,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5708.015,
    y1: 2334.954,
    x2: 5788.239,
    y2: 2463.001,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6084.626,
    y1: 1962.578,
    x2: 6041.238,
    y2: 2321.636,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6115.685,
    y1: 1943.943,
    x2: 6072.297,
    y2: 2303.001,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6140.014,
    y1: 1977.778,
    x2: 6107.873,
    y2: 2288.319,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6017.191,
    y1: 2009.401,
    x2: 6144.532,
    y2: 2205.354,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6036.532,
    y1: 1995.001,
    x2: 6138.885,
    y2: 2153.401,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6059.191,
    y1: 1986.107,
    x2: 6137.191,
    y2: 2108.789,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6077.579,
    y1: 1975.166,
    x2: 6140.014,
    y2: 2071.519,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6098.35,
    y1: 1964.613,
    x2: 6138.32,
    y2: 2025.213,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 6277.886,
    y1: 1868.156,
    x2: 6436.003,
    y2: 2096.296,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6293.698,
    y1: 1853.473,
    x2: 6451.815,
    y2: 2081.614,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6321.368,
    y1: 1841.05,
    x2: 6479.486,
    y2: 2069.19,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6348.474,
    y1: 1826.367,
    x2: 6506.591,
    y2: 2054.508,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6372.192,
    y1: 1813.944,
    x2: 6530.309,
    y2: 2042.085,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6398.168,
    y1: 1798.132,
    x2: 6556.285,
    y2: 2026.273,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6424.144,
    y1: 1783.45,
    x2: 6571.815,
    y2: 2003.685,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6330.968,
    y1: 1836.532,
    x2: 6287.58,
    y2: 2195.59,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6360.003,
    y1: 1816.25,
    x2: 6316.615,
    y2: 2175.308,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6391.627,
    y1: 1794.791,
    x2: 6348.239,
    y2: 2153.849,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6422.121,
    y1: 1781.238,
    x2: 6378.733,
    y2: 2140.296,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6452.615,
    y1: 1765.426,
    x2: 6409.227,
    y2: 2124.484,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6484.238,
    y1: 1747.356,
    x2: 6440.85,
    y2: 2106.414,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6255.862,
    y1: 1880.579,
    x2: 6413.98,
    y2: 2108.72,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6237.792,
    y1: 1893.003,
    x2: 6395.909,
    y2: 2121.143,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6218.592,
    y1: 1904.297,
    x2: 6376.709,
    y2: 2132.437,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6198.263,
    y1: 1916.72,
    x2: 6356.38,
    y2: 2144.861,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6179.063,
    y1: 1926.885,
    x2: 6337.18,
    y2: 2155.026,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6159.863,
    y1: 1937.05,
    x2: 6317.98,
    y2: 2165.19,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6180.592,
    y1: 1916.179,
    x2: 6146.31,
    y2: 2232.39,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6209.627,
    y1: 1895.897,
    x2: 6166.239,
    y2: 2254.955,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6241.251,
    y1: 1874.438,
    x2: 6197.863,
    y2: 2233.496,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6271.745,
    y1: 1860.885,
    x2: 6228.357,
    y2: 2219.943,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6302.239,
    y1: 1845.073,
    x2: 6258.851,
    y2: 2204.131,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6138.827,
    y1: 1956.532,
    x2: 6296.945,
    y2: 2184.673,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6135.298,
    y1: 1993.52,
    x2: 6275.768,
    y2: 2197.378,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6139.533,
    y1: 2043.496,
    x2: 6248.31,
    y2: 2208.108,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6139.533,
    y1: 2096.014,
    x2: 6219.757,
    y2: 2224.061,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6516.144,
    y1: 1723.638,
    x2: 6472.756,
    y2: 2082.696,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6547.203,
    y1: 1705.003,
    x2: 6503.815,
    y2: 2064.061,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6571.532,
    y1: 1738.838,
    x2: 6539.391,
    y2: 2049.379,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6448.709,
    y1: 1770.462,
    x2: 6576.05,
    y2: 1966.414,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6468.05,
    y1: 1756.062,
    x2: 6570.403,
    y2: 1914.461,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6490.709,
    y1: 1747.168,
    x2: 6568.709,
    y2: 1869.85,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6509.097,
    y1: 1736.226,
    x2: 6571.532,
    y2: 1832.579,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6529.868,
    y1: 1725.674,
    x2: 6569.838,
    y2: 1786.273,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3974.242,3529.417c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3948.265,3155.817s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3955.418,3555.628s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3966.901,3535.911c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4424.876,3278.688c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4398.9,2905.089s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4406.053,3304.9s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4417.535,3285.182c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4845.016,3038.124c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4819.04,2664.524s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4826.193,3064.335s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4834.852,3044.053c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5280.686,2801.889c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5254.71,2428.29s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5261.863,2828.1s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5273.345,2808.383c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5729.344,2540.054c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5703.368,2166.455s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5710.521,2566.266s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5722.003,2546.548c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6159.649,2296.102c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6133.673,1922.502s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6140.826,2322.313s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6152.308,2302.596c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3561.005,3789.009c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3535.029,3415.409s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3542.182,3815.22s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3553.664,3795.503c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7533.182,2496.439c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7507.206,2122.84s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7514.359,2522.651s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7525.841,2502.933c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7982.687,2765.238c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7956.711,2391.639s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7963.864,2791.45s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7975.346,2771.733c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 6668.337,
    y1: 1656.488,
    x2: 6697.702,
    y2: 2009.993,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6697.137,
    y1: 1673.429,
    x2: 6726.502,
    y2: 2026.934,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6722.125,
    y1: 1687.547,
    x2: 6751.49,
    y2: 2041.052,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6748.807,
    y1: 1702.794,
    x2: 6778.172,
    y2: 2056.299,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6775.913,
    y1: 1718.041,
    x2: 6805.278,
    y2: 2071.546,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6803.866,
    y1: 1734.135,
    x2: 6833.231,
    y2: 2087.64,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6832.666,
    y1: 1750.229,
    x2: 6862.031,
    y2: 2103.734,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6862.313,
    y1: 1768.864,
    x2: 6891.678,
    y2: 2122.369,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6891.96,
    y1: 1786.652,
    x2: 6921.325,
    y2: 2140.157,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6921.607,
    y1: 1802.746,
    x2: 6950.972,
    y2: 2156.252,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6949.56,
    y1: 1820.535,
    x2: 6978.925,
    y2: 2174.04,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6973.277,
    y1: 1833.24,
    x2: 7002.642,
    y2: 2186.746,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6999.536,
    y1: 1849.334,
    x2: 7028.901,
    y2: 2202.84,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7030.03,
    y1: 1867.97,
    x2: 7059.395,
    y2: 2221.475,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7056.289,
    y1: 1881.523,
    x2: 7071.818,
    y2: 2153.993,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7081.136,
    y1: 1893.946,
    x2: 6902.407,
    y2: 2129.428,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7060.807,
    y1: 1880.393,
    x2: 6882.078,
    y2: 2115.875,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7037.936,
    y1: 1870.229,
    x2: 6859.207,
    y2: 2105.71,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7016.76,
    y1: 1858.37,
    x2: 6838.031,
    y2: 2093.852,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6997.701,
    y1: 1844.817,
    x2: 6818.972,
    y2: 2080.299,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6977.372,
    y1: 1831.264,
    x2: 6798.643,
    y2: 2066.746,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6954.501,
    y1: 1821.099,
    x2: 6775.772,
    y2: 2056.581,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6933.325,
    y1: 1809.24,
    x2: 6754.596,
    y2: 2044.722,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6912.995,
    y1: 1795.688,
    x2: 6734.266,
    y2: 2031.169,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6892.666,
    y1: 1782.135,
    x2: 6713.937,
    y2: 2017.617,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6869.795,
    y1: 1771.97,
    x2: 6691.066,
    y2: 2007.452,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6848.619,
    y1: 1760.111,
    x2: 6669.89,
    y2: 1995.593,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6829.137,
    y1: 1747.405,
    x2: 6656.76,
    y2: 1965.099,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6808.807,
    y1: 1733.852,
    x2: 6644.902,
    y2: 1939.687,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6785.937,
    y1: 1723.688,
    x2: 6644.055,
    y2: 1904.958,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6764.76,
    y1: 1711.829,
    x2: 6642.361,
    y2: 1864.299,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6742.737,
    y1: 1699.123,
    x2: 6645.749,
    y2: 1817.711,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6722.407,
    y1: 1685.57,
    x2: 6644.055,
    y2: 1784.676,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6699.537,
    y1: 1675.405,
    x2: 6644.055,
    y2: 1749.099,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6678.36,
    y1: 1663.547,
    x2: 6639.819,
    y2: 1710.135,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7186.806,
    y1: 1955.781,
    x2: 7008.077,
    y2: 2191.263,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7166.477,
    y1: 1942.228,
    x2: 6987.748,
    y2: 2177.71,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7143.607,
    y1: 1932.064,
    x2: 6964.878,
    y2: 2167.546,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7122.43,
    y1: 1920.205,
    x2: 6943.701,
    y2: 2155.687,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7103.371,
    y1: 1906.652,
    x2: 6924.642,
    y2: 2142.134,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 7113.889,
    y1: 1913.993,
    x2: 7143.254,
    y2: 2267.498,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7142.689,
    y1: 1930.934,
    x2: 7172.054,
    y2: 2284.439,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7167.677,
    y1: 1945.052,
    x2: 7197.042,
    y2: 2298.557,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7194.359,
    y1: 1960.299,
    x2: 7223.724,
    y2: 2313.804,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7221.465,
    y1: 1975.546,
    x2: 7250.83,
    y2: 2329.051,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7249.418,
    y1: 1991.64,
    x2: 7278.783,
    y2: 2345.145,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7278.218,
    y1: 2007.734,
    x2: 7307.583,
    y2: 2361.239,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7307.865,
    y1: 2026.369,
    x2: 7337.23,
    y2: 2379.875,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7337.512,
    y1: 2044.158,
    x2: 7366.877,
    y2: 2397.663,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7367.159,
    y1: 2060.252,
    x2: 7396.524,
    y2: 2413.757,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7395.112,
    y1: 2078.04,
    x2: 7424.477,
    y2: 2431.545,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7418.83,
    y1: 2090.746,
    x2: 7448.194,
    y2: 2444.251,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7445.088,
    y1: 2106.84,
    x2: 7474.453,
    y2: 2460.345,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7475.582,
    y1: 2125.475,
    x2: 7504.947,
    y2: 2478.98,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7501.841,
    y1: 2139.028,
    x2: 7517.371,
    y2: 2411.498,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7526.688,
    y1: 2151.452,
    x2: 7347.959,
    y2: 2386.933,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7506.359,
    y1: 2137.899,
    x2: 7327.63,
    y2: 2373.38,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7483.488,
    y1: 2127.734,
    x2: 7304.759,
    y2: 2363.216,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7462.312,
    y1: 2115.875,
    x2: 7283.583,
    y2: 2351.357,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7443.253,
    y1: 2102.322,
    x2: 7264.524,
    y2: 2337.804,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7422.924,
    y1: 2088.769,
    x2: 7244.195,
    y2: 2324.251,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7400.053,
    y1: 2078.605,
    x2: 7221.324,
    y2: 2314.086,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7378.877,
    y1: 2066.746,
    x2: 7200.148,
    y2: 2302.228,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7358.547,
    y1: 2053.193,
    x2: 7179.818,
    y2: 2288.675,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7338.218,
    y1: 2039.64,
    x2: 7159.489,
    y2: 2275.122,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7315.347,
    y1: 2029.475,
    x2: 7136.618,
    y2: 2264.957,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7294.171,
    y1: 2017.617,
    x2: 7115.442,
    y2: 2253.098,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7274.689,
    y1: 2004.911,
    x2: 7102.313,
    y2: 2222.604,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7254.359,
    y1: 1991.358,
    x2: 7090.454,
    y2: 2197.193,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7231.489,
    y1: 1981.193,
    x2: 7089.607,
    y2: 2162.463,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7210.312,
    y1: 1969.334,
    x2: 7087.913,
    y2: 2121.805,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7188.289,
    y1: 1956.628,
    x2: 7091.301,
    y2: 2075.216,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7167.959,
    y1: 1943.075,
    x2: 7089.607,
    y2: 2042.181,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7145.089,
    y1: 1932.911,
    x2: 7089.607,
    y2: 2006.605,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7123.912,
    y1: 1921.052,
    x2: 7085.371,
    y2: 1967.64,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7632.359,
    y1: 2213.287,
    x2: 7453.629,
    y2: 2448.769,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7612.029,
    y1: 2199.734,
    x2: 7433.3,
    y2: 2435.216,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7589.159,
    y1: 2189.569,
    x2: 7410.43,
    y2: 2425.051,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7567.982,
    y1: 2177.71,
    x2: 7389.253,
    y2: 2413.192,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7548.923,
    y1: 2164.157,
    x2: 7370.194,
    y2: 2399.639,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7101.748,2243.451c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7075.771,1869.852s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7082.924,2269.663s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7094.407,2249.945c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 7539.198,
    y1: 2157.804,
    x2: 7568.563,
    y2: 2511.31,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7567.998,
    y1: 2174.746,
    x2: 7597.363,
    y2: 2528.251,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7592.986,
    y1: 2188.863,
    x2: 7622.351,
    y2: 2542.368,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7619.668,
    y1: 2204.11,
    x2: 7649.033,
    y2: 2557.615,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7646.774,
    y1: 2219.357,
    x2: 7676.139,
    y2: 2572.862,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7674.727,
    y1: 2235.451,
    x2: 7704.092,
    y2: 2588.957,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7703.527,
    y1: 2251.545,
    x2: 7732.892,
    y2: 2605.051,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7733.174,
    y1: 2270.181,
    x2: 7762.539,
    y2: 2623.686,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7762.821,
    y1: 2287.969,
    x2: 7792.186,
    y2: 2641.474,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7792.468,
    y1: 2304.063,
    x2: 7821.833,
    y2: 2657.568,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7820.421,
    y1: 2321.851,
    x2: 7849.786,
    y2: 2675.356,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7844.139,
    y1: 2334.557,
    x2: 7873.503,
    y2: 2688.062,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7870.397,
    y1: 2350.651,
    x2: 7899.762,
    y2: 2704.156,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7900.891,
    y1: 2369.286,
    x2: 7930.256,
    y2: 2722.792,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7927.15,
    y1: 2382.839,
    x2: 7942.68,
    y2: 2655.309,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7951.997,
    y1: 2395.263,
    x2: 7773.268,
    y2: 2630.745,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7931.668,
    y1: 2381.71,
    x2: 7752.939,
    y2: 2617.192,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7908.797,
    y1: 2371.545,
    x2: 7730.068,
    y2: 2607.027,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7887.621,
    y1: 2359.686,
    x2: 7708.892,
    y2: 2595.168,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7868.562,
    y1: 2346.133,
    x2: 7689.833,
    y2: 2581.615,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7848.233,
    y1: 2332.581,
    x2: 7669.504,
    y2: 2568.062,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7825.362,
    y1: 2322.416,
    x2: 7646.633,
    y2: 2557.898,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7804.186,
    y1: 2310.557,
    x2: 7625.457,
    y2: 2546.039,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7783.856,
    y1: 2297.004,
    x2: 7605.127,
    y2: 2532.486,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7763.527,
    y1: 2283.451,
    x2: 7584.798,
    y2: 2518.933,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7740.656,
    y1: 2273.287,
    x2: 7561.927,
    y2: 2508.768,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7719.48,
    y1: 2261.428,
    x2: 7540.751,
    y2: 2496.91,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7699.998,
    y1: 2248.722,
    x2: 7527.622,
    y2: 2466.416,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7679.668,
    y1: 2235.169,
    x2: 7515.763,
    y2: 2441.004,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7656.798,
    y1: 2225.004,
    x2: 7514.916,
    y2: 2406.275,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7635.621,
    y1: 2213.146,
    x2: 7513.222,
    y2: 2365.616,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7613.598,
    y1: 2200.44,
    x2: 7516.61,
    y2: 2319.028,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7593.268,
    y1: 2186.887,
    x2: 7514.916,
    y2: 2285.992,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7570.398,
    y1: 2176.722,
    x2: 7514.916,
    y2: 2250.416,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7549.222,
    y1: 2164.863,
    x2: 7510.68,
    y2: 2211.451,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8057.668,
    y1: 2457.098,
    x2: 7878.938,
    y2: 2692.58,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8037.338,
    y1: 2443.545,
    x2: 7858.609,
    y2: 2679.027,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8014.468,
    y1: 2433.38,
    x2: 7835.739,
    y2: 2668.862,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7993.291,
    y1: 2421.522,
    x2: 7814.562,
    y2: 2657.003,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7974.232,
    y1: 2407.969,
    x2: 7795.503,
    y2: 2643.451,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 7986.444,
    y1: 2413.616,
    x2: 8015.809,
    y2: 2767.121,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8015.244,
    y1: 2430.557,
    x2: 8044.609,
    y2: 2784.062,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8040.232,
    y1: 2444.674,
    x2: 8069.597,
    y2: 2798.18,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8066.915,
    y1: 2459.921,
    x2: 8096.279,
    y2: 2813.427,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8094.02,
    y1: 2475.169,
    x2: 8123.385,
    y2: 2828.674,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8121.973,
    y1: 2491.263,
    x2: 8151.338,
    y2: 2844.768,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8150.773,
    y1: 2507.357,
    x2: 8180.138,
    y2: 2860.862,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8180.42,
    y1: 2525.992,
    x2: 8209.785,
    y2: 2879.497,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8210.067,
    y1: 2543.78,
    x2: 8239.432,
    y2: 2897.285,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8239.714,
    y1: 2559.874,
    x2: 8269.079,
    y2: 2913.379,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8267.667,
    y1: 2577.662,
    x2: 8297.032,
    y2: 2931.168,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8291.385,
    y1: 2590.368,
    x2: 8320.749,
    y2: 2943.873,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8317.643,
    y1: 2606.462,
    x2: 8347.008,
    y2: 2959.968,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8348.138,
    y1: 2625.098,
    x2: 8377.502,
    y2: 2978.603,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8374.396,
    y1: 2638.651,
    x2: 8389.926,
    y2: 2911.121,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8399.243,
    y1: 2651.074,
    x2: 8220.514,
    y2: 2886.556,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8378.914,
    y1: 2637.521,
    x2: 8200.185,
    y2: 2873.003,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8356.043,
    y1: 2627.356,
    x2: 8177.314,
    y2: 2862.838,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8334.867,
    y1: 2615.498,
    x2: 8156.138,
    y2: 2850.98,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8315.808,
    y1: 2601.945,
    x2: 8137.079,
    y2: 2837.427,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8295.479,
    y1: 2588.392,
    x2: 8116.75,
    y2: 2823.874,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8272.608,
    y1: 2578.227,
    x2: 8093.879,
    y2: 2813.709,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8251.432,
    y1: 2566.368,
    x2: 8072.703,
    y2: 2801.85,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8231.102,
    y1: 2552.815,
    x2: 8052.373,
    y2: 2788.297,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8210.773,
    y1: 2539.263,
    x2: 8032.044,
    y2: 2774.744,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8187.903,
    y1: 2529.098,
    x2: 8009.174,
    y2: 2764.58,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8166.726,
    y1: 2517.239,
    x2: 7987.997,
    y2: 2752.721,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8147.244,
    y1: 2504.533,
    x2: 7974.868,
    y2: 2722.227,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8126.914,
    y1: 2490.98,
    x2: 7963.009,
    y2: 2696.815,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8104.044,
    y1: 2480.816,
    x2: 7962.162,
    y2: 2662.086,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8082.867,
    y1: 2468.957,
    x2: 7960.468,
    y2: 2621.427,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8060.844,
    y1: 2456.251,
    x2: 7963.856,
    y2: 2574.839,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8040.515,
    y1: 2442.698,
    x2: 7962.162,
    y2: 2541.804,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8017.644,
    y1: 2432.533,
    x2: 7962.162,
    y2: 2506.227,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7996.468,
    y1: 2420.675,
    x2: 7957.927,
    y2: 2467.263,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8504.914,
    y1: 2712.909,
    x2: 8326.185,
    y2: 2948.391,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8484.584,
    y1: 2699.356,
    x2: 8305.855,
    y2: 2934.838,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8461.714,
    y1: 2689.192,
    x2: 8282.985,
    y2: 2924.674,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8440.537,
    y1: 2677.333,
    x2: 8261.808,
    y2: 2912.815,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8421.479,
    y1: 2663.78,
    x2: 8242.75,
    y2: 2899.262,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9254.402,3499.355c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9228.426,3125.755s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9235.579,3525.566s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9247.061,3505.849c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9703.907,3768.154c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9677.931,3394.555s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9685.084,3794.366s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9696.566,3774.648c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 8389.557,
    y1: 2659.403,
    x2: 8418.922,
    y2: 3012.909,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8418.357,
    y1: 2676.345,
    x2: 8447.722,
    y2: 3029.85,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8443.345,
    y1: 2690.462,
    x2: 8472.71,
    y2: 3043.967,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8470.027,
    y1: 2705.709,
    x2: 8499.392,
    y2: 3059.214,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8497.133,
    y1: 2720.956,
    x2: 8526.498,
    y2: 3074.461,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8525.086,
    y1: 2737.05,
    x2: 8554.451,
    y2: 3090.556,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8553.886,
    y1: 2753.144,
    x2: 8583.251,
    y2: 3106.65,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8583.533,
    y1: 2771.78,
    x2: 8612.898,
    y2: 3125.285,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8613.18,
    y1: 2789.568,
    x2: 8642.545,
    y2: 3143.073,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8642.827,
    y1: 2805.662,
    x2: 8672.192,
    y2: 3159.167,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8670.78,
    y1: 2823.45,
    x2: 8700.145,
    y2: 3176.955,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8694.498,
    y1: 2836.156,
    x2: 8723.862,
    y2: 3189.661,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8720.756,
    y1: 2852.25,
    x2: 8750.121,
    y2: 3205.755,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8751.25,
    y1: 2870.885,
    x2: 8780.615,
    y2: 3224.391,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8777.509,
    y1: 2884.438,
    x2: 8793.039,
    y2: 3156.908,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8802.356,
    y1: 2896.862,
    x2: 8623.627,
    y2: 3132.344,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8782.027,
    y1: 2883.309,
    x2: 8603.298,
    y2: 3118.791,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8759.156,
    y1: 2873.144,
    x2: 8580.427,
    y2: 3108.626,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8737.98,
    y1: 2861.285,
    x2: 8559.251,
    y2: 3096.767,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8718.921,
    y1: 2847.732,
    x2: 8540.192,
    y2: 3083.214,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8698.592,
    y1: 2834.18,
    x2: 8519.863,
    y2: 3069.661,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8675.721,
    y1: 2824.015,
    x2: 8496.992,
    y2: 3059.497,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8654.545,
    y1: 2812.156,
    x2: 8475.816,
    y2: 3047.638,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8634.215,
    y1: 2798.603,
    x2: 8455.486,
    y2: 3034.085,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8613.886,
    y1: 2785.05,
    x2: 8435.157,
    y2: 3020.532,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8591.015,
    y1: 2774.886,
    x2: 8412.286,
    y2: 3010.367,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8569.839,
    y1: 2763.027,
    x2: 8391.11,
    y2: 2998.509,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8550.357,
    y1: 2750.321,
    x2: 8377.981,
    y2: 2968.015,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8530.027,
    y1: 2736.768,
    x2: 8366.122,
    y2: 2942.603,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8507.157,
    y1: 2726.603,
    x2: 8365.275,
    y2: 2907.874,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8485.98,
    y1: 2714.745,
    x2: 8363.581,
    y2: 2867.215,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8463.957,
    y1: 2702.039,
    x2: 8366.969,
    y2: 2820.627,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8443.627,
    y1: 2688.486,
    x2: 8365.275,
    y2: 2787.591,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8420.757,
    y1: 2678.321,
    x2: 8365.275,
    y2: 2752.015,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8399.58,
    y1: 2666.462,
    x2: 8361.039,
    y2: 2713.05,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8908.027,
    y1: 2958.697,
    x2: 8729.297,
    y2: 3194.179,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8887.697,
    y1: 2945.144,
    x2: 8708.968,
    y2: 3180.626,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8864.827,
    y1: 2934.979,
    x2: 8686.098,
    y2: 3170.461,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8843.65,
    y1: 2923.121,
    x2: 8664.921,
    y2: 3158.602,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8824.591,
    y1: 2909.568,
    x2: 8645.862,
    y2: 3145.05,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 8835.109,
    y1: 2916.909,
    x2: 8864.474,
    y2: 3270.414,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8863.909,
    y1: 2933.85,
    x2: 8893.274,
    y2: 3287.355,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8888.897,
    y1: 2947.968,
    x2: 8918.262,
    y2: 3301.473,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8915.579,
    y1: 2963.215,
    x2: 8944.944,
    y2: 3316.72,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8942.685,
    y1: 2978.462,
    x2: 8972.05,
    y2: 3331.967,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8970.638,
    y1: 2994.556,
    x2: 9000.003,
    y2: 3348.061,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8999.438,
    y1: 3010.65,
    x2: 9028.803,
    y2: 3364.155,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9029.085,
    y1: 3029.285,
    x2: 9058.45,
    y2: 3382.79,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9058.732,
    y1: 3047.073,
    x2: 9088.097,
    y2: 3400.578,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9088.379,
    y1: 3063.167,
    x2: 9117.744,
    y2: 3416.673,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9116.332,
    y1: 3080.956,
    x2: 9145.697,
    y2: 3434.461,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9140.05,
    y1: 3093.661,
    x2: 9169.414,
    y2: 3447.167,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9166.308,
    y1: 3109.755,
    x2: 9195.673,
    y2: 3463.261,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9196.802,
    y1: 3128.391,
    x2: 9226.167,
    y2: 3481.896,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9223.061,
    y1: 3141.944,
    x2: 9238.591,
    y2: 3414.414,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9247.908,
    y1: 3154.367,
    x2: 9069.179,
    y2: 3389.849,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9227.579,
    y1: 3140.814,
    x2: 9048.85,
    y2: 3376.296,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9204.708,
    y1: 3130.65,
    x2: 9025.979,
    y2: 3366.131,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9183.532,
    y1: 3118.791,
    x2: 9004.803,
    y2: 3354.273,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9164.473,
    y1: 3105.238,
    x2: 8985.744,
    y2: 3340.72,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9144.144,
    y1: 3091.685,
    x2: 8965.415,
    y2: 3327.167,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9121.273,
    y1: 3081.52,
    x2: 8942.544,
    y2: 3317.002,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9100.097,
    y1: 3069.661,
    x2: 8921.368,
    y2: 3305.143,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9079.767,
    y1: 3056.109,
    x2: 8901.038,
    y2: 3291.59,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9059.438,
    y1: 3042.556,
    x2: 8880.709,
    y2: 3278.037,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9036.567,
    y1: 3032.391,
    x2: 8857.838,
    y2: 3267.873,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9015.391,
    y1: 3020.532,
    x2: 8836.662,
    y2: 3256.014,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8995.909,
    y1: 3007.826,
    x2: 8823.533,
    y2: 3225.52,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8975.579,
    y1: 2994.273,
    x2: 8811.674,
    y2: 3200.108,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8952.709,
    y1: 2984.109,
    x2: 8810.827,
    y2: 3165.379,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8931.532,
    y1: 2972.25,
    x2: 8809.133,
    y2: 3124.72,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8909.509,
    y1: 2959.544,
    x2: 8812.521,
    y2: 3078.132,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8889.18,
    y1: 2945.991,
    x2: 8810.827,
    y2: 3045.097,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8866.309,
    y1: 2935.826,
    x2: 8810.827,
    y2: 3009.52,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8845.133,
    y1: 2923.968,
    x2: 8806.591,
    y2: 2970.556,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9353.579,
    y1: 3216.202,
    x2: 9174.85,
    y2: 3451.684,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9333.249,
    y1: 3202.649,
    x2: 9154.52,
    y2: 3438.131,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9310.379,
    y1: 3192.485,
    x2: 9131.65,
    y2: 3427.967,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9289.202,
    y1: 3180.626,
    x2: 9110.473,
    y2: 3416.108,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9270.143,
    y1: 3167.073,
    x2: 9091.414,
    y2: 3402.555,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8390.686,2987.826c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8364.71,2614.227s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8371.863,3014.038s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8383.345,2994.32c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8822.968,3246.367c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8796.991,2872.768s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8804.144,3272.579s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8815.627,3252.861c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 9260.418,
    y1: 3160.72,
    x2: 9289.783,
    y2: 3514.225,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9289.218,
    y1: 3177.661,
    x2: 9318.583,
    y2: 3531.166,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9314.206,
    y1: 3191.779,
    x2: 9343.571,
    y2: 3545.284,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9340.888,
    y1: 3207.026,
    x2: 9370.253,
    y2: 3560.531,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9367.994,
    y1: 3222.273,
    x2: 9397.359,
    y2: 3575.778,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9395.947,
    y1: 3238.367,
    x2: 9425.312,
    y2: 3591.872,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9424.747,
    y1: 3254.461,
    x2: 9454.112,
    y2: 3607.966,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9454.394,
    y1: 3273.096,
    x2: 9483.759,
    y2: 3626.602,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9484.041,
    y1: 3290.885,
    x2: 9513.406,
    y2: 3644.39,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9513.688,
    y1: 3306.979,
    x2: 9543.053,
    y2: 3660.484,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9541.641,
    y1: 3324.767,
    x2: 9571.006,
    y2: 3678.272,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9565.359,
    y1: 3337.473,
    x2: 9594.723,
    y2: 3690.978,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9591.617,
    y1: 3353.567,
    x2: 9620.982,
    y2: 3707.072,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9622.111,
    y1: 3372.202,
    x2: 9651.476,
    y2: 3725.707,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9648.37,
    y1: 3385.755,
    x2: 9663.9,
    y2: 3658.225,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9673.217,
    y1: 3398.178,
    x2: 9494.488,
    y2: 3633.66,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9652.888,
    y1: 3384.626,
    x2: 9474.159,
    y2: 3620.107,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9630.017,
    y1: 3374.461,
    x2: 9451.288,
    y2: 3609.943,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9608.841,
    y1: 3362.602,
    x2: 9430.112,
    y2: 3598.084,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9589.782,
    y1: 3349.049,
    x2: 9411.053,
    y2: 3584.531,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9569.453,
    y1: 3335.496,
    x2: 9390.724,
    y2: 3570.978,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9546.582,
    y1: 3325.332,
    x2: 9367.853,
    y2: 3560.813,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9525.406,
    y1: 3313.473,
    x2: 9346.677,
    y2: 3548.955,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9505.076,
    y1: 3299.92,
    x2: 9326.347,
    y2: 3535.402,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9484.747,
    y1: 3286.367,
    x2: 9306.018,
    y2: 3521.849,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9461.876,
    y1: 3276.202,
    x2: 9283.147,
    y2: 3511.684,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9440.7,
    y1: 3264.343,
    x2: 9261.971,
    y2: 3499.825,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9421.218,
    y1: 3251.638,
    x2: 9248.842,
    y2: 3469.331,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9400.888,
    y1: 3238.085,
    x2: 9236.983,
    y2: 3443.92,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9378.018,
    y1: 3227.92,
    x2: 9236.136,
    y2: 3409.19,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9356.841,
    y1: 3216.061,
    x2: 9234.442,
    y2: 3368.531,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9334.818,
    y1: 3203.355,
    x2: 9237.83,
    y2: 3321.943,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9314.489,
    y1: 3189.802,
    x2: 9236.136,
    y2: 3288.908,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9291.618,
    y1: 3179.638,
    x2: 9236.136,
    y2: 3253.332,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9270.442,
    y1: 3167.779,
    x2: 9231.9,
    y2: 3214.367,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9778.888,
    y1: 3460.014,
    x2: 9600.159,
    y2: 3695.495,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9758.558,
    y1: 3446.461,
    x2: 9579.829,
    y2: 3681.943,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9735.688,
    y1: 3436.296,
    x2: 9556.959,
    y2: 3671.778,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9714.511,
    y1: 3424.437,
    x2: 9535.782,
    y2: 3659.919,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9695.452,
    y1: 3410.884,
    x2: 9516.723,
    y2: 3646.366,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 9707.664,
    y1: 3416.531,
    x2: 9737.029,
    y2: 3770.037,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9736.464,
    y1: 3433.472,
    x2: 9765.829,
    y2: 3786.978,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9761.452,
    y1: 3447.59,
    x2: 9790.817,
    y2: 3801.095,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9788.135,
    y1: 3462.837,
    x2: 9817.499,
    y2: 3816.342,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9815.24,
    y1: 3478.084,
    x2: 9844.605,
    y2: 3831.589,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9843.193,
    y1: 3494.178,
    x2: 9872.558,
    y2: 3847.683,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9871.993,
    y1: 3510.272,
    x2: 9901.358,
    y2: 3863.777,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9901.64,
    y1: 3528.908,
    x2: 9931.005,
    y2: 3882.413,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9931.287,
    y1: 3546.696,
    x2: 9960.652,
    y2: 3900.201,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9960.934,
    y1: 3562.79,
    x2: 9990.299,
    y2: 3916.295,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9988.887,
    y1: 3580.578,
    x2: 10018.252,
    y2: 3934.083,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10012.605,
    y1: 3593.284,
    x2: 10041.969,
    y2: 3946.789,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10038.864,
    y1: 3609.378,
    x2: 10068.228,
    y2: 3962.883,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10069.358,
    y1: 3628.013,
    x2: 10098.722,
    y2: 3981.518,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10095.616,
    y1: 3641.566,
    x2: 10111.146,
    y2: 3914.036,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10120.463,
    y1: 3653.99,
    x2: 9941.734,
    y2: 3889.472,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10100.134,
    y1: 3640.437,
    x2: 9921.405,
    y2: 3875.919,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10077.263,
    y1: 3630.272,
    x2: 9898.534,
    y2: 3865.754,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10056.087,
    y1: 3618.413,
    x2: 9877.358,
    y2: 3853.895,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10037.028,
    y1: 3604.86,
    x2: 9858.299,
    y2: 3840.342,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10016.699,
    y1: 3591.307,
    x2: 9837.97,
    y2: 3826.789,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9993.828,
    y1: 3581.143,
    x2: 9815.099,
    y2: 3816.625,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9972.652,
    y1: 3569.284,
    x2: 9793.923,
    y2: 3804.766,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9952.323,
    y1: 3555.731,
    x2: 9773.593,
    y2: 3791.213,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9931.993,
    y1: 3542.178,
    x2: 9753.264,
    y2: 3777.66,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9909.123,
    y1: 3532.013,
    x2: 9730.394,
    y2: 3767.495,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9887.946,
    y1: 3520.155,
    x2: 9709.217,
    y2: 3755.637,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9868.464,
    y1: 3507.449,
    x2: 9696.088,
    y2: 3725.142,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9848.135,
    y1: 3493.896,
    x2: 9684.229,
    y2: 3699.731,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9825.264,
    y1: 3483.731,
    x2: 9683.382,
    y2: 3665.001,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9804.088,
    y1: 3471.872,
    x2: 9681.688,
    y2: 3624.343,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9782.064,
    y1: 3459.167,
    x2: 9685.076,
    y2: 3577.755,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9761.735,
    y1: 3445.614,
    x2: 9683.382,
    y2: 3544.719,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9738.864,
    y1: 3435.449,
    x2: 9683.382,
    y2: 3509.143,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9717.688,
    y1: 3423.59,
    x2: 9679.147,
    y2: 3470.178,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10226.134,
    y1: 3715.825,
    x2: 10047.405,
    y2: 3951.307,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10205.804,
    y1: 3702.272,
    x2: 10027.075,
    y2: 3937.754,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10182.934,
    y1: 3692.107,
    x2: 10004.205,
    y2: 3927.589,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10161.757,
    y1: 3680.248,
    x2: 9983.028,
    y2: 3915.73,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10142.699,
    y1: 3666.696,
    x2: 9963.97,
    y2: 3902.177,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 8005.667,
    y1: 4659.721,
    x2: 8163.784,
    y2: 4887.861,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8021.479,
    y1: 4645.038,
    x2: 8179.596,
    y2: 4873.179,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8049.149,
    y1: 4632.615,
    x2: 8207.267,
    y2: 4860.756,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8076.255,
    y1: 4617.933,
    x2: 8234.373,
    y2: 4846.073,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8099.973,
    y1: 4605.509,
    x2: 8258.09,
    y2: 4833.65,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8125.949,
    y1: 4589.697,
    x2: 8284.067,
    y2: 4817.838,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8151.926,
    y1: 4575.015,
    x2: 8299.596,
    y2: 4795.25,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8058.749,
    y1: 4628.097,
    x2: 8015.361,
    y2: 4987.155,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8087.785,
    y1: 4607.815,
    x2: 8044.396,
    y2: 4966.873,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8119.408,
    y1: 4586.356,
    x2: 8076.02,
    y2: 4945.414,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8149.902,
    y1: 4572.803,
    x2: 8106.514,
    y2: 4931.861,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8180.396,
    y1: 4556.992,
    x2: 8137.008,
    y2: 4916.05,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8212.02,
    y1: 4538.921,
    x2: 8168.632,
    y2: 4897.979,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7983.644,
    y1: 4672.144,
    x2: 8141.761,
    y2: 4900.285,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7965.573,
    y1: 4684.568,
    x2: 8123.69,
    y2: 4912.708,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7946.373,
    y1: 4695.862,
    x2: 8104.49,
    y2: 4924.003,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7926.044,
    y1: 4708.285,
    x2: 8084.161,
    y2: 4936.426,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7906.844,
    y1: 4718.45,
    x2: 8064.961,
    y2: 4946.591,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7887.644,
    y1: 4728.615,
    x2: 8045.761,
    y2: 4956.755,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7908.373,
    y1: 4707.744,
    x2: 7874.091,
    y2: 5023.955,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7937.408,
    y1: 4687.462,
    x2: 7894.02,
    y2: 5046.52,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7969.032,
    y1: 4666.003,
    x2: 7925.644,
    y2: 5025.061,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7999.526,
    y1: 4652.45,
    x2: 7956.138,
    y2: 5011.508,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8030.02,
    y1: 4636.638,
    x2: 7986.632,
    y2: 4995.697,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7866.609,
    y1: 4748.097,
    x2: 8024.726,
    y2: 4976.238,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7863.079,
    y1: 4785.085,
    x2: 8003.55,
    y2: 4988.944,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7867.314,
    y1: 4835.062,
    x2: 7976.091,
    y2: 4999.673,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7867.314,
    y1: 4887.579,
    x2: 7947.538,
    y2: 5015.626,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8243.925,
    y1: 4515.203,
    x2: 8200.537,
    y2: 4874.261,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8274.984,
    y1: 4496.568,
    x2: 8231.596,
    y2: 4855.626,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8299.314,
    y1: 4530.403,
    x2: 8267.173,
    y2: 4840.944,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8176.49,
    y1: 4562.027,
    x2: 8303.831,
    y2: 4757.979,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8195.831,
    y1: 4547.627,
    x2: 8298.184,
    y2: 4706.027,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8218.49,
    y1: 4538.733,
    x2: 8296.49,
    y2: 4661.415,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8236.878,
    y1: 4527.792,
    x2: 8299.314,
    y2: 4624.144,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8257.649,
    y1: 4517.239,
    x2: 8297.62,
    y2: 4577.839,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 7570.583,
    y1: 4905.793,
    x2: 7728.7,
    y2: 5133.934,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7586.395,
    y1: 4891.111,
    x2: 7744.512,
    y2: 5119.251,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7614.065,
    y1: 4878.687,
    x2: 7772.182,
    y2: 5106.828,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7641.171,
    y1: 4864.005,
    x2: 7799.288,
    y2: 5092.146,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7664.888,
    y1: 4851.581,
    x2: 7823.006,
    y2: 5079.722,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7690.865,
    y1: 4835.77,
    x2: 7848.982,
    y2: 5063.91,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7716.841,
    y1: 4821.087,
    x2: 7864.512,
    y2: 5041.322,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7623.665,
    y1: 4874.17,
    x2: 7580.277,
    y2: 5233.228,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7652.7,
    y1: 4853.887,
    x2: 7609.312,
    y2: 5212.945,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7684.324,
    y1: 4832.428,
    x2: 7640.936,
    y2: 5191.487,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7714.818,
    y1: 4818.876,
    x2: 7671.43,
    y2: 5177.934,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7745.312,
    y1: 4803.064,
    x2: 7701.924,
    y2: 5162.122,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7776.935,
    y1: 4784.993,
    x2: 7733.547,
    y2: 5144.051,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7548.559,
    y1: 4918.217,
    x2: 7706.677,
    y2: 5146.357,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7530.489,
    y1: 4930.64,
    x2: 7688.606,
    y2: 5158.781,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7511.289,
    y1: 4941.934,
    x2: 7669.406,
    y2: 5170.075,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7490.959,
    y1: 4954.358,
    x2: 7649.077,
    y2: 5182.498,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7471.759,
    y1: 4964.522,
    x2: 7629.877,
    y2: 5192.663,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7452.56,
    y1: 4974.687,
    x2: 7610.677,
    y2: 5202.828,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7473.289,
    y1: 4953.816,
    x2: 7439.007,
    y2: 5270.028,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7502.324,
    y1: 4933.534,
    x2: 7458.936,
    y2: 5292.592,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7533.948,
    y1: 4912.075,
    x2: 7490.559,
    y2: 5271.133,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7564.442,
    y1: 4898.522,
    x2: 7521.053,
    y2: 5257.581,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7594.936,
    y1: 4882.711,
    x2: 7551.548,
    y2: 5241.769,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7431.524,
    y1: 4994.169,
    x2: 7589.642,
    y2: 5222.31,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7427.995,
    y1: 5031.157,
    x2: 7568.465,
    y2: 5235.016,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7432.23,
    y1: 5081.134,
    x2: 7541.006,
    y2: 5245.745,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7432.23,
    y1: 5133.651,
    x2: 7512.454,
    y2: 5261.698,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7808.841,
    y1: 4761.276,
    x2: 7765.453,
    y2: 5120.334,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7839.9,
    y1: 4742.64,
    x2: 7796.512,
    y2: 5101.699,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7864.229,
    y1: 4776.476,
    x2: 7832.088,
    y2: 5087.016,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7741.406,
    y1: 4808.099,
    x2: 7868.747,
    y2: 5004.052,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7760.747,
    y1: 4793.699,
    x2: 7863.1,
    y2: 4952.099,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7783.406,
    y1: 4784.805,
    x2: 7861.406,
    y2: 4907.487,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7801.794,
    y1: 4773.864,
    x2: 7864.229,
    y2: 4870.217,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7822.565,
    y1: 4763.311,
    x2: 7862.535,
    y2: 4823.911,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 7123.119,
    y1: 5158.36,
    x2: 7281.237,
    y2: 5386.501,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7138.931,
    y1: 5143.678,
    x2: 7297.048,
    y2: 5371.819,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7166.602,
    y1: 5131.254,
    x2: 7324.719,
    y2: 5359.395,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7193.707,
    y1: 5116.572,
    x2: 7351.825,
    y2: 5344.713,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7217.425,
    y1: 5104.149,
    x2: 7375.542,
    y2: 5332.289,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7243.401,
    y1: 5088.337,
    x2: 7401.519,
    y2: 5316.478,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7269.378,
    y1: 5073.654,
    x2: 7417.048,
    y2: 5293.889,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7176.202,
    y1: 5126.737,
    x2: 7132.813,
    y2: 5485.795,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7205.237,
    y1: 5106.454,
    x2: 7161.849,
    y2: 5465.513,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7236.86,
    y1: 5084.996,
    x2: 7193.472,
    y2: 5444.054,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7267.354,
    y1: 5071.443,
    x2: 7223.966,
    y2: 5430.501,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7297.848,
    y1: 5055.631,
    x2: 7254.46,
    y2: 5414.689,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7329.472,
    y1: 5037.56,
    x2: 7286.084,
    y2: 5396.619,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7101.096,
    y1: 5170.784,
    x2: 7259.213,
    y2: 5398.924,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7083.025,
    y1: 5183.207,
    x2: 7241.143,
    y2: 5411.348,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7063.825,
    y1: 5194.501,
    x2: 7221.943,
    y2: 5422.642,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7043.496,
    y1: 5206.925,
    x2: 7201.613,
    y2: 5435.066,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7024.296,
    y1: 5217.089,
    x2: 7182.413,
    y2: 5445.23,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7005.096,
    y1: 5227.254,
    x2: 7163.213,
    y2: 5455.395,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7025.825,
    y1: 5206.384,
    x2: 6991.543,
    y2: 5522.595,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7054.861,
    y1: 5186.101,
    x2: 7011.473,
    y2: 5545.159,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7086.484,
    y1: 5164.643,
    x2: 7043.096,
    y2: 5523.701,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7116.978,
    y1: 5151.09,
    x2: 7073.59,
    y2: 5510.148,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7147.472,
    y1: 5135.278,
    x2: 7104.084,
    y2: 5494.336,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6984.061,
    y1: 5246.736,
    x2: 7142.178,
    y2: 5474.877,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6980.531,
    y1: 5283.725,
    x2: 7121.002,
    y2: 5487.583,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6984.767,
    y1: 5333.701,
    x2: 7093.543,
    y2: 5498.312,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6984.767,
    y1: 5386.219,
    x2: 7064.99,
    y2: 5514.265,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7361.378,
    y1: 5013.843,
    x2: 7317.99,
    y2: 5372.901,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7392.436,
    y1: 4995.208,
    x2: 7349.048,
    y2: 5354.266,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7416.766,
    y1: 5029.043,
    x2: 7384.625,
    y2: 5339.583,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7293.943,
    y1: 5060.666,
    x2: 7421.283,
    y2: 5256.619,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7313.284,
    y1: 5046.266,
    x2: 7415.636,
    y2: 5204.666,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7335.942,
    y1: 5037.372,
    x2: 7413.942,
    y2: 5160.054,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7354.331,
    y1: 5026.431,
    x2: 7416.766,
    y2: 5122.784,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7375.101,
    y1: 5015.878,
    x2: 7415.072,
    y2: 5076.478,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 8439.071,
    y1: 4402.312,
    x2: 8597.189,
    y2: 4630.453,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8454.883,
    y1: 4387.63,
    x2: 8613,
    y2: 4615.77,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8482.553,
    y1: 4375.206,
    x2: 8640.671,
    y2: 4603.347,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8509.659,
    y1: 4360.524,
    x2: 8667.777,
    y2: 4588.665,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8533.377,
    y1: 4348.1,
    x2: 8691.494,
    y2: 4576.241,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8559.353,
    y1: 4332.289,
    x2: 8717.471,
    y2: 4560.429,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8585.33,
    y1: 4317.606,
    x2: 8733,
    y2: 4537.841,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8492.153,
    y1: 4370.689,
    x2: 8448.765,
    y2: 4729.747,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8521.189,
    y1: 4350.406,
    x2: 8477.801,
    y2: 4709.464,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8552.812,
    y1: 4328.947,
    x2: 8509.424,
    y2: 4688.006,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8583.306,
    y1: 4315.395,
    x2: 8539.918,
    y2: 4674.453,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8613.8,
    y1: 4299.583,
    x2: 8570.412,
    y2: 4658.641,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8645.424,
    y1: 4281.512,
    x2: 8602.036,
    y2: 4640.57,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8417.048,
    y1: 4414.735,
    x2: 8575.165,
    y2: 4642.876,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8398.977,
    y1: 4427.159,
    x2: 8557.094,
    y2: 4655.3,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8379.777,
    y1: 4438.453,
    x2: 8537.895,
    y2: 4666.594,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8359.448,
    y1: 4450.877,
    x2: 8517.565,
    y2: 4679.017,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8340.248,
    y1: 4461.041,
    x2: 8498.365,
    y2: 4689.182,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8321.048,
    y1: 4471.206,
    x2: 8479.165,
    y2: 4699.347,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8341.777,
    y1: 4450.335,
    x2: 8307.495,
    y2: 4766.547,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8370.812,
    y1: 4430.053,
    x2: 8327.424,
    y2: 4789.111,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8402.436,
    y1: 4408.594,
    x2: 8359.048,
    y2: 4767.652,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8432.93,
    y1: 4395.041,
    x2: 8389.542,
    y2: 4754.1,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8463.424,
    y1: 4379.23,
    x2: 8420.036,
    y2: 4738.288,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8300.013,
    y1: 4490.688,
    x2: 8458.13,
    y2: 4718.829,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8296.483,
    y1: 4527.676,
    x2: 8436.954,
    y2: 4731.535,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8300.719,
    y1: 4577.653,
    x2: 8409.495,
    y2: 4742.264,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8300.719,
    y1: 4630.17,
    x2: 8380.942,
    y2: 4758.217,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8677.33,
    y1: 4257.795,
    x2: 8633.941,
    y2: 4616.853,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8708.388,
    y1: 4239.159,
    x2: 8665,
    y2: 4598.217,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8732.718,
    y1: 4272.995,
    x2: 8700.577,
    y2: 4583.535,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8609.894,
    y1: 4304.618,
    x2: 8737.235,
    y2: 4500.571,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8629.236,
    y1: 4290.218,
    x2: 8731.588,
    y2: 4448.618,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8651.894,
    y1: 4281.324,
    x2: 8729.894,
    y2: 4404.006,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8670.282,
    y1: 4270.383,
    x2: 8732.718,
    y2: 4366.736,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8691.053,
    y1: 4259.83,
    x2: 8731.024,
    y2: 4320.43,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 8877.722,
    y1: 4149.107,
    x2: 9035.839,
    y2: 4377.248,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8893.534,
    y1: 4134.425,
    x2: 9051.651,
    y2: 4362.566,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8921.204,
    y1: 4122.001,
    x2: 9079.321,
    y2: 4350.142,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8948.31,
    y1: 4107.319,
    x2: 9106.427,
    y2: 4335.46,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8972.027,
    y1: 4094.896,
    x2: 9130.145,
    y2: 4323.036,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8998.004,
    y1: 4079.084,
    x2: 9156.121,
    y2: 4307.224,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9023.98,
    y1: 4064.401,
    x2: 9171.651,
    y2: 4284.636,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8930.804,
    y1: 4117.484,
    x2: 8887.416,
    y2: 4476.542,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8959.839,
    y1: 4097.201,
    x2: 8916.451,
    y2: 4456.259,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8991.463,
    y1: 4075.743,
    x2: 8948.075,
    y2: 4434.801,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9021.957,
    y1: 4062.19,
    x2: 8978.569,
    y2: 4421.248,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9052.451,
    y1: 4046.378,
    x2: 9009.063,
    y2: 4405.436,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9084.074,
    y1: 4028.307,
    x2: 9040.686,
    y2: 4387.366,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8855.698,
    y1: 4161.531,
    x2: 9013.816,
    y2: 4389.671,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8837.628,
    y1: 4173.954,
    x2: 8995.745,
    y2: 4402.095,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8818.428,
    y1: 4185.248,
    x2: 8976.545,
    y2: 4413.389,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8798.098,
    y1: 4197.672,
    x2: 8956.216,
    y2: 4425.812,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8778.898,
    y1: 4207.836,
    x2: 8937.016,
    y2: 4435.977,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8759.699,
    y1: 4218.001,
    x2: 8917.816,
    y2: 4446.142,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8780.428,
    y1: 4197.131,
    x2: 8746.146,
    y2: 4513.342,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8809.463,
    y1: 4176.848,
    x2: 8766.075,
    y2: 4535.906,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8841.087,
    y1: 4155.389,
    x2: 8797.698,
    y2: 4514.448,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8871.581,
    y1: 4141.837,
    x2: 8828.192,
    y2: 4500.895,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8902.075,
    y1: 4126.025,
    x2: 8858.687,
    y2: 4485.083,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8738.663,
    y1: 4237.483,
    x2: 8896.781,
    y2: 4465.624,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8735.134,
    y1: 4274.472,
    x2: 8875.604,
    y2: 4478.33,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8739.369,
    y1: 4324.448,
    x2: 8848.145,
    y2: 4489.059,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8739.369,
    y1: 4376.966,
    x2: 8819.593,
    y2: 4505.012,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9115.98,
    y1: 4004.59,
    x2: 9072.592,
    y2: 4363.648,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9147.039,
    y1: 3985.955,
    x2: 9103.651,
    y2: 4345.013,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9171.368,
    y1: 4019.79,
    x2: 9139.227,
    y2: 4330.33,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9048.545,
    y1: 4051.413,
    x2: 9175.886,
    y2: 4247.366,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9067.886,
    y1: 4037.013,
    x2: 9170.239,
    y2: 4195.413,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9090.545,
    y1: 4028.119,
    x2: 9168.545,
    y2: 4150.801,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9108.933,
    y1: 4017.178,
    x2: 9171.368,
    y2: 4113.531,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9129.704,
    y1: 4006.625,
    x2: 9169.674,
    y2: 4067.225,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7440.68,5321.79c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7414.704,4948.191s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7421.857,5348.002s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7433.339,5328.284c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7891.314,5071.061c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7865.338,4697.462s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7872.491,5097.273s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7883.973,5077.555c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8311.455,4830.497c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8285.478,4456.898s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8292.631,4856.709s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8301.29,4836.426c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8747.124,4594.262c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8721.148,4220.663s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8728.301,4620.474s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8739.783,4600.756c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9195.782,4332.427c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9169.806,3958.828s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9176.959,4358.639s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9188.441,4338.921c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 6719.056,
    y1: 5378.025,
    x2: 6877.173,
    y2: 5606.166,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6734.867,
    y1: 5363.343,
    x2: 6892.985,
    y2: 5591.484,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6762.538,
    y1: 5350.919,
    x2: 6920.655,
    y2: 5579.06,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6789.644,
    y1: 5336.237,
    x2: 6947.761,
    y2: 5564.378,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6813.361,
    y1: 5323.814,
    x2: 6971.479,
    y2: 5551.954,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6839.338,
    y1: 5308.002,
    x2: 6997.455,
    y2: 5536.142,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6865.314,
    y1: 5293.319,
    x2: 7012.985,
    y2: 5513.554,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6772.138,
    y1: 5346.402,
    x2: 6728.75,
    y2: 5705.46,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6801.173,
    y1: 5326.119,
    x2: 6757.785,
    y2: 5685.177,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6832.797,
    y1: 5304.661,
    x2: 6789.408,
    y2: 5663.719,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6863.291,
    y1: 5291.108,
    x2: 6819.903,
    y2: 5650.166,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6893.785,
    y1: 5275.296,
    x2: 6850.397,
    y2: 5634.354,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6925.408,
    y1: 5257.225,
    x2: 6882.02,
    y2: 5616.284,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6697.032,
    y1: 5390.449,
    x2: 6855.15,
    y2: 5618.589,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6678.962,
    y1: 5402.872,
    x2: 6837.079,
    y2: 5631.013,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6659.762,
    y1: 5414.166,
    x2: 6817.879,
    y2: 5642.307,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6639.432,
    y1: 5426.59,
    x2: 6797.55,
    y2: 5654.73,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6620.232,
    y1: 5436.754,
    x2: 6778.35,
    y2: 5664.895,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6601.032,
    y1: 5446.919,
    x2: 6759.15,
    y2: 5675.06,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6621.762,
    y1: 5426.049,
    x2: 6587.479,
    y2: 5742.26,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6650.797,
    y1: 5405.766,
    x2: 6607.409,
    y2: 5764.824,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6682.42,
    y1: 5384.308,
    x2: 6639.032,
    y2: 5743.366,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6712.915,
    y1: 5370.755,
    x2: 6669.526,
    y2: 5729.813,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6743.409,
    y1: 5354.943,
    x2: 6700.02,
    y2: 5714.001,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6579.997,
    y1: 5466.401,
    x2: 6738.114,
    y2: 5694.542,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6576.468,
    y1: 5503.39,
    x2: 6716.938,
    y2: 5707.248,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6580.703,
    y1: 5553.366,
    x2: 6689.479,
    y2: 5717.977,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6580.703,
    y1: 5605.884,
    x2: 6660.926,
    y2: 5733.93,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6957.314,
    y1: 5233.508,
    x2: 6913.926,
    y2: 5592.566,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6988.373,
    y1: 5214.873,
    x2: 6944.985,
    y2: 5573.931,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7012.702,
    y1: 5248.708,
    x2: 6980.561,
    y2: 5559.248,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6889.879,
    y1: 5280.331,
    x2: 7017.22,
    y2: 5476.284,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6909.22,
    y1: 5265.931,
    x2: 7011.573,
    y2: 5424.331,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6931.879,
    y1: 5257.037,
    x2: 7009.879,
    y2: 5379.719,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6950.267,
    y1: 5246.096,
    x2: 7012.702,
    y2: 5342.449,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6971.038,
    y1: 5235.543,
    x2: 7011.008,
    y2: 5296.143,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 6283.971,
    y1: 5624.097,
    x2: 6442.089,
    y2: 5852.238,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6299.783,
    y1: 5609.415,
    x2: 6457.9,
    y2: 5837.556,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6327.454,
    y1: 5596.992,
    x2: 6485.571,
    y2: 5825.132,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6354.559,
    y1: 5582.309,
    x2: 6512.677,
    y2: 5810.45,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6378.277,
    y1: 5569.886,
    x2: 6536.394,
    y2: 5798.027,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6404.253,
    y1: 5554.074,
    x2: 6562.371,
    y2: 5782.215,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6430.23,
    y1: 5539.392,
    x2: 6577.9,
    y2: 5759.627,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6337.054,
    y1: 5592.474,
    x2: 6293.665,
    y2: 5951.532,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6366.089,
    y1: 5572.192,
    x2: 6322.701,
    y2: 5931.25,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6397.712,
    y1: 5550.733,
    x2: 6354.324,
    y2: 5909.791,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6428.206,
    y1: 5537.18,
    x2: 6384.818,
    y2: 5896.238,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6458.7,
    y1: 5521.368,
    x2: 6415.312,
    y2: 5880.426,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6490.324,
    y1: 5503.298,
    x2: 6446.936,
    y2: 5862.356,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6261.948,
    y1: 5636.521,
    x2: 6420.065,
    y2: 5864.662,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6243.877,
    y1: 5648.944,
    x2: 6401.995,
    y2: 5877.085,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6224.677,
    y1: 5660.239,
    x2: 6382.795,
    y2: 5888.379,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6204.348,
    y1: 5672.662,
    x2: 6362.465,
    y2: 5900.803,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6185.148,
    y1: 5682.827,
    x2: 6343.265,
    y2: 5910.967,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6165.948,
    y1: 5692.991,
    x2: 6324.065,
    y2: 5921.132,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6186.677,
    y1: 5672.121,
    x2: 6152.395,
    y2: 5988.332,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6215.713,
    y1: 5651.839,
    x2: 6172.325,
    y2: 6010.897,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6247.336,
    y1: 5630.38,
    x2: 6203.948,
    y2: 5989.438,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6277.83,
    y1: 5616.827,
    x2: 6234.442,
    y2: 5975.885,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6308.324,
    y1: 5601.015,
    x2: 6264.936,
    y2: 5960.073,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6144.913,
    y1: 5712.474,
    x2: 6303.03,
    y2: 5940.614,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6141.383,
    y1: 5749.462,
    x2: 6281.854,
    y2: 5953.32,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6145.619,
    y1: 5799.438,
    x2: 6254.395,
    y2: 5964.05,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6145.619,
    y1: 5851.956,
    x2: 6225.842,
    y2: 5980.003,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6522.23,
    y1: 5479.58,
    x2: 6478.842,
    y2: 5838.638,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6553.288,
    y1: 5460.945,
    x2: 6509.9,
    y2: 5820.003,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6577.618,
    y1: 5494.78,
    x2: 6545.477,
    y2: 5805.321,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6454.795,
    y1: 5526.404,
    x2: 6582.135,
    y2: 5722.356,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6474.136,
    y1: 5512.004,
    x2: 6576.488,
    y2: 5670.403,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6496.794,
    y1: 5503.109,
    x2: 6574.794,
    y2: 5625.792,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6515.183,
    y1: 5492.168,
    x2: 6577.618,
    y2: 5588.521,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6535.953,
    y1: 5481.615,
    x2: 6575.924,
    y2: 5542.215,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6154.069,6040.094c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6128.092,5666.495s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6135.245,6066.306s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6146.727,6046.588c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6604.703,5789.365c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6578.727,5415.766s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6585.879,5815.577s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6597.362,5795.86c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7024.843,5548.801c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6998.867,5175.202s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7006.02,5575.013s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7014.679,5554.731c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 6711.77,
    y1: 1621.032,
    x2: 6869.888,
    y2: 1849.173,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6727.582,
    y1: 1606.35,
    x2: 6885.699,
    y2: 1834.491,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6755.253,
    y1: 1593.927,
    x2: 6913.37,
    y2: 1822.067,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6782.358,
    y1: 1579.244,
    x2: 6940.476,
    y2: 1807.385,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6806.076,
    y1: 1566.821,
    x2: 6964.193,
    y2: 1794.961,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6832.052,
    y1: 1551.009,
    x2: 6990.17,
    y2: 1779.15,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6858.029,
    y1: 1536.327,
    x2: 7005.699,
    y2: 1756.561,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6764.853,
    y1: 1589.409,
    x2: 6721.464,
    y2: 1948.467,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6793.888,
    y1: 1569.127,
    x2: 6750.5,
    y2: 1928.185,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6825.511,
    y1: 1547.668,
    x2: 6782.123,
    y2: 1906.726,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6856.005,
    y1: 1534.115,
    x2: 6812.617,
    y2: 1893.173,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6886.499,
    y1: 1518.303,
    x2: 6843.111,
    y2: 1877.361,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6918.123,
    y1: 1500.233,
    x2: 6874.735,
    y2: 1859.291,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6689.747,
    y1: 1633.456,
    x2: 6847.864,
    y2: 1861.597,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6671.676,
    y1: 1645.879,
    x2: 6829.794,
    y2: 1874.02,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6652.476,
    y1: 1657.173,
    x2: 6810.594,
    y2: 1885.314,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6632.147,
    y1: 1669.597,
    x2: 6790.264,
    y2: 1897.738,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6612.947,
    y1: 1679.762,
    x2: 6771.064,
    y2: 1907.902,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6593.747,
    y1: 1689.926,
    x2: 6751.864,
    y2: 1918.067,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6614.476,
    y1: 1669.056,
    x2: 6580.194,
    y2: 1985.267,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6643.512,
    y1: 1648.773,
    x2: 6600.124,
    y2: 2007.832,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6675.135,
    y1: 1627.315,
    x2: 6631.747,
    y2: 1986.373,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6705.629,
    y1: 1613.762,
    x2: 6662.241,
    y2: 1972.82,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6736.123,
    y1: 1597.95,
    x2: 6692.735,
    y2: 1957.008,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6572.712,
    y1: 1709.409,
    x2: 6730.829,
    y2: 1937.549,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6569.182,
    y1: 1746.397,
    x2: 6709.653,
    y2: 1950.255,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6573.418,
    y1: 1796.373,
    x2: 6682.194,
    y2: 1960.985,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6573.418,
    y1: 1848.891,
    x2: 6653.641,
    y2: 1976.938,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6950.029,
    y1: 1476.515,
    x2: 6906.641,
    y2: 1835.573,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6981.087,
    y1: 1457.88,
    x2: 6937.699,
    y2: 1816.938,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7005.417,
    y1: 1491.715,
    x2: 6973.276,
    y2: 1802.255,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6882.594,
    y1: 1523.338,
    x2: 7009.934,
    y2: 1719.291,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6901.935,
    y1: 1508.938,
    x2: 7004.287,
    y2: 1667.338,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6924.593,
    y1: 1500.044,
    x2: 7002.593,
    y2: 1622.726,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6942.982,
    y1: 1489.103,
    x2: 7005.417,
    y2: 1585.456,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6963.752,
    y1: 1478.55,
    x2: 7003.723,
    y2: 1539.15,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6590.236,2053.09c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6564.26,1679.491s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6571.413,2079.302s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6582.895,2059.584c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6669.466,1984.911c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6643.49,1611.311s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6650.643,2011.122s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6662.125,1991.405c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4011.23,4995.155l-147.388,86.4s-18.635,10.165-37.271-1.694l-1515.103-866.069,32.188-19.106,1482.35,852.987s24.847,13.553,40.659,3.388l123.106-71.153,21.459,15.247Z",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3982.43 4984.99 4011.23 4995.155 4012.359 4984.049 3982.43 4984.99",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5915.979,6264.047l-32.188,19.765-1646.679-964.516s-35.576-19.2,1.694-37.835l172.8-96.565,29.647,17.788-157.553,90.635s-11.012,9.318,1.694,16.941l1630.585,953.786",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4221.865 5303.484 4221.865 5289.366 4242.477 5299.248 4221.865 5303.484",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4441.253 5190.825 4441.253 5202.684 4423.464 5202.966 4423.464 5190.543 4441.253 5190.825",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5915.979,6252.188l-32.188,19.765-1646.679-964.516s-35.576-19.2,1.694-37.835l172.8-96.565,29.647,17.788-157.553,90.635s-11.012,9.318,1.694,16.941l1630.585,953.786",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4455.088,5222.496c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4429.111,4848.896s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4436.264,5248.707s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4447.747,5228.99c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4809.481,1719.969c-25.658,2.865-61.659,.198-85.566,8.2-23.906,8.003-39.795,26.781-58.722,55.853-18.927,29.073,4.218,49.237,64.852,32.705,60.633-16.532,111.995-51.23,126.389-69.355,21.761-27.403-13.682-31.119-46.953-27.403Z",
    fill: "#3ba4f2",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3820.175,2080.138c-25.658,2.865-61.659,.198-85.566,8.2-23.906,8.003-39.795,26.781-58.722,55.853-18.927,29.073,4.218,49.237,64.852,32.705,60.633-16.532,111.995-51.23,126.389-69.355,21.761-27.403-13.682-31.119-46.953-27.403Z",
    fill: "#3ba4f2",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5026.384,1352.798c-25.658,2.865-61.659,.198-85.566,8.2-23.906,8.003-39.795,26.781-58.722,55.853-18.927,29.073,4.218,49.237,64.852,32.705,60.633-16.532,111.995-51.23,126.389-69.355,21.761-27.403-13.682-31.119-46.953-27.403Z",
    fill: "#3ba4f2",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9077.695,3508.643c-2.111-48.224,3.063-134.443,4.299-148.236,1.235-13.793-5.057-25.692-23.792-44.798-18.734-19.107-75.707-17.658-98.402-30.57-25.746-14.648-38.259-11.578-61.186-9.764-20.208,1.597-36.569,25.392-36.569,25.392,0,0,26.883-21.996,56.564-7.348,29.681,14.648,61.549,37.684,90.515,39.859,28.965,2.174,61.03,8.999,60.389,30.675-.042,1.396-.217,2.701-.492,3.933,2.429,12.327-3.326,32.717-4.346,45.819-1.314,16.867-3.914,65.932,0,121.299,3.563,50.415,11.592,85.547,13.409,95.257,9.335,10.489,15.064,1.306,15.064,1.306,0,0-13.341-74.599-15.452-122.822Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9009.123,3333.177c-28.966-2.175-60.834-25.21-90.515-39.859-29.681-14.648-56.564,7.348-56.564,7.348,0,0,15.403-6.157,47.073-.719,31.67,5.437,44.267,29.673,84.925,41.072,40.659,11.4,59.968,10.254,70.631,18.42,2.38,1.823,3.649,4.804,4.346,8.345,.276-1.232,.45-2.537,.492-3.933,.641-21.676-31.424-28.501-60.389-30.675Z",
    fill: "#478e19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8883.079,3280.695s38.766-5.208,46.256,1.16c7.49,6.369,1.357,17.88,7.608,18.812,6.251,.931,4.185-11.365,7.765-13.496,3.581-2.133,9.949,8.058,23.961,10.606,14.01,2.547,5.25,7.523,8.927,17.832,3.676,10.31,6.496,4.459,8.974-2.547,2.479-7.006,1.719-10.827,18.021-8.916,16.301,1.911,25.608,2.547,24.776,8.916-.831,6.368-1.468,15.937,4.263,14.975,5.733-.963,4.261-14.975,7.863-13.701,3.602,1.274,11.615,3.904,19.523,13.701,7.908,9.796,16.982,22.957,20.843,33.986,3.04-16.161-5.588-35.905-27.398-51.955-23.311-13.359-53.879-16.279-76.865-21.78-21.719-5.198-32.966-14.825-51.597-14.825-31.358,0-42.92,7.233-42.92,7.233Z",
    fill: "#6ebc3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9062.887,3399.983s14.536-6.999,27.524,22.213c11.607,26.105,9.553,76.833-2.865,122.688-12.42,45.854-16.439,57.419-18.035,75.995-1.772,20.63,4.366,37.943,7.913,49.517-9.507,6.798-14.019-.844-14.019-.844,0,0-14.449-30.838-6.617-65.334,7.831-34.496,23.116-47.847,28.847-96.579,5.731-48.733,1.911-75.45-8.598-86.929-10.509-11.48-16.499-13.391-16.499-13.391l2.349-7.335Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9146.009,3362.757s-14.536-7-27.524,22.214c-11.607,26.105-9.553,76.832,2.867,122.686,12.418,45.854,16.437,57.42,18.034,75.997,1.772,20.63-4.366,37.942-7.913,49.515,9.508,6.799,14.02-.843,14.02-.843,0,0,14.448-30.839,6.618-65.335-7.832-34.495-23.116-47.846-28.849-96.579-5.731-48.732-1.909-75.45,8.598-86.929,10.509-11.48,16.499-13.39,16.499-13.39l-2.349-7.336Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8883.355,3462.692c46.688-8.588,66.216-11.351,106.854-36.591,27.001-16.768,57.356-24.664,79.302-24.715-11.636-16.247-35.415-27.015-65.061-30.086-40.373-4.183-69.731,15.273-69.731,15.273,0,0,10.364,1.516,18.202,1.671,10.182,.201,17.771,1.254,23.156,2.67,21.983,5.779,3.845,12.565,.585,11.903-11.258-2.289-26.088-9.981-47.103-8.201-9.115,.774-33.714,15.377-33.714,15.377,0,0,10.01,.14,20.731,3.394,11.61,3.523,34.344-.947,31.029,4.145-6.38,9.796-38.901,4.068-48.644,1.796-25.985-6.058-51.117,17.951-51.117,17.951,9.479-2.587,17.34-1.742,28.427-1.573,8.131,.125,19.422-4.347,24.047-1.733,6.83,3.861-10.91,10.716-26.302,11.435-15.391,.718-29.327,3.111-40.385,17.535-12.85,16.764-21.795,45.129-21.795,45.129,17.179-17.608,45.903-40.667,71.519-45.381Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8887.383,3495.002c11.4-16.215,24.897-19.354,27.64-16.829,5.489,5.051-29.148,36.608-29.148,36.608,0,0,26.942,6.435,49.826,1.827,13.124-2.644,20.268-22.241,27.139-33.24,5.109-8.178,9.527-11.997,14.205-12.216,3.662-.171,11.836,3.975,2.162,14.503-4.982,5.42-21.291,27.349-21.291,27.349,0,0,28.028,5.235,54.382-14.28,9.99-7.398,8.169-28.4,10.56-40.078,1.665-8.129,4.701-18.016,9.822-9.621,.793,1.301,4.264,10.707-.368,20.05-5.401,10.894-6.127,16.932-7.233,26.725,47.081-28.587,54.108-53.74,52.021-74.744-.716-7.215-3.381-13.791-7.591-19.669-21.946,.051-52.301,7.948-79.302,24.715-40.638,25.24-60.166,28.003-106.854,36.591-25.616,4.714-54.34,27.773-71.519,45.381,0,0,16.037,5.384,35.491,4.001,9.726-.692,30.451-3.406,40.057-17.072Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8826.052,3494.529s30.033-22.225,52.513-28.312c22.481-6.087,61.316-7.397,75.816-15.077,14.501-7.681,50.411-31.493,71.049-37.133,41.078-11.224,51.201-2.847,51.201-2.847,0,0-.727-9.207-3.388-10.391-10.242-4.555-29.275-3.706-49.24,3.298-19.966,7.006-26.994,12.807-46.578,26.123-17.181,11.683-29.128,19.255-46.553,21.748-17.426,2.493-41.909,2.719-56.62,8.245-15.685,5.89-42.389,25.231-48.2,34.347Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8948.089,3459.386c-5.247,1.601-12.041,16.001-16.862,21.145-4.819,5.144-13.195,12.806-16.666,17.713-3.469,4.908,4.383,9.838,13.453,.572,9.071-9.266,12.307-15.242,19.461-24.267,7.155-9.027,10.798-18.268,.613-15.163Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8999.19,3440.344c-5.008,2.997-3.442,18.481-5.235,27.457-1.793,8.977-6.309,15.236-8.68,23.132-2.372,7.894,15.771,4.917,16.916-9.539,1.146-14.456,.331-21.589,1.885-29.368,1.555-7.78-.508-14.299-4.886-11.68Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8883.82,3469.576c-5.059,1.399-21.422,7.546-29.127,12.48-7.707,4.933-14.576,11.9-16.489,15.252-1.915,3.351,15.935,1.371,23.023-2.718,7.087-4.088,16.417-13.444,26.304-18.68,9.888-5.236,2.806-8.133-3.71-6.334Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9045.017,3418.561c-5.734,1.57-3.221,11-1.16,20.623,2.061,9.622,1.154,19.772,3.069,22.644,1.916,2.871,15.668-4.082,9.852-19.874-6.558-17.805-6.665-24.79-11.761-23.394Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8873.025,3451.155c-6.282,.345-15.196,1.974-21.965,5.997-6.769,4.022-9.385,9.348-8.766,11.62,.62,2.272,12.854-4.594,18.385-7.189,5.53-2.595,12.114-3.172,19.555-5.88,4.979-1.814-2.469-4.807-7.21-4.547Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8920.074,3425.163c-6.153-1.012-21.21-4.112-26.116-4.468-4.907-.358-10.487,.033-14.231,3.884-3.744,3.851,3.724,3.228,8.595,3.453,4.871,.227,15.068-2.839,22.274-.28,7.205,2.559,14.081,2.873,19.5,1.995,5.419-.877,5.658-5.185,.631-4.945-5.026,.24-6.322,1.073-10.652,.361Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8929.475,3397.418c-4.012,.611-8.761,2.108-10.628,4.599-1.867,2.489,7.66,2.152,12.136,.93,4.477-1.221,15.129-1.583,21.281,1.264,6.153,2.847,16.113,7.201,22.263,6.936,6.153-.265,10.461-.026,8.163-2.228-2.299-2.202-7.685-3.278-13.334-4.282-5.649-1.003-15.052-5.227-20.621-6.535-5.569-1.309-14.598-1.394-19.26-.684Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8984.525,3377.297c-5.69,.329-17.642,1.704-20.106,4.074-2.466,2.37,9.248,3.823,14.235,2.4,4.987-1.423,16.835-1.546,23.634,.56,6.799,2.104,16.565,3.679,20.717,1.274,4.153-2.406-5.71-5.371-10.354-5.801-4.644-.43-21.859-2.869-28.127-2.506Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9325.902,3425.159c-46.688-8.589-66.215-11.351-106.854-36.591-27-16.768-57.355-24.664-79.302-24.716,11.637-16.248,35.415-27.015,65.063-30.086,40.372-4.183,69.73,15.272,69.73,15.272,0,0-10.364,1.517-18.203,1.672-10.18,.201-17.77,1.254-23.156,2.669-21.982,5.779-3.843,12.566-.585,11.904,11.259-2.289,26.089-9.982,47.104-8.201,9.115,.773,33.712,15.377,33.712,15.377,0,0-10.008,.141-20.73,3.394-11.61,3.523-34.344-.947-31.028,4.146,6.38,9.794,38.901,4.067,48.644,1.795,25.985-6.057,51.117,17.952,51.117,17.952-9.478-2.589-17.341-1.743-28.428-1.573-8.13,.124-19.42-4.347-24.046-1.733-6.831,3.861,10.91,10.716,26.301,11.433,15.392,.718,29.329,3.112,40.385,17.536,12.85,16.764,21.796,45.129,21.796,45.129-17.18-17.606-45.903-40.667-71.519-45.379Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9321.873,3457.469c-11.398-16.215-24.895-19.354-27.64-16.829-5.488,5.049,29.15,36.607,29.15,36.607,0,0-26.942,6.435-49.826,1.827-13.125-2.643-20.268-22.241-27.14-33.239-5.108-8.18-9.526-11.997-14.205-12.217-3.662-.172-11.836,3.975-2.161,14.503,4.981,5.42,21.291,27.348,21.291,27.348,0,0-28.029,5.235-54.381-14.28-9.991-7.398-8.17-28.399-10.561-40.077-1.664-8.129-4.701-18.016-9.822-9.622-.793,1.3-4.264,10.706,.368,20.049,5.401,10.895,6.127,16.934,7.233,26.727-47.082-28.587-54.107-53.74-52.021-74.745,.716-7.215,3.38-13.791,7.59-19.669,21.946,.052,52.302,7.948,79.302,24.716,40.639,25.24,60.166,28.001,106.854,36.591,25.616,4.712,54.339,27.773,71.519,45.379,0,0-16.037,5.385-35.49,4.001-9.727-.691-30.452-3.406-40.058-17.071Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9383.205,3456.996s-30.033-22.226-52.513-28.313c-22.48-6.087-61.316-7.398-75.817-15.078-14.5-7.681-50.41-31.493-71.049-37.132-41.078-11.224-51.201-2.848-51.201-2.848,0,0,.727-9.208,3.389-10.391,10.242-4.555,29.274-3.707,49.24,3.299,19.965,7.006,26.992,12.806,46.577,26.121,17.182,11.684,29.127,19.255,46.554,21.748,17.426,2.495,41.907,2.72,56.619,8.246,15.686,5.891,42.39,25.232,48.2,34.348Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9261.168,3421.853c5.247,1.599,12.04,16.001,16.86,21.145,4.821,5.144,13.197,12.805,16.666,17.713,3.469,4.908-4.383,9.837-13.452,.571-9.07-9.265-12.307-15.242-19.461-24.268-7.156-9.025-10.798-18.267-.612-15.161Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9210.067,3402.81c5.009,2.997,3.443,18.48,5.235,27.458,1.793,8.977,6.308,15.235,8.68,23.131,2.37,7.895-15.771,4.917-16.918-9.539-1.146-14.455-.33-21.588-1.885-29.369-1.554-7.779,.509-14.299,4.886-11.68Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9325.437,3432.042c5.061,1.398,21.422,7.545,29.129,12.478,7.707,4.933,14.574,11.9,16.489,15.252,1.913,3.351-15.936,1.372-23.024-2.717-7.088-4.089-16.416-13.444-26.304-18.679-9.887-5.236-2.805-8.135,3.71-6.334Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9164.24,3381.026c5.733,1.571,3.222,11.002,1.16,20.625-2.061,9.621-1.154,19.772-3.07,22.643-1.914,2.872-15.667-4.081-9.852-19.874,6.559-17.803,6.667-24.79,11.762-23.394Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9336.232,3413.62c6.281,.346,15.195,1.975,21.966,5.997,6.769,4.022,9.385,9.348,8.764,11.621-.62,2.273-12.853-4.594-18.383-7.189-5.532-2.595-12.115-3.171-19.555-5.881-4.98-1.814,2.469-4.807,7.209-4.547Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9289.183,3387.63c6.153-1.012,21.21-4.112,26.116-4.47,4.908-.358,10.488,.034,14.231,3.886,3.743,3.851-3.725,3.227-8.596,3.453-4.87,.226-15.067-2.841-22.273-.281-7.206,2.559-14.082,2.874-19.5,1.996-5.419-.877-5.657-5.187-.63-4.945,5.026,.24,6.322,1.074,10.651,.362Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9279.783,3359.884c4.011,.61,8.761,2.109,10.628,4.599,1.865,2.49-7.661,2.152-12.137,.931-4.476-1.222-15.128-1.584-21.281,1.264-6.152,2.847-16.111,7.2-22.263,6.936-6.152-.266-10.46-.027-8.161-2.229,2.298-2.202,7.685-3.277,13.334-4.281,5.649-1.005,15.051-5.227,20.62-6.536s14.597-1.393,19.261-.684Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9224.732,3339.763c5.689,.329,17.642,1.704,20.105,4.075,2.466,2.369-9.247,3.821-14.234,2.398-4.987-1.421-16.837-1.544-23.636,.56-6.797,2.106-16.564,3.68-20.717,1.275-4.153-2.406,5.709-5.371,10.355-5.801,4.643-.429,21.858-2.868,28.126-2.506Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9162.307,3442.166s-40.806,66.511-32.958,97.536c7.848,31.025,27.704,53.447,32.958,88.599,3.425,22.912,.501,35.024,.501,35.024,0,0-6.433,7.627-12.096,.624,.979-9.315,1.698-25.376-1.805-42.593-4.431-21.782-14.084-45.607-21.526-62.095-13.324-29.524-8.425-54.461,6.738-84.411,7.127-14.079,28.187-32.684,28.187-32.684Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9288.392,3569.98c-16.45-7.392-49.489-34.356-56.216-49.31-6.728-14.954-13.505-31.619-24.426-45.644-10.919-14.024-24.794-27.211-41.826-30.071-6.317-1.06-12.342-1.909-17.435-2.561,4.597-2.363,9.823-4.148,15.787-6.885,26.571-12.189,64.663-3.636,83.85,6.989,19.187,10.625,27.146,17.549,27.146,17.549,0,0-13.927-.872-20.939-2.198-11.29-2.136-21.563-.522-22.807,2.83-2.488,6.704,2.825,6.605,14.16,4.883,11.336-1.722,28.932,1.063,37.091,6.35,9.476,6.142,30.528,33.996,30.528,33.996,0,0-21.71-1.155-44.392-4.08-10.183-1.314-6.703,7.368-3.528,8.351,14.839,4.594,41.993-3.95,49.521,5.147,8.085,9.769,12.629,36.491,12.629,36.491,0,0-28.187,.432-39.575-1.952-11.387-2.383-18.862,3.733-9.686,7.018,9.177,3.286,39.967,3.703,49.161,7.633,6.186,7.167,8.132,24.109,7.967,33.568-.166,9.459-2.315,24.166-4.096,34.087-7.662-22.963-26.463-54.798-42.913-62.19Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9265.301,3580.932c-2.827-10.925-10.625-5.499-9.498,1.13,1.127,6.629,7.428,37.981,7.428,37.981,0,0-28.42-11.534-48.387-28.111-13.193-10.954-3.962-34.706-2.756-50.405,1.207-15.7-4.586-18.116-8.629-13.704-3.282,3.583-1.098,15.359-2.303,25.738-2.007,17.299-1.661,32.706-1.661,32.706,0,0-18.482-9.119-30.772-26.223-9.246-12.869,.188-47.702,2.183-52.698,3.739-9.357-2.887-9.571-5.199-4.93-2.019,4.055-4.439,12.346-6.668,20.645-3.248,12.085-3.032,20.111-3.898,25.493-13.571-12.63-33.749-45.107-26.438-75.7,4.631-19.378,11.057-25.977,19.783-30.46,5.093,.652,11.118,1.5,17.435,2.561,17.032,2.861,30.907,16.048,41.826,30.071,10.922,14.025,17.698,30.69,24.426,45.644,6.727,14.954,39.766,41.917,56.216,49.31,16.451,7.392,35.251,39.227,42.913,62.19-19.633-1.114-40.775-.113-56.995-9.648-6.809-17.255-6.183-30.667-9.009-41.59Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9265.301,3580.932c-2.827-10.925-10.625-5.499-9.498,1.13,1.127,6.629,7.428,37.981,7.428,37.981,0,0-28.42-11.534-48.387-28.111-13.193-10.954-3.962-34.706-2.756-50.405,1.207-15.7-4.586-18.116-8.629-13.704-3.282,3.583-1.098,15.359-2.303,25.738-2.007,17.299-1.661,32.706-1.661,32.706,0,0-18.482-9.119-30.772-26.223-9.246-12.869,.188-47.702,2.183-52.698,3.739-9.357-2.887-9.571-5.199-4.93-2.019,4.055-4.439,12.346-6.668,20.645-3.248,12.085-3.032,20.111-3.898,25.493-13.571-12.63-33.749-45.107-26.438-75.7,4.631-19.378,11.057-25.977,19.783-30.46,5.093,.652,11.118,1.5,17.435,2.561,17.032,2.861,30.907,16.048,41.826,30.071,10.922,14.025,17.698,30.69,24.426,45.644,6.727,14.954,39.766,41.917,56.216,49.31,16.451,7.392,35.251,39.227,42.913,62.19-19.633-1.114-40.775-.113-56.995-9.648-6.809-17.255-6.183-30.667-9.009-41.59Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9144.588,3444.733s22.102-2.078,40.017,11.486c12.586,9.529,23.144,18.809,33.481,46.498,7.519,20.138,29.64,42.348,39.707,50.26,10.066,7.911,24.354,14.002,41.041,28.553,16.686,14.55,29.175,42.036,29.175,42.036,0,0-11.218-33.305-27.018-46.444-15.8-13.139-34.209-18.83-49.8-36.429-15.589-17.599-23.032-37.751-28.343-49.446-5.309-11.694-21.461-32.6-34.411-40.375-12.952-7.776-35.79-17.143-43.85-6.14Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9266.577,3520.047c9.684,.764,22.601-1.012,32.282,1.792,9.683,2.804,9.22,9.182,10.937,16.157,1.717,6.976-15.013,5.46-27.266,4.637-12.254-.824-22.356-11.056-27.597-16.229-5.24-5.174,2.222-7.099,11.643-6.357Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9239.404,3474.596c12.776-1.251,25.165-1.511,36.205,2.631,11.04,4.142,14.836,12.218,14.063,16.226-.772,4.007-11.391-1.455-25.528-1.959-14.137-.502-23.434,4.467-29.831-1.809-6.397-6.276-6.61-13.944,5.091-15.088Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9201.246,3436.78c14.139-.668,24.42,2.234,31.456,6.566,7.035,4.331-2.123,7.13-10.734,6.519-8.61-.609-21.016-1.103-30.381-6.931-9.367-5.828,.831-5.739,9.659-6.155Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9315.481,3571.431c8.069,1.493,12.21,15.094,12.573,21.226,.362,6.131-5.778,1.36-12.64-7.648-6.861-9.008-9.485-15.345,.067-13.578Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9287.617,3583.949c7.667,2.674,21.259,15.069,22.071,24.955,.811,9.888-15.088,9.199-23.002-2.538-7.913-11.735-15.139-28.021,.931-22.417Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9234.97,3550.719c5.127,4.525,10.755,28.734,10.798,39.124,.043,10.391-19.703,1.319-25.586-9.877-5.884-11.197,2.817-39.809,14.788-29.248Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9196.028,3487.395c7.665,7.027,.679,19.441-.716,31.792-1.396,12.349,1.248,32.733-1.474,38.527-2.722,5.792-19.241-3.027-21.724-17.625-2.482-14.599,2.943-36.838,6.922-44.783,3.979-7.944,11.382-13.054,16.993-7.911Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9159.4,3455.81c10.269-2.465,13.335,8.143,6.426,21.653-6.909,13.511-9.769,30.955-13.991,34.581-4.224,3.625-14.434-7.989-12.075-25.457,2.359-17.467,8.622-28.134,19.639-30.777Z",
    fill: "#2ca348",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9079.746,3474.514s40.807,66.512,32.958,97.536c-7.848,31.025-27.704,53.447-32.958,88.599-3.425,22.913-.501,35.025-.501,35.025,0,0,6.434,7.627,12.096,.623-.979-9.315-1.698-25.376,1.806-42.592,4.431-21.783,14.084-45.607,21.525-62.096,13.324-29.523,8.425-54.46-6.739-84.41-7.127-14.079-28.187-32.685-28.187-32.685Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8972.372,3620.396c14.979-10.045,43.031-42.166,47.156-58.035,4.126-15.87,8.015-33.436,16.429-49.093,8.415-15.656,19.881-30.982,36.194-36.657,6.05-2.104,11.848-3.951,16.76-5.448-4.929-1.557-10.38-2.442-16.719-4.14-28.238-7.563-64.358,7.253-81.492,20.943-17.134,13.692-23.821,21.851-23.821,21.851,0,0,13.584-3.193,20.275-5.676,10.773-3.999,21.169-4.129,22.959-1.033,3.577,6.192-1.678,6.984-13.142,7.187-11.463,.202-28.343,5.897-35.502,12.477-8.312,7.643-24.398,38.633-24.398,38.633,0,0,21.209-4.778,43.08-11.465,9.818-3.003,7.843,6.142,4.878,7.643-13.859,7.017-42.061,3.145-47.958,13.374-6.333,10.986-6.333,38.092-6.333,38.092,0,0,27.861-4.3,38.687-8.557,10.827-4.258,19.223,.518,10.726,5.295-8.496,4.776-38.781,10.349-47.187,15.764-4.897,8.103-3.975,25.131-2.226,34.429,1.75,9.297,6.333,23.436,9.752,32.918,3.704-23.922,16.903-58.458,31.881-68.504Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8996.971,3627.323c.956-11.245,9.554-7.204,9.554-.48s-.956,38.691-.956,38.691c0,0,26.084-16.135,42.989-35.824,11.172-13.01-1.911-34.878-5.731-50.154-3.822-15.275,1.485-18.628,6.209-14.955,3.836,2.981,3.657,14.957,6.585,24.986,4.878,16.719,7.12,31.965,7.12,31.965,0,0,16.692-12.087,25.94-31.01,6.958-14.237-8.181-46.996-10.986-51.586-5.254-8.598,1.242-9.92,4.299-5.733,2.67,3.66,6.447,11.428,10.035,19.236,5.226,11.37,6.36,19.317,8.116,24.478,11.262-14.726,25.71-50.125,13.375-79.06-7.815-18.329-15.255-23.756-24.609-26.714-4.912,1.497-10.71,3.344-16.76,5.448-16.312,5.675-27.779,21.002-36.194,36.657-8.415,15.657-12.303,33.223-16.429,49.093-4.125,15.869-32.177,47.99-47.156,58.035-14.978,10.046-28.177,44.582-31.881,68.504,19.168-4.39,40.179-6.947,54.571-19.066,3.82-18.152,.954-31.268,1.909-42.51Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8996.971,3627.323c.956-11.245,9.554-7.204,9.554-.48s-.956,38.691-.956,38.691c0,0,26.084-16.135,42.989-35.824,11.172-13.01-1.911-34.878-5.731-50.154-3.822-15.275,1.485-18.628,6.209-14.955,3.836,2.981,3.657,14.957,6.585,24.986,4.878,16.719,7.12,31.965,7.12,31.965,0,0,16.692-12.087,25.94-31.01,6.958-14.237-8.181-46.996-10.986-51.586-5.254-8.598,1.242-9.92,4.299-5.733,2.67,3.66,6.447,11.428,10.035,19.236,5.226,11.37,6.36,19.317,8.116,24.478,11.262-14.726,25.71-50.125,13.375-79.06-7.815-18.329-15.255-23.756-24.609-26.714-4.912,1.497-10.71,3.344-16.76,5.448-16.312,5.675-27.779,21.002-36.194,36.657-8.415,15.657-12.303,33.223-16.429,49.093-4.125,15.869-32.177,47.99-47.156,58.035-14.978,10.046-28.177,44.582-31.881,68.504,19.168-4.39,40.179-6.947,54.571-19.066,3.82-18.152,.954-31.268,1.909-42.51Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9093.147,3472.817s-22.139,1.656-37.527,18.031c-10.81,11.503-19.663,22.421-25.213,51.452-4.036,21.113-22.123,46.717-30.72,56.204-8.598,9.486-21.662,17.887-35.674,35.029-14.01,17.142-21.716,46.332-21.716,46.332,0,0,5.477-34.714,18.851-50.316,13.374-15.601,30.57-24.297,42.988-44.26,12.42-19.964,16.38-41.078,19.654-53.498,3.275-12.419,15.694-35.737,27.157-45.573,11.463-9.835,32.409-22.898,42.2-13.402Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8985.508,3567.513c-9.419,2.376-22.45,2.792-31.525,7.179-9.076,4.386-7.55,10.596-8.074,17.761-.523,7.165,15.717,2.865,27.658,0,11.942-2.867,20.186-14.647,24.485-20.625,4.299-5.979-3.38-6.626-12.544-4.316Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9004.678,3518.15c-12.805,.909-25.062,2.729-35.251,8.663-10.19,5.933-12.579,14.531-11.145,18.353,1.433,3.821,10.986-3.344,24.838-6.209,13.852-2.867,23.852,.474,29.107-6.786,5.254-7.258,4.178-14.853-7.548-14.021Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9035.957,3474.473c-14.052,1.712-23.701,6.297-29.91,11.745-6.209,5.45,3.289,6.674,11.675,4.629,8.386-2.045,20.534-4.61,28.789-11.926,8.256-7.315-1.781-5.518-10.554-4.449Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8945.908,3626.367c-7.704,2.823-9.507,16.928-8.836,23.032,.671,6.104,5.924,.373,11.178-9.658,5.255-10.031,6.781-16.718-2.342-13.374Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8975.477,3634.038c-7.111,3.921-18.434,18.419-17.576,28.301,.857,9.883,16.418,6.539,22.251-6.357,5.834-12.898,10.228-30.163-4.675-21.944Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9021.809,3592.454c-4.297,5.32-5.787,30.129-4.087,40.38,1.698,10.251,19.644-2.001,23.569-14.025,3.923-12.025-9.451-38.774-19.482-26.354Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9049.585,3523.497c-6.378,8.213,2.589,19.28,6.034,31.223,3.447,11.941,4.258,32.481,7.913,37.734,3.655,5.254,18.462-6.21,18.462-21.018s-9.076-35.824-14.331-42.988c-5.254-7.165-13.409-10.962-18.078-4.951Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9080.4,3486.218c-10.537-.708-11.781,10.263-2.706,22.425,9.076,12.162,14.819,28.88,19.59,31.745,4.77,2.866,12.891-10.296,7.637-27.12-5.255-16.824-13.216-26.29-24.522-27.05Z",
    fill: "#2ca348",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9456.286,3690.461c-2.111-48.224,3.063-134.443,4.299-148.236,1.235-13.793-5.057-25.692-23.792-44.798-18.734-19.107-75.707-17.658-98.402-30.57-25.746-14.648-38.259-11.578-61.186-9.764-20.208,1.597-36.569,25.392-36.569,25.392,0,0,26.883-21.996,56.564-7.348,29.681,14.648,61.549,37.684,90.515,39.859,28.965,2.174,61.03,8.999,60.389,30.675-.042,1.396-.217,2.701-.492,3.933,2.429,12.327-3.326,32.717-4.346,45.819-1.314,16.867-3.914,65.932,0,121.299,3.563,50.415,11.592,85.547,13.409,95.257,9.335,10.489,15.064,1.306,15.064,1.306,0,0-13.341-74.599-15.452-122.822Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9387.714,3514.995c-28.966-2.175-60.834-25.21-90.515-39.859-29.681-14.648-56.564,7.348-56.564,7.348,0,0,15.403-6.157,47.073-.719,31.67,5.437,44.267,29.673,84.925,41.072,40.659,11.4,59.968,10.254,70.631,18.42,2.38,1.823,3.649,4.804,4.346,8.345,.276-1.232,.45-2.537,.492-3.933,.641-21.676-31.424-28.501-60.389-30.675Z",
    fill: "#478e19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9261.669,3462.512s38.766-5.208,46.256,1.16c7.49,6.369,1.357,17.88,7.608,18.812,6.251,.931,4.185-11.365,7.765-13.496,3.581-2.133,9.949,8.058,23.961,10.606,14.01,2.547,5.25,7.523,8.927,17.832,3.676,10.31,6.496,4.459,8.974-2.547,2.479-7.006,1.719-10.827,18.021-8.916,16.301,1.911,25.608,2.547,24.776,8.916-.831,6.368-1.468,15.937,4.263,14.975,5.733-.963,4.261-14.975,7.863-13.701,3.602,1.274,11.615,3.904,19.523,13.701,7.908,9.796,16.982,22.957,20.843,33.986,3.04-16.161-5.588-35.905-27.398-51.955-23.311-13.359-53.879-16.279-76.865-21.78-21.719-5.198-32.966-14.825-51.597-14.825-31.358,0-42.92,7.233-42.92,7.233Z",
    fill: "#6ebc3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9441.477,3581.801s14.536-6.999,27.524,22.213c11.607,26.105,9.553,76.833-2.865,122.688-12.42,45.854-16.439,57.419-18.035,75.995-1.772,20.63,4.366,37.943,7.913,49.517-9.507,6.798-14.019-.844-14.019-.844,0,0-14.449-30.838-6.617-65.334,7.831-34.496,23.116-47.847,28.847-96.579,5.731-48.733,1.911-75.45-8.598-86.929-10.509-11.48-16.499-13.391-16.499-13.391l2.349-7.335Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9524.6,3544.575s-14.536-7-27.524,22.214c-11.607,26.105-9.553,76.832,2.867,122.686,12.418,45.854,16.437,57.42,18.034,75.997,1.772,20.63-4.366,37.942-7.913,49.515,9.508,6.799,14.02-.843,14.02-.843,0,0,14.448-30.839,6.618-65.335-7.832-34.495-23.116-47.846-28.849-96.579-5.731-48.732-1.909-75.45,8.598-86.929,10.509-11.48,16.499-13.39,16.499-13.39l-2.349-7.336Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9261.946,3644.509c46.688-8.588,66.216-11.351,106.854-36.591,27.001-16.768,57.356-24.664,79.302-24.715-11.636-16.247-35.415-27.015-65.061-30.086-40.373-4.183-69.731,15.273-69.731,15.273,0,0,10.364,1.516,18.202,1.671,10.182,.201,17.771,1.254,23.156,2.67,21.983,5.779,3.845,12.565,.585,11.903-11.258-2.289-26.088-9.981-47.103-8.201-9.115,.774-33.714,15.377-33.714,15.377,0,0,10.01,.14,20.731,3.394,11.61,3.523,34.344-.947,31.029,4.145-6.38,9.796-38.901,4.068-48.644,1.796-25.985-6.058-51.117,17.951-51.117,17.951,9.479-2.587,17.34-1.742,28.427-1.573,8.131,.125,19.422-4.347,24.047-1.733,6.83,3.861-10.91,10.716-26.302,11.435-15.391,.718-29.327,3.111-40.385,17.535-12.85,16.764-21.795,45.129-21.795,45.129,17.179-17.608,45.903-40.667,71.519-45.381Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9265.974,3676.819c11.4-16.215,24.897-19.354,27.64-16.829,5.489,5.051-29.148,36.608-29.148,36.608,0,0,26.942,6.435,49.826,1.827,13.124-2.644,20.268-22.241,27.139-33.24,5.109-8.178,9.527-11.997,14.205-12.216,3.662-.171,11.836,3.975,2.162,14.503-4.982,5.42-21.291,27.349-21.291,27.349,0,0,28.028,5.235,54.382-14.28,9.99-7.398,8.169-28.4,10.56-40.078,1.665-8.129,4.701-18.016,9.822-9.621,.793,1.301,4.264,10.707-.368,20.05-5.401,10.894-6.127,16.932-7.233,26.725,47.081-28.587,54.108-53.74,52.021-74.744-.716-7.215-3.381-13.791-7.591-19.669-21.946,.051-52.301,7.948-79.302,24.715-40.638,25.24-60.166,28.003-106.854,36.591-25.616,4.714-54.34,27.773-71.519,45.381,0,0,16.037,5.384,35.491,4.001,9.726-.692,30.451-3.406,40.057-17.072Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9204.643,3676.346s30.033-22.225,52.513-28.312c22.481-6.087,61.316-7.397,75.816-15.077,14.501-7.681,50.411-31.493,71.049-37.133,41.078-11.224,51.201-2.847,51.201-2.847,0,0-.727-9.207-3.388-10.391-10.242-4.555-29.275-3.706-49.24,3.298-19.966,7.006-26.994,12.807-46.578,26.123-17.181,11.683-29.128,19.255-46.553,21.748-17.426,2.493-41.909,2.719-56.62,8.245-15.685,5.89-42.389,25.231-48.2,34.347Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9326.68,3641.203c-5.247,1.601-12.041,16.001-16.862,21.145-4.819,5.144-13.195,12.806-16.666,17.713-3.469,4.908,4.383,9.838,13.453,.572,9.071-9.266,12.307-15.242,19.461-24.267,7.155-9.027,10.798-18.268,.613-15.163Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9377.781,3622.161c-5.008,2.997-3.442,18.481-5.235,27.457-1.793,8.977-6.309,15.236-8.68,23.132-2.372,7.894,15.771,4.917,16.916-9.539,1.146-14.456,.331-21.589,1.885-29.368,1.555-7.78-.508-14.299-4.886-11.68Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9262.41,3651.393c-5.059,1.399-21.422,7.546-29.127,12.48-7.707,4.933-14.576,11.9-16.489,15.252-1.915,3.351,15.935,1.371,23.023-2.718,7.087-4.088,16.417-13.444,26.304-18.68,9.888-5.236,2.806-8.133-3.71-6.334Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9423.607,3600.378c-5.734,1.57-3.221,11-1.16,20.623,2.061,9.622,1.154,19.772,3.069,22.644,1.916,2.871,15.668-4.082,9.852-19.874-6.558-17.805-6.665-24.79-11.761-23.394Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9251.615,3632.972c-6.282,.345-15.196,1.974-21.965,5.997-6.769,4.022-9.385,9.348-8.766,11.62,.62,2.272,12.854-4.594,18.385-7.189,5.53-2.595,12.114-3.172,19.555-5.88,4.979-1.814-2.469-4.807-7.21-4.547Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9298.664,3606.98c-6.153-1.012-21.21-4.112-26.116-4.468-4.907-.358-10.487,.033-14.231,3.884-3.744,3.851,3.724,3.228,8.595,3.453,4.871,.227,15.068-2.839,22.274-.28,7.205,2.559,14.081,2.873,19.5,1.995,5.419-.877,5.658-5.185,.631-4.945-5.026,.24-6.322,1.073-10.652,.361Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9308.065,3579.235c-4.012,.611-8.761,2.108-10.628,4.599-1.867,2.489,7.66,2.152,12.136,.93,4.477-1.221,15.129-1.583,21.281,1.264,6.153,2.847,16.113,7.201,22.263,6.936,6.153-.265,10.461-.026,8.163-2.228-2.299-2.202-7.685-3.278-13.334-4.282-5.649-1.003-15.052-5.227-20.621-6.535-5.569-1.309-14.598-1.394-19.26-.684Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9363.115,3559.114c-5.69,.329-17.642,1.704-20.106,4.074-2.466,2.37,9.248,3.823,14.235,2.4,4.987-1.423,16.835-1.546,23.634,.56,6.799,2.104,16.565,3.679,20.717,1.274,4.153-2.406-5.71-5.371-10.354-5.801-4.644-.43-21.859-2.869-28.127-2.506Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9704.492,3606.976c-46.688-8.589-66.215-11.351-106.854-36.591-27-16.768-57.355-24.664-79.302-24.716,11.637-16.248,35.415-27.015,65.063-30.086,40.372-4.183,69.73,15.272,69.73,15.272,0,0-10.364,1.517-18.203,1.672-10.18,.201-17.77,1.254-23.156,2.669-21.982,5.779-3.843,12.566-.585,11.904,11.259-2.289,26.089-9.982,47.104-8.201,9.115,.773,33.712,15.377,33.712,15.377,0,0-10.008,.141-20.73,3.394-11.61,3.523-34.344-.947-31.028,4.146,6.38,9.794,38.901,4.067,48.644,1.795,25.985-6.057,51.117,17.952,51.117,17.952-9.478-2.589-17.341-1.743-28.428-1.573-8.13,.124-19.42-4.347-24.046-1.733-6.831,3.861,10.91,10.716,26.301,11.433,15.392,.718,29.329,3.112,40.385,17.536,12.85,16.764,21.796,45.129,21.796,45.129-17.18-17.606-45.903-40.667-71.519-45.379Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9700.463,3639.286c-11.398-16.215-24.895-19.354-27.64-16.829-5.488,5.049,29.15,36.607,29.15,36.607,0,0-26.942,6.435-49.826,1.827-13.125-2.643-20.268-22.241-27.14-33.239-5.108-8.18-9.526-11.997-14.205-12.217-3.662-.172-11.836,3.975-2.161,14.503,4.981,5.42,21.291,27.348,21.291,27.348,0,0-28.029,5.235-54.381-14.28-9.991-7.398-8.17-28.399-10.561-40.077-1.664-8.129-4.701-18.016-9.822-9.622-.793,1.3-4.264,10.706,.368,20.049,5.401,10.895,6.127,16.934,7.233,26.727-47.082-28.587-54.107-53.74-52.021-74.745,.716-7.215,3.38-13.791,7.59-19.669,21.946,.052,52.302,7.948,79.302,24.716,40.639,25.24,60.166,28.001,106.854,36.591,25.616,4.712,54.339,27.773,71.519,45.379,0,0-16.037,5.385-35.49,4.001-9.727-.691-30.452-3.406-40.058-17.071Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9761.795,3638.813s-30.033-22.226-52.513-28.313c-22.48-6.087-61.316-7.398-75.817-15.078-14.5-7.681-50.41-31.493-71.049-37.132-41.078-11.224-51.201-2.848-51.201-2.848,0,0,.727-9.208,3.389-10.391,10.242-4.555,29.274-3.707,49.24,3.299,19.965,7.006,26.992,12.806,46.577,26.121,17.182,11.684,29.127,19.255,46.554,21.748,17.426,2.495,41.907,2.72,56.619,8.246,15.686,5.891,42.39,25.232,48.2,34.348Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9639.759,3603.67c5.247,1.599,12.04,16.001,16.86,21.145,4.821,5.144,13.197,12.805,16.666,17.713,3.469,4.908-4.383,9.837-13.452,.571-9.07-9.265-12.307-15.242-19.461-24.268-7.156-9.025-10.798-18.267-.612-15.161Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9588.657,3584.627c5.009,2.997,3.443,18.48,5.235,27.458,1.793,8.977,6.308,15.235,8.68,23.131,2.37,7.895-15.771,4.917-16.918-9.539-1.146-14.455-.33-21.588-1.885-29.369-1.554-7.779,.509-14.299,4.886-11.68Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9704.027,3613.86c5.061,1.398,21.422,7.545,29.129,12.478,7.707,4.933,14.574,11.9,16.489,15.252,1.913,3.351-15.936,1.372-23.024-2.717-7.088-4.089-16.416-13.444-26.304-18.679-9.887-5.236-2.805-8.135,3.71-6.334Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9542.831,3562.843c5.733,1.571,3.222,11.002,1.16,20.625-2.061,9.621-1.154,19.772-3.07,22.643-1.914,2.872-15.667-4.081-9.852-19.874,6.559-17.803,6.667-24.79,11.762-23.394Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9714.822,3595.438c6.281,.346,15.195,1.975,21.966,5.997,6.769,4.022,9.385,9.348,8.764,11.621-.62,2.273-12.853-4.594-18.383-7.189-5.532-2.595-12.115-3.171-19.555-5.881-4.98-1.814,2.469-4.807,7.209-4.547Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9667.774,3569.447c6.153-1.012,21.21-4.112,26.116-4.47,4.908-.358,10.488,.034,14.231,3.886,3.743,3.851-3.725,3.227-8.596,3.453-4.87,.226-15.067-2.841-22.273-.281-7.206,2.559-14.082,2.874-19.5,1.996-5.419-.877-5.657-5.187-.63-4.945,5.026,.24,6.322,1.074,10.651,.362Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9658.373,3541.701c4.011,.61,8.761,2.109,10.628,4.599,1.865,2.49-7.661,2.152-12.137,.931-4.476-1.222-15.128-1.584-21.281,1.264-6.152,2.847-16.111,7.2-22.263,6.936-6.152-.266-10.46-.027-8.161-2.229,2.298-2.202,7.685-3.277,13.334-4.281,5.649-1.005,15.051-5.227,20.62-6.536s14.597-1.393,19.261-.684Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9603.323,3521.58c5.689,.329,17.642,1.704,20.105,4.075,2.466,2.369-9.247,3.821-14.234,2.398-4.987-1.421-16.837-1.544-23.636,.56-6.797,2.106-16.564,3.68-20.717,1.275-4.153-2.406,5.709-5.371,10.355-5.801,4.643-.429,21.858-2.868,28.126-2.506Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9540.897,3623.983s-40.806,66.511-32.958,97.536c7.848,31.025,27.704,53.447,32.958,88.599,3.425,22.912,.501,35.024,.501,35.024,0,0-6.433,7.627-12.096,.624,.979-9.315,1.698-25.376-1.805-42.593-4.431-21.782-14.084-45.607-21.526-62.095-13.324-29.524-8.425-54.461,6.738-84.411,7.127-14.079,28.187-32.684,28.187-32.684Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9666.982,3751.797c-16.45-7.392-49.489-34.356-56.216-49.31-6.728-14.954-13.505-31.619-24.426-45.644-10.919-14.024-24.794-27.211-41.826-30.071-6.317-1.06-12.342-1.909-17.435-2.561,4.597-2.363,9.823-4.148,15.787-6.885,26.571-12.189,64.663-3.636,83.85,6.989,19.187,10.625,27.146,17.549,27.146,17.549,0,0-13.927-.872-20.939-2.198-11.29-2.136-21.563-.522-22.807,2.83-2.488,6.704,2.825,6.605,14.16,4.883,11.336-1.722,28.932,1.063,37.091,6.35,9.476,6.142,30.528,33.996,30.528,33.996,0,0-21.71-1.155-44.392-4.08-10.183-1.314-6.703,7.368-3.528,8.351,14.839,4.594,41.993-3.95,49.521,5.147,8.085,9.769,12.629,36.491,12.629,36.491,0,0-28.187,.432-39.575-1.952-11.387-2.383-18.862,3.733-9.686,7.018,9.177,3.286,39.967,3.703,49.161,7.633,6.186,7.167,8.132,24.109,7.967,33.568-.166,9.459-2.315,24.166-4.096,34.087-7.662-22.963-26.463-54.798-42.913-62.19Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9643.892,3762.749c-2.827-10.925-10.625-5.499-9.498,1.13,1.127,6.629,7.428,37.981,7.428,37.981,0,0-28.42-11.534-48.387-28.111-13.193-10.954-3.962-34.706-2.756-50.405,1.207-15.7-4.586-18.116-8.629-13.704-3.282,3.583-1.098,15.359-2.303,25.738-2.007,17.299-1.661,32.706-1.661,32.706,0,0-18.482-9.119-30.772-26.223-9.246-12.869,.188-47.702,2.183-52.698,3.739-9.357-2.887-9.571-5.199-4.93-2.019,4.055-4.439,12.346-6.668,20.645-3.248,12.085-3.032,20.111-3.898,25.493-13.571-12.63-33.749-45.107-26.438-75.7,4.631-19.378,11.057-25.977,19.783-30.46,5.093,.652,11.118,1.5,17.435,2.561,17.032,2.861,30.907,16.048,41.826,30.071,10.922,14.025,17.698,30.69,24.426,45.644,6.727,14.954,39.766,41.917,56.216,49.31,16.451,7.392,35.251,39.227,42.913,62.19-19.633-1.114-40.775-.113-56.995-9.648-6.809-17.255-6.183-30.667-9.009-41.59Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9643.892,3762.749c-2.827-10.925-10.625-5.499-9.498,1.13,1.127,6.629,7.428,37.981,7.428,37.981,0,0-28.42-11.534-48.387-28.111-13.193-10.954-3.962-34.706-2.756-50.405,1.207-15.7-4.586-18.116-8.629-13.704-3.282,3.583-1.098,15.359-2.303,25.738-2.007,17.299-1.661,32.706-1.661,32.706,0,0-18.482-9.119-30.772-26.223-9.246-12.869,.188-47.702,2.183-52.698,3.739-9.357-2.887-9.571-5.199-4.93-2.019,4.055-4.439,12.346-6.668,20.645-3.248,12.085-3.032,20.111-3.898,25.493-13.571-12.63-33.749-45.107-26.438-75.7,4.631-19.378,11.057-25.977,19.783-30.46,5.093,.652,11.118,1.5,17.435,2.561,17.032,2.861,30.907,16.048,41.826,30.071,10.922,14.025,17.698,30.69,24.426,45.644,6.727,14.954,39.766,41.917,56.216,49.31,16.451,7.392,35.251,39.227,42.913,62.19-19.633-1.114-40.775-.113-56.995-9.648-6.809-17.255-6.183-30.667-9.009-41.59Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9523.179,3626.55s22.102-2.078,40.017,11.486c12.586,9.529,23.144,18.809,33.481,46.498,7.519,20.138,29.64,42.348,39.707,50.26,10.066,7.911,24.354,14.002,41.041,28.553,16.686,14.55,29.175,42.036,29.175,42.036,0,0-11.218-33.305-27.018-46.444-15.8-13.139-34.209-18.83-49.8-36.429-15.589-17.599-23.032-37.751-28.343-49.446-5.309-11.694-21.461-32.6-34.411-40.375-12.952-7.776-35.79-17.143-43.85-6.14Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9645.168,3701.865c9.684,.764,22.601-1.012,32.282,1.792,9.683,2.804,9.22,9.182,10.937,16.157,1.717,6.976-15.013,5.46-27.266,4.637-12.254-.824-22.356-11.056-27.597-16.229-5.24-5.174,2.222-7.099,11.643-6.357Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9617.995,3656.413c12.776-1.251,25.165-1.511,36.205,2.631,11.04,4.142,14.836,12.218,14.063,16.226-.772,4.007-11.391-1.455-25.528-1.959-14.137-.502-23.434,4.467-29.831-1.809-6.397-6.276-6.61-13.944,5.091-15.088Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9579.837,3618.597c14.139-.668,24.42,2.234,31.456,6.566,7.035,4.331-2.123,7.13-10.734,6.519-8.61-.609-21.016-1.103-30.381-6.931-9.367-5.828,.831-5.739,9.659-6.155Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9694.071,3753.248c8.069,1.493,12.21,15.094,12.573,21.226,.362,6.131-5.778,1.36-12.64-7.648-6.861-9.008-9.485-15.345,.067-13.578Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9666.207,3765.766c7.667,2.674,21.259,15.069,22.071,24.955,.811,9.888-15.088,9.199-23.002-2.538-7.913-11.735-15.139-28.021,.931-22.417Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9613.561,3732.536c5.127,4.525,10.755,28.734,10.798,39.124,.043,10.391-19.703,1.319-25.586-9.877-5.884-11.197,2.817-39.809,14.788-29.248Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9574.618,3669.212c7.665,7.027,.679,19.441-.716,31.792-1.396,12.349,1.248,32.733-1.474,38.527-2.722,5.792-19.241-3.027-21.724-17.625-2.482-14.599,2.943-36.838,6.922-44.783,3.979-7.944,11.382-13.054,16.993-7.911Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9537.991,3637.627c10.269-2.465,13.335,8.143,6.426,21.653-6.909,13.511-9.769,30.955-13.991,34.581-4.224,3.625-14.434-7.989-12.075-25.457,2.359-17.467,8.622-28.134,19.639-30.777Z",
    fill: "#2ca348",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9458.337,3656.331s40.807,66.512,32.958,97.536c-7.848,31.025-27.704,53.447-32.958,88.599-3.425,22.913-.501,35.025-.501,35.025,0,0,6.434,7.627,12.096,.623-.979-9.315-1.698-25.376,1.806-42.592,4.431-21.783,14.084-45.607,21.525-62.096,13.324-29.523,8.425-54.46-6.739-84.41-7.127-14.079-28.187-32.685-28.187-32.685Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9350.962,3802.213c14.979-10.045,43.031-42.166,47.156-58.035,4.126-15.87,8.015-33.436,16.429-49.093,8.415-15.656,19.881-30.982,36.194-36.657,6.05-2.104,11.848-3.951,16.76-5.448-4.929-1.557-10.38-2.442-16.719-4.14-28.238-7.563-64.358,7.253-81.492,20.943-17.134,13.692-23.821,21.851-23.821,21.851,0,0,13.584-3.193,20.275-5.676,10.773-3.999,21.169-4.129,22.959-1.033,3.577,6.192-1.678,6.984-13.142,7.187-11.463,.202-28.343,5.897-35.502,12.477-8.312,7.643-24.398,38.633-24.398,38.633,0,0,21.209-4.778,43.08-11.465,9.818-3.003,7.843,6.142,4.878,7.643-13.859,7.017-42.061,3.145-47.958,13.374-6.333,10.986-6.333,38.092-6.333,38.092,0,0,27.861-4.3,38.687-8.557,10.827-4.258,19.223,.518,10.726,5.295-8.496,4.776-38.781,10.349-47.187,15.764-4.897,8.103-3.975,25.131-2.226,34.429,1.75,9.297,6.333,23.436,9.752,32.918,3.704-23.922,16.903-58.458,31.881-68.504Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9375.561,3809.141c.956-11.245,9.554-7.204,9.554-.48s-.956,38.691-.956,38.691c0,0,26.084-16.135,42.989-35.824,11.172-13.01-1.911-34.878-5.731-50.154-3.822-15.275,1.485-18.628,6.209-14.955,3.836,2.981,3.657,14.957,6.585,24.986,4.878,16.719,7.12,31.965,7.12,31.965,0,0,16.692-12.087,25.94-31.01,6.958-14.237-8.181-46.996-10.986-51.586-5.254-8.598,1.242-9.92,4.299-5.733,2.67,3.66,6.447,11.428,10.035,19.236,5.226,11.37,6.36,19.317,8.116,24.478,11.262-14.726,25.71-50.125,13.375-79.06-7.815-18.329-15.255-23.756-24.609-26.714-4.912,1.497-10.71,3.344-16.76,5.448-16.312,5.675-27.779,21.002-36.194,36.657-8.415,15.657-12.303,33.223-16.429,49.093-4.125,15.869-32.177,47.99-47.156,58.035-14.978,10.046-28.177,44.582-31.881,68.504,19.168-4.39,40.179-6.947,54.571-19.066,3.82-18.152,.954-31.268,1.909-42.51Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9375.561,3809.141c.956-11.245,9.554-7.204,9.554-.48s-.956,38.691-.956,38.691c0,0,26.084-16.135,42.989-35.824,11.172-13.01-1.911-34.878-5.731-50.154-3.822-15.275,1.485-18.628,6.209-14.955,3.836,2.981,3.657,14.957,6.585,24.986,4.878,16.719,7.12,31.965,7.12,31.965,0,0,16.692-12.087,25.94-31.01,6.958-14.237-8.181-46.996-10.986-51.586-5.254-8.598,1.242-9.92,4.299-5.733,2.67,3.66,6.447,11.428,10.035,19.236,5.226,11.37,6.36,19.317,8.116,24.478,11.262-14.726,25.71-50.125,13.375-79.06-7.815-18.329-15.255-23.756-24.609-26.714-4.912,1.497-10.71,3.344-16.76,5.448-16.312,5.675-27.779,21.002-36.194,36.657-8.415,15.657-12.303,33.223-16.429,49.093-4.125,15.869-32.177,47.99-47.156,58.035-14.978,10.046-28.177,44.582-31.881,68.504,19.168-4.39,40.179-6.947,54.571-19.066,3.82-18.152,.954-31.268,1.909-42.51Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9471.737,3654.634s-22.139,1.656-37.527,18.031c-10.81,11.503-19.663,22.421-25.213,51.452-4.036,21.113-22.123,46.717-30.72,56.204-8.598,9.486-21.662,17.887-35.674,35.029-14.01,17.142-21.716,46.332-21.716,46.332,0,0,5.477-34.714,18.851-50.316,13.374-15.601,30.57-24.297,42.988-44.26,12.42-19.964,16.38-41.078,19.654-53.498,3.275-12.419,15.694-35.737,27.157-45.573,11.463-9.835,32.409-22.898,42.2-13.402Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9364.098,3749.331c-9.419,2.376-22.45,2.792-31.525,7.179-9.076,4.386-7.55,10.596-8.074,17.761-.523,7.165,15.717,2.865,27.658,0,11.942-2.867,20.186-14.647,24.485-20.625,4.299-5.979-3.38-6.626-12.544-4.316Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9383.268,3699.967c-12.805,.909-25.062,2.729-35.251,8.663-10.19,5.933-12.579,14.531-11.145,18.353,1.433,3.821,10.986-3.344,24.838-6.209,13.852-2.867,23.852,.474,29.107-6.786,5.254-7.258,4.178-14.853-7.548-14.021Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9414.547,3656.29c-14.052,1.712-23.701,6.297-29.91,11.745-6.209,5.45,3.289,6.674,11.675,4.629,8.386-2.045,20.534-4.61,28.789-11.926,8.256-7.315-1.781-5.518-10.554-4.449Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9324.498,3808.185c-7.704,2.823-9.507,16.928-8.836,23.032,.671,6.104,5.924,.373,11.178-9.658,5.255-10.031,6.781-16.718-2.342-13.374Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9354.067,3815.855c-7.111,3.921-18.434,18.419-17.576,28.301,.857,9.883,16.418,6.539,22.251-6.357,5.834-12.898,10.228-30.163-4.675-21.944Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9400.4,3774.271c-4.297,5.32-5.787,30.129-4.087,40.38,1.698,10.251,19.644-2.001,23.569-14.025,3.923-12.025-9.451-38.774-19.482-26.354Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9428.176,3705.314c-6.378,8.213,2.589,19.28,6.034,31.223,3.447,11.941,4.258,32.481,7.913,37.734,3.655,5.254,18.462-6.21,18.462-21.018s-9.076-35.824-14.331-42.988c-5.254-7.165-13.409-10.962-18.078-4.951Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9458.991,3668.036c-10.537-.708-11.781,10.263-2.706,22.425,9.076,12.162,14.819,28.88,19.59,31.745,4.77,2.866,12.891-10.296,7.637-27.12-5.255-16.824-13.216-26.29-24.522-27.05Z",
    fill: "#2ca348",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 9312.806,
    y1: 3899.469,
    x2: 9470.923,
    y2: 4127.609,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9328.618,
    y1: 3884.786,
    x2: 9486.735,
    y2: 4112.927,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9356.288,
    y1: 3872.363,
    x2: 9514.406,
    y2: 4100.503,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9383.394,
    y1: 3857.68,
    x2: 9541.512,
    y2: 4085.821,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9407.112,
    y1: 3845.257,
    x2: 9565.229,
    y2: 4073.398,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9433.088,
    y1: 3829.445,
    x2: 9591.206,
    y2: 4057.586,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9459.065,
    y1: 3814.763,
    x2: 9606.735,
    y2: 4034.998,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9365.888,
    y1: 3867.845,
    x2: 9322.5,
    y2: 4226.903,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9394.924,
    y1: 3847.563,
    x2: 9351.535,
    y2: 4206.621,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9426.547,
    y1: 3826.104,
    x2: 9383.159,
    y2: 4185.162,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9457.041,
    y1: 3812.551,
    x2: 9413.653,
    y2: 4171.609,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9487.535,
    y1: 3796.739,
    x2: 9444.147,
    y2: 4155.797,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9519.159,
    y1: 3778.669,
    x2: 9475.771,
    y2: 4137.727,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9290.783,
    y1: 3911.892,
    x2: 9448.9,
    y2: 4140.033,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9272.712,
    y1: 3924.316,
    x2: 9430.829,
    y2: 4152.456,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9253.512,
    y1: 3935.61,
    x2: 9411.629,
    y2: 4163.75,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9233.183,
    y1: 3948.033,
    x2: 9391.3,
    y2: 4176.174,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9213.983,
    y1: 3958.198,
    x2: 9372.1,
    y2: 4186.339,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9194.783,
    y1: 3968.363,
    x2: 9352.9,
    y2: 4196.503,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9215.512,
    y1: 3947.492,
    x2: 9181.23,
    y2: 4263.703,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9244.547,
    y1: 3927.21,
    x2: 9201.159,
    y2: 4286.268,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9276.171,
    y1: 3905.751,
    x2: 9232.783,
    y2: 4264.809,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9306.665,
    y1: 3892.198,
    x2: 9263.277,
    y2: 4251.256,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9337.159,
    y1: 3876.386,
    x2: 9293.771,
    y2: 4235.444,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9173.748,
    y1: 3987.845,
    x2: 9331.865,
    y2: 4215.986,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9170.218,
    y1: 4024.833,
    x2: 9310.688,
    y2: 4228.691,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9174.453,
    y1: 4074.809,
    x2: 9283.23,
    y2: 4239.421,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9174.453,
    y1: 4127.327,
    x2: 9254.677,
    y2: 4255.374,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9551.064,
    y1: 3754.951,
    x2: 9507.676,
    y2: 4114.009,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9582.123,
    y1: 3736.316,
    x2: 9538.735,
    y2: 4095.374,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9606.453,
    y1: 3770.151,
    x2: 9574.311,
    y2: 4080.692,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9483.629,
    y1: 3801.775,
    x2: 9610.97,
    y2: 3997.727,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9502.97,
    y1: 3787.375,
    x2: 9605.323,
    y2: 3945.774,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9525.629,
    y1: 3778.481,
    x2: 9603.629,
    y2: 3901.163,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9544.017,
    y1: 3767.539,
    x2: 9606.453,
    y2: 3863.892,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9564.788,
    y1: 3756.987,
    x2: 9604.758,
    y2: 3817.586,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 9744.324,
    y1: 3660.529,
    x2: 9902.442,
    y2: 3888.67,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9760.136,
    y1: 3645.847,
    x2: 9918.253,
    y2: 3873.987,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9787.806,
    y1: 3633.423,
    x2: 9945.924,
    y2: 3861.564,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9814.912,
    y1: 3618.741,
    x2: 9973.03,
    y2: 3846.881,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9838.63,
    y1: 3606.317,
    x2: 9996.747,
    y2: 3834.458,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9864.606,
    y1: 3590.505,
    x2: 10022.724,
    y2: 3818.646,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9890.583,
    y1: 3575.823,
    x2: 10038.253,
    y2: 3796.058,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9797.406,
    y1: 3628.905,
    x2: 9754.018,
    y2: 3987.963,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9826.442,
    y1: 3608.623,
    x2: 9783.054,
    y2: 3967.681,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9858.065,
    y1: 3587.164,
    x2: 9814.677,
    y2: 3946.222,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9888.559,
    y1: 3573.611,
    x2: 9845.171,
    y2: 3932.669,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9919.053,
    y1: 3557.8,
    x2: 9875.665,
    y2: 3916.858,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9950.677,
    y1: 3539.729,
    x2: 9907.289,
    y2: 3898.787,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9722.301,
    y1: 3672.952,
    x2: 9880.418,
    y2: 3901.093,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9704.23,
    y1: 3685.376,
    x2: 9862.348,
    y2: 3913.517,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9685.03,
    y1: 3696.67,
    x2: 9843.148,
    y2: 3924.811,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9664.701,
    y1: 3709.093,
    x2: 9822.818,
    y2: 3937.234,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9645.501,
    y1: 3719.258,
    x2: 9803.618,
    y2: 3947.399,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9626.301,
    y1: 3729.423,
    x2: 9784.418,
    y2: 3957.564,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9647.03,
    y1: 3708.552,
    x2: 9612.748,
    y2: 4024.763,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9676.066,
    y1: 3688.27,
    x2: 9632.677,
    y2: 4047.328,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9707.689,
    y1: 3666.811,
    x2: 9664.301,
    y2: 4025.869,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9738.183,
    y1: 3653.258,
    x2: 9694.795,
    y2: 4012.316,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9768.677,
    y1: 3637.447,
    x2: 9725.289,
    y2: 3996.505,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9605.266,
    y1: 3748.905,
    x2: 9763.383,
    y2: 3977.046,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9601.736,
    y1: 3785.893,
    x2: 9742.207,
    y2: 3989.752,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9605.972,
    y1: 3835.87,
    x2: 9714.748,
    y2: 4000.481,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9605.972,
    y1: 3888.387,
    x2: 9686.195,
    y2: 4016.434,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9982.583,
    y1: 3516.011,
    x2: 9939.194,
    y2: 3875.07,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10013.641,
    y1: 3497.376,
    x2: 9970.253,
    y2: 3856.434,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10037.971,
    y1: 3531.211,
    x2: 10005.83,
    y2: 3841.752,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9915.147,
    y1: 3562.835,
    x2: 10042.488,
    y2: 3758.787,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9934.489,
    y1: 3548.435,
    x2: 10036.841,
    y2: 3706.835,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9957.147,
    y1: 3539.541,
    x2: 10035.147,
    y2: 3662.223,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9975.536,
    y1: 3528.6,
    x2: 10037.971,
    y2: 3624.952,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9996.306,
    y1: 3518.047,
    x2: 10036.277,
    y2: 3578.647,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9626.087,4088.475c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9600.111,3714.876s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9607.264,4114.687s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9618.746,4094.969c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10056.675,3845.464c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10030.698,3471.864s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10037.851,3871.675s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10049.334,3851.958c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5130.937,2825.691c-1.235-28.213,1.792-78.654,2.515-86.724,.722-8.069-2.958-15.031-13.92-26.209-10.96-11.178-44.292-10.33-57.569-17.885-15.063-8.569-22.383-6.773-35.797-5.713-11.823,.935-21.394,14.856-21.394,14.856,0,0,15.727-12.869,33.092-4.299,17.365,8.57,36.009,22.047,52.955,23.319,16.946,1.272,35.705,5.265,35.33,17.946-.025,.817-.127,1.58-.288,2.301,1.421,7.212-1.946,19.141-2.543,26.806-.769,9.868-2.29,38.573,0,70.965,2.084,29.495,6.782,50.048,7.845,55.729,5.462,6.136,8.813,.764,8.813,.764,0,0-7.805-43.643-9.04-71.856Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5090.82,2723.036c-16.946-1.272-35.59-14.749-52.955-23.319-17.365-8.57-33.092,4.299-33.092,4.299,0,0,9.011-3.602,27.54-.421,18.528,3.181,25.898,17.36,49.685,24.029,23.787,6.669,35.084,5.999,41.322,10.777,1.392,1.067,2.135,2.81,2.543,4.882,.161-.721,.263-1.484,.288-2.301,.375-12.681-18.385-16.674-35.33-17.946Z",
    fill: "#478e19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5017.078,2692.332s22.68-3.047,27.062,.679c4.382,3.726,.794,10.461,4.451,11.006,3.657,.544,2.448-6.649,4.543-7.896,2.095-1.248,5.821,4.714,14.018,6.205,8.197,1.49,3.071,4.401,5.222,10.433,2.151,6.032,3.8,2.609,5.25-1.49,1.45-4.099,1.006-6.334,10.543-5.217,9.537,1.118,14.982,1.49,14.495,5.217-.486,3.726-.859,9.324,2.494,8.761,3.354-.564,2.493-8.761,4.6-8.016,2.107,.745,6.795,2.284,11.422,8.016,4.627,5.731,9.935,13.431,12.194,19.883,1.778-9.455-3.269-21.006-16.029-30.396-13.638-7.815-31.521-9.524-44.969-12.742-12.706-3.041-19.286-8.673-30.186-8.673-18.346,0-25.11,4.232-25.11,4.232Z",
    fill: "#6ebc3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5122.273,2762.12s8.504-4.095,16.103,12.995c6.791,15.273,5.589,44.95-1.676,71.778-7.266,26.827-9.617,33.593-10.551,44.46-1.037,12.069,2.554,22.198,4.629,28.969-5.562,3.977-8.202-.494-8.202-.494,0,0-8.453-18.042-3.871-38.223,4.581-20.182,13.524-27.992,16.877-56.503,3.353-28.511,1.118-44.141-5.03-50.857-6.148-6.716-9.653-7.834-9.653-7.834l1.374-4.291Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5170.904,2740.341s-8.504-4.095-16.103,12.996c-6.791,15.272-5.589,44.95,1.677,71.777,7.265,26.827,9.616,33.593,10.55,44.461,1.037,12.069-2.554,22.198-4.629,28.968,5.563,3.978,8.202-.493,8.202-.493,0,0,8.453-18.042,3.872-38.224-4.582-20.181-13.524-27.992-16.878-56.503-3.353-28.51-1.117-44.141,5.03-50.857,6.148-6.716,9.653-7.834,9.653-7.834l-1.374-4.292Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5017.24,2798.807c27.314-5.024,38.739-6.641,62.514-21.407,15.796-9.81,33.556-14.429,46.395-14.46-6.807-9.505-20.719-15.805-38.064-17.601-23.62-2.447-40.796,8.935-40.796,8.935,0,0,6.063,.887,10.649,.977,5.957,.118,10.397,.734,13.547,1.562,12.861,3.381,2.249,7.351,.342,6.964-6.586-1.339-15.262-5.839-27.557-4.798-5.332,.453-19.724,8.996-19.724,8.996,0,0,5.856,.082,12.128,1.986,6.792,2.061,20.093-.554,18.153,2.425-3.733,5.731-22.759,2.38-28.459,1.051-15.202-3.544-29.905,10.502-29.905,10.502,5.545-1.513,10.145-1.019,16.631-.92,4.757,.073,11.363-2.543,14.068-1.014,3.996,2.259-6.383,6.269-15.388,6.69-9.004,.42-17.158,1.82-23.627,10.259-7.518,9.808-12.751,26.403-12.751,26.403,10.05-10.301,26.855-23.792,41.842-26.55Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5019.597,2817.71c6.669-9.486,14.566-11.323,16.171-9.846,3.211,2.955-17.053,21.417-17.053,21.417,0,0,15.762,3.765,29.15,1.069,7.678-1.547,11.858-13.012,15.877-19.447,2.989-4.785,5.574-7.018,8.311-7.147,2.142-.1,6.925,2.326,1.265,8.485-2.914,3.171-12.456,16-12.456,16,0,0,16.398,3.063,31.816-8.354,5.844-4.328,4.779-16.615,6.178-23.447,.974-4.756,2.75-10.54,5.746-5.629,.464,.761,2.495,6.264-.215,11.73-3.16,6.373-3.585,9.906-4.232,15.635,27.544-16.725,31.656-31.44,30.435-43.728-.419-4.221-1.978-8.068-4.441-11.507-12.839,.03-30.598,4.65-46.395,14.46-23.775,14.766-35.199,16.383-62.514,21.407-14.986,2.758-31.791,16.248-41.842,26.55,0,0,9.382,3.15,20.763,2.34,5.69-.405,17.815-1.993,23.435-9.988Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4983.715,2817.433s17.57-13.003,30.722-16.564c13.152-3.561,35.872-4.327,44.356-8.821,8.484-4.494,29.493-18.424,41.567-21.725,24.033-6.567,29.955-1.666,29.955-1.666,0,0-.425-5.387-1.982-6.079-5.992-2.665-17.127-2.168-28.808,1.93-11.681,4.099-15.793,7.492-27.25,15.283-10.052,6.835-17.041,11.265-27.236,12.724-10.195,1.459-24.518,1.591-33.125,4.823-9.176,3.446-24.799,14.761-28.199,20.094Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5055.112,2796.873c-3.07,.936-7.045,9.361-9.865,12.371-2.819,3.009-7.72,7.492-9.75,10.363-2.03,2.872,2.564,5.756,7.871,.334,5.307-5.421,7.2-8.917,11.386-14.197,4.186-5.281,6.317-10.687,.359-8.871Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5085.008,2785.733c-2.93,1.753-2.014,10.812-3.063,16.063-1.049,5.252-3.691,8.914-5.078,13.533-1.388,4.618,9.227,2.877,9.896-5.581,.671-8.457,.194-12.63,1.103-17.182,.91-4.552-.297-8.366-2.858-6.834Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5017.512,2802.834c-2.96,.819-12.533,4.415-17.041,7.301-4.509,2.886-8.528,6.962-9.647,8.923-1.12,1.961,9.322,.802,13.469-1.59,4.146-2.392,9.605-7.865,15.389-10.929,5.785-3.063,1.642-4.758-2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5111.819,2772.989c-3.354,.919-1.884,6.436-.679,12.065,1.206,5.629,.675,11.567,1.796,13.248,1.121,1.68,9.167-2.388,5.764-11.627-3.837-10.417-3.899-14.503-6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5011.197,2792.058c-3.675,.202-8.89,1.155-12.85,3.508-3.96,2.353-5.491,5.469-5.128,6.798,.363,1.329,7.52-2.688,10.756-4.206,3.236-1.518,7.087-1.856,11.441-3.44,2.913-1.061-1.444-2.812-4.218-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5038.722,2776.851c-3.6-.592-12.409-2.406-15.279-2.614-2.871-.21-6.135,.019-8.326,2.272s2.179,1.888,5.029,2.02c2.85,.133,8.815-1.661,13.031-.164,4.215,1.497,8.238,1.681,11.408,1.167,3.17-.513,3.31-3.033,.369-2.893-2.941,.141-3.699,.628-6.232,.211Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5044.222,2760.619c-2.347,.358-5.126,1.233-6.218,2.691-1.092,1.456,4.481,1.259,7.1,.544,2.619-.715,8.851-.926,12.45,.74,3.6,1.665,9.427,4.213,13.025,4.058,3.599-.155,6.12-.015,4.776-1.303-1.345-1.288-4.496-1.918-7.801-2.505-3.305-.587-8.806-3.058-12.064-3.823-3.258-.766-8.54-.816-11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5076.429,2748.848c-3.329,.192-10.321,.997-11.763,2.383-1.442,1.387,5.41,2.236,8.328,1.404,2.917-.832,9.849-.904,13.827,.327,3.978,1.231,9.691,2.153,12.121,.745,2.43-1.407-3.341-3.142-6.057-3.394-2.717-.252-12.788-1.679-16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5276.148,2776.849c-27.314-5.025-38.739-6.641-62.514-21.407-15.796-9.81-33.555-14.429-46.395-14.46,6.808-9.506,20.719-15.805,38.065-17.601,23.619-2.447,40.795,8.935,40.795,8.935,0,0-6.063,.888-10.65,.978-5.956,.118-10.396,.734-13.547,1.561-12.86,3.381-2.248,7.352-.342,6.964,6.587-1.339,15.263-5.84,27.558-4.798,5.332,.452,19.723,8.996,19.723,8.996,0,0-5.855,.082-12.128,1.986-6.793,2.061-20.093-.554-18.153,2.425,3.733,5.73,22.759,2.379,28.459,1.05,15.202-3.544,29.905,10.503,29.905,10.503-5.545-1.514-10.145-1.02-16.631-.92-4.756,.072-11.362-2.543-14.068-1.014-3.996,2.259,6.383,6.269,15.387,6.689,9.005,.42,17.159,1.821,23.627,10.259,7.518,9.808,12.751,26.402,12.751,26.402-10.051-10.3-26.855-23.792-41.842-26.549Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5273.791,2795.751c-6.668-9.486-14.565-11.323-16.171-9.846-3.211,2.954,17.054,21.417,17.054,21.417,0,0-15.762,3.765-29.15,1.069-7.679-1.547-11.858-13.012-15.878-19.446-2.988-4.785-5.573-7.019-8.311-7.147-2.142-.101-6.925,2.326-1.264,8.485,2.914,3.171,12.456,16,12.456,16,0,0-16.398,3.063-31.815-8.354-5.845-4.328-4.78-16.615-6.179-23.447-.973-4.756-2.75-10.54-5.746-5.629-.464,.76-2.495,6.263,.215,11.729,3.16,6.374,3.585,9.907,4.232,15.636-27.545-16.725-31.655-31.44-30.435-43.729,.419-4.221,1.978-8.068,4.44-11.507,12.84,.031,30.599,4.65,46.395,14.46,23.776,14.766,35.2,16.382,62.514,21.407,14.986,2.757,31.791,16.248,41.842,26.549,0,0-9.382,3.15-20.763,2.341-5.691-.404-17.815-1.993-23.436-9.987Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5309.673,2795.475s-17.57-13.003-30.722-16.564c-13.152-3.561-35.872-4.328-44.356-8.821-8.483-4.494-29.492-18.424-41.566-21.724-24.033-6.567-29.955-1.666-29.955-1.666,0,0,.425-5.387,1.982-6.079,5.992-2.665,17.126-2.169,28.808,1.93,11.68,4.099,15.792,7.492,27.249,15.282,10.052,6.836,17.041,11.265,27.236,12.724,10.195,1.46,24.517,1.591,33.125,4.824,9.177,3.447,24.8,14.762,28.199,20.095Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5238.276,2774.915c3.07,.935,7.044,9.361,9.864,12.371,2.82,3.009,7.721,7.491,9.75,10.363,2.03,2.872-2.564,5.755-7.87,.334-5.306-5.421-7.2-8.917-11.386-14.198-4.186-5.28-6.317-10.687-.358-8.87Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5208.38,2763.774c2.93,1.753,2.014,10.812,3.063,16.064,1.049,5.252,3.691,8.913,5.078,13.532,1.387,4.619-9.227,2.877-9.897-5.581-.671-8.457-.193-12.63-1.103-17.182-.909-4.551,.298-8.365,2.859-6.833Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5275.876,2780.876c2.961,.818,12.533,4.414,17.042,7.3,4.509,2.886,8.527,6.962,9.647,8.923,1.119,1.961-9.323,.803-13.47-1.589-4.147-2.392-9.604-7.865-15.389-10.928-5.784-3.063-1.641-4.759,2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5181.569,2751.029c3.354,.919,1.885,6.437,.679,12.066-1.206,5.629-.675,11.567-1.796,13.247-1.12,1.68-9.166-2.388-5.764-11.627,3.837-10.416,3.9-14.503,6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5282.192,2770.098c3.675,.202,8.89,1.155,12.851,3.508,3.96,2.353,5.491,5.469,5.127,6.799-.363,1.33-7.52-2.688-10.755-4.206-3.237-1.518-7.088-1.855-11.441-3.441-2.914-1.061,1.444-2.812,4.217-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5254.666,2754.893c3.6-.592,12.409-2.406,15.279-2.615,2.872-.21,6.136,.02,8.326,2.273,2.19,2.253-2.179,1.888-5.029,2.02-2.849,.132-8.815-1.662-13.03-.164-4.216,1.497-8.239,1.681-11.409,1.168-3.17-.513-3.31-3.034-.368-2.893,2.941,.141,3.699,.628,6.231,.212Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5249.166,2738.66c2.347,.357,5.125,1.234,6.218,2.691,1.091,1.457-4.482,1.259-7.101,.544-2.619-.715-8.851-.927-12.45,.739-3.599,1.665-9.426,4.212-13.025,4.058-3.599-.155-6.119-.016-4.775-1.304,1.344-1.288,4.496-1.917,7.801-2.505,3.305-.588,8.806-3.058,12.063-3.824s8.54-.815,11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5216.96,2726.889c3.328,.192,10.321,.997,11.763,2.384,1.442,1.386-5.41,2.235-8.327,1.403-2.917-.831-9.85-.903-13.828,.327-3.977,1.232-9.69,2.153-12.12,.746-2.43-1.407,3.34-3.142,6.058-3.394,2.716-.251,12.788-1.678,16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5180.438,2786.799s-23.873,38.912-19.282,57.063c4.592,18.151,16.208,31.268,19.282,51.834,2.004,13.405,.293,20.491,.293,20.491,0,0-3.764,4.462-7.077,.365,.573-5.45,.993-14.846-1.056-24.919-2.592-12.743-8.239-26.682-12.593-36.328-7.795-17.272-4.929-31.862,3.942-49.384,4.17-8.237,16.491-19.122,16.491-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5254.203,2861.575c-9.624-4.325-28.953-20.1-32.889-28.848-3.936-8.748-7.901-18.498-14.29-26.703-6.388-8.204-14.505-15.919-24.47-17.593-3.696-.62-7.221-1.117-10.2-1.498,2.69-1.382,5.747-2.427,9.236-4.028,15.545-7.131,37.831-2.127,49.056,4.089s15.881,10.267,15.881,10.267c0,0-8.148-.51-12.25-1.286-6.605-1.25-12.615-.305-13.343,1.655-1.456,3.922,1.653,3.864,8.284,2.857,6.632-1.007,16.926,.622,21.7,3.715,5.544,3.593,17.86,19.889,17.86,19.889,0,0-12.701-.676-25.971-2.387-5.957-.769-3.922,4.311-2.064,4.886,8.681,2.688,24.568-2.311,28.972,3.011,4.73,5.715,7.388,21.349,7.388,21.349,0,0-16.49,.252-23.153-1.142-6.662-1.394-11.035,2.184-5.667,4.106,5.369,1.922,23.383,2.166,28.761,4.465,3.619,4.193,4.757,14.105,4.661,19.639-.097,5.534-1.354,14.138-2.396,19.942-4.483-13.434-15.482-32.059-25.106-36.384Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5240.694,2867.983c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5240.694,2867.983c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5170.072,2788.3s12.931-1.216,23.412,6.72c7.363,5.575,13.54,11.004,19.588,27.203,4.399,11.781,17.34,24.775,23.23,29.404,5.889,4.628,14.248,8.192,24.011,16.705,9.762,8.512,17.069,24.593,17.069,24.593,0,0-6.563-19.485-15.807-27.171-9.243-7.687-20.014-11.016-29.135-21.312-9.12-10.296-13.475-22.086-16.582-28.928-3.106-6.841-12.556-19.072-20.132-23.621-7.577-4.549-20.939-10.029-25.654-3.592Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5241.441,2832.363c5.665,.447,13.222-.592,18.887,1.048,5.665,1.64,5.394,5.372,6.399,9.453,1.004,4.081-8.783,3.194-15.952,2.713-7.169-.482-13.079-6.468-16.145-9.495-3.065-3.027,1.3-4.153,6.812-3.719Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5225.543,2805.772c7.475-.732,14.722-.884,21.182,1.539,6.459,2.423,8.679,7.148,8.228,9.493-.452,2.344-6.664-.851-14.935-1.146-8.271-.294-13.71,2.613-17.452-1.058-3.742-3.671-3.867-8.158,2.978-8.827Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5203.219,2783.648c8.272-.391,14.287,1.307,18.403,3.842,4.116,2.534-1.242,4.172-6.28,3.814-5.037-.357-12.295-.645-17.774-4.055-5.48-3.41,.486-3.357,5.651-3.601Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5270.051,2862.424c4.721,.873,7.143,8.831,7.356,12.418,.212,3.587-3.381,.796-7.395-4.474-4.014-5.27-5.549-8.977,.039-7.944Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5253.75,2869.748c4.486,1.564,12.438,8.816,12.913,14.6,.474,5.785-8.827,5.382-13.457-1.485-4.629-6.866-8.857-16.394,.544-13.115Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5222.949,2850.307c3,2.647,6.292,16.81,6.317,22.889,.025,6.079-11.527,.772-14.969-5.778-3.442-6.551,1.648-23.29,8.652-17.111Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5200.166,2813.26c4.484,4.111,.397,11.374-.419,18.6-.817,7.225,.73,19.15-.863,22.54-1.592,3.388-11.257-1.771-12.709-10.311-1.452-8.541,1.722-21.552,4.05-26.2,2.328-4.647,6.659-7.637,9.941-4.628Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5178.738,2794.781c6.008-1.442,7.802,4.764,3.76,12.668-4.042,7.905-5.715,18.11-8.185,20.231-2.471,2.121-8.445-4.674-7.064-14.894,1.38-10.219,5.044-16.459,11.49-18.006Z",
    fill: "#2ca348",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5132.137,2805.724s23.874,38.912,19.282,57.063c-4.591,18.151-16.208,31.268-19.282,51.834-2.004,13.405-.293,20.491-.293,20.491,0,0,3.764,4.462,7.077,.364-.573-5.45-.993-14.846,1.056-24.918,2.592-12.744,8.239-26.682,12.593-36.329,7.795-17.272,4.929-31.861-3.943-49.383-4.17-8.237-16.49-19.122-16.49-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5069.318,2891.071c8.763-5.877,25.175-24.669,27.588-33.953,2.414-9.284,4.689-19.561,9.612-28.721,4.923-9.159,11.631-18.126,21.175-21.446,3.539-1.231,6.932-2.311,9.805-3.187-2.883-.911-6.073-1.429-9.781-2.422-16.52-4.425-37.652,4.244-47.676,12.253-10.024,8.01-13.936,12.784-13.936,12.784,0,0,7.947-1.868,11.862-3.321,6.302-2.339,12.385-2.415,13.432-.604,2.092,3.623-.982,4.086-7.689,4.205-6.706,.118-16.582,3.45-20.77,7.3-4.863,4.471-14.274,22.602-14.274,22.602,0,0,12.408-2.795,25.204-6.707,5.744-1.757,4.589,3.593,2.854,4.471-8.108,4.105-24.608,1.84-28.058,7.824-3.705,6.427-3.705,22.285-3.705,22.285,0,0,16.3-2.516,22.633-5.006,6.334-2.491,11.246,.303,6.275,3.098-4.97,2.794-22.689,6.054-27.606,9.223-2.865,4.741-2.326,14.703-1.302,20.143,1.024,5.439,3.705,13.711,5.705,19.258,2.167-13.996,9.889-34.2,18.652-40.078Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5083.71,2895.123c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5083.71,2895.123c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5139.977,2804.731s-12.952,.969-21.955,10.549c-6.324,6.73-11.504,13.117-14.751,30.102-2.361,12.352-12.943,27.331-17.973,32.882-5.03,5.55-12.673,10.465-20.871,20.493-8.197,10.029-12.705,27.106-12.705,27.106,0,0,3.204-20.309,11.029-29.437,7.824-9.127,17.884-14.215,25.15-25.894,7.266-11.68,9.583-24.033,11.498-31.299,1.916-7.266,9.181-20.907,15.888-26.662,6.706-5.754,18.961-13.396,24.689-7.841Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5077.004,2860.132c-5.51,1.39-13.134,1.633-18.444,4.2-5.31,2.566-4.417,6.199-4.724,10.391-.306,4.192,9.195,1.676,16.181,0,6.986-1.677,11.81-8.569,14.325-12.066,2.515-3.498-1.978-3.877-7.339-2.525Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5088.219,2831.252c-7.491,.532-14.662,1.596-20.623,5.068-5.962,3.471-7.359,8.501-6.52,10.737,.838,2.235,6.427-1.956,14.531-3.633,8.104-1.677,13.955,.277,17.029-3.97,3.074-4.246,2.445-8.69-4.416-8.203Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5106.518,2805.7c-8.221,1.002-13.866,3.684-17.499,6.872-3.633,3.188,1.924,3.905,6.831,2.708,4.906-1.196,12.013-2.697,16.843-6.977,4.83-4.28-1.042-3.228-6.175-2.603Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5053.836,2894.564c-4.507,1.652-5.562,9.903-5.17,13.475,.393,3.571,3.466,.218,6.54-5.65,3.074-5.868,3.967-9.781-1.37-7.824Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5071.135,2899.052c-4.16,2.294-10.785,10.776-10.283,16.557,.502,5.782,9.605,3.825,13.018-3.719,3.413-7.546,5.984-17.647-2.735-12.838Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5098.241,2874.723c-2.514,3.112-3.385,17.627-2.391,23.624,.994,5.997,11.493-1.171,13.789-8.205,2.295-7.035-5.529-22.684-11.398-15.418Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5114.492,2834.381c-3.731,4.805,1.515,11.28,3.53,18.267,2.016,6.986,2.491,19.002,4.629,22.076,2.138,3.074,10.801-3.633,10.801-12.296s-5.31-20.958-8.384-25.15c-3.074-4.192-7.845-6.413-10.576-2.897Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5132.52,2812.571c-6.164-.414-6.892,6.005-1.583,13.12,5.31,7.115,8.67,16.896,11.461,18.572,2.791,1.677,7.542-6.023,4.468-15.867-3.074-9.843-7.732-15.381-14.346-15.826Z",
    fill: "#2ca348",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4249.714,3318.718c-1.235-28.213,1.792-78.654,2.515-86.724,.722-8.069-2.958-15.031-13.92-26.209-10.96-11.178-44.292-10.33-57.569-17.885-15.063-8.569-22.383-6.773-35.797-5.713-11.823,.935-21.394,14.856-21.394,14.856,0,0,15.727-12.869,33.092-4.299,17.365,8.57,36.009,22.047,52.955,23.319,16.946,1.272,35.705,5.265,35.33,17.946-.025,.817-.127,1.58-.288,2.301,1.421,7.212-1.946,19.141-2.543,26.806-.769,9.868-2.29,38.573,0,70.965,2.084,29.495,6.782,50.048,7.845,55.729,5.462,6.136,8.813,.764,8.813,.764,0,0-7.805-43.643-9.04-71.856Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4209.596,3216.063c-16.946-1.272-35.59-14.749-52.955-23.319-17.365-8.57-33.092,4.299-33.092,4.299,0,0,9.011-3.602,27.54-.421,18.528,3.181,25.898,17.36,49.685,24.029,23.787,6.669,35.084,5.999,41.322,10.777,1.392,1.067,2.135,2.81,2.543,4.882,.161-.721,.263-1.484,.288-2.301,.375-12.681-18.385-16.674-35.33-17.946Z",
    fill: "#478e19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4135.855,3185.359s22.68-3.047,27.062,.679c4.382,3.726,.794,10.461,4.451,11.006,3.657,.544,2.448-6.649,4.543-7.896,2.095-1.248,5.821,4.714,14.018,6.205,8.197,1.49,3.071,4.401,5.222,10.433,2.151,6.032,3.8,2.609,5.25-1.49,1.45-4.099,1.006-6.334,10.543-5.217,9.537,1.118,14.982,1.49,14.495,5.217-.486,3.726-.859,9.324,2.494,8.761,3.354-.564,2.493-8.761,4.6-8.016,2.107,.745,6.795,2.284,11.422,8.016,4.627,5.731,9.935,13.431,12.194,19.883,1.778-9.455-3.269-21.006-16.029-30.396-13.638-7.815-31.521-9.524-44.969-12.742-12.706-3.041-19.286-8.673-30.186-8.673-18.346,0-25.11,4.232-25.11,4.232Z",
    fill: "#6ebc3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4241.05,3255.147s8.504-4.095,16.103,12.995c6.791,15.273,5.589,44.95-1.676,71.778-7.266,26.827-9.617,33.593-10.551,44.46-1.037,12.069,2.554,22.198,4.629,28.969-5.562,3.977-8.202-.494-8.202-.494,0,0-8.453-18.042-3.871-38.223,4.581-20.182,13.524-27.992,16.877-56.503,3.353-28.511,1.118-44.141-5.03-50.857-6.148-6.716-9.653-7.834-9.653-7.834l1.374-4.291Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4289.68,3233.369s-8.504-4.095-16.103,12.996c-6.791,15.272-5.589,44.95,1.677,71.777,7.265,26.827,9.616,33.593,10.55,44.461,1.037,12.069-2.554,22.198-4.629,28.968,5.563,3.978,8.202-.493,8.202-.493,0,0,8.453-18.042,3.872-38.224-4.582-20.181-13.524-27.992-16.878-56.503-3.353-28.51-1.117-44.141,5.03-50.857,6.148-6.716,9.653-7.834,9.653-7.834l-1.374-4.292Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4136.017,3291.835c27.314-5.024,38.739-6.641,62.514-21.407,15.796-9.81,33.556-14.429,46.395-14.46-6.807-9.505-20.719-15.805-38.064-17.601-23.62-2.447-40.796,8.935-40.796,8.935,0,0,6.063,.887,10.649,.977,5.957,.118,10.397,.734,13.547,1.562,12.861,3.381,2.249,7.351,.342,6.964-6.586-1.339-15.262-5.839-27.557-4.798-5.332,.453-19.724,8.996-19.724,8.996,0,0,5.856,.082,12.128,1.986,6.792,2.061,20.093-.554,18.153,2.425-3.733,5.731-22.759,2.38-28.459,1.051-15.202-3.544-29.905,10.502-29.905,10.502,5.545-1.513,10.145-1.019,16.631-.92,4.757,.073,11.363-2.543,14.068-1.014,3.996,2.259-6.383,6.269-15.388,6.69-9.004,.42-17.158,1.82-23.627,10.259-7.518,9.808-12.751,26.403-12.751,26.403,10.05-10.301,26.855-23.792,41.842-26.55Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4138.373,3310.737c6.669-9.486,14.566-11.323,16.171-9.846,3.211,2.955-17.053,21.417-17.053,21.417,0,0,15.762,3.765,29.15,1.069,7.678-1.547,11.858-13.012,15.877-19.447,2.989-4.785,5.574-7.018,8.311-7.147,2.142-.1,6.925,2.326,1.265,8.485-2.914,3.171-12.456,16-12.456,16,0,0,16.398,3.063,31.816-8.354,5.844-4.328,4.779-16.615,6.178-23.447,.974-4.756,2.75-10.54,5.746-5.629,.464,.761,2.495,6.264-.215,11.73-3.16,6.373-3.585,9.906-4.232,15.635,27.544-16.725,31.656-31.44,30.435-43.728-.419-4.221-1.978-8.068-4.441-11.507-12.839,.03-30.598,4.65-46.395,14.46-23.775,14.766-35.199,16.383-62.514,21.407-14.986,2.758-31.791,16.248-41.842,26.55,0,0,9.382,3.15,20.763,2.34,5.69-.405,17.815-1.993,23.435-9.988Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4102.492,3310.46s17.57-13.003,30.722-16.564c13.152-3.561,35.872-4.327,44.356-8.821,8.484-4.494,29.493-18.424,41.567-21.725,24.033-6.567,29.955-1.666,29.955-1.666,0,0-.425-5.387-1.982-6.079-5.992-2.665-17.127-2.168-28.808,1.93-11.681,4.099-15.793,7.492-27.25,15.283-10.052,6.835-17.041,11.265-27.236,12.724-10.195,1.459-24.518,1.591-33.125,4.823-9.176,3.446-24.799,14.761-28.199,20.094Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4173.889,3289.9c-3.07,.936-7.045,9.361-9.865,12.371-2.819,3.009-7.72,7.492-9.75,10.363-2.03,2.872,2.564,5.756,7.871,.334,5.307-5.421,7.2-8.917,11.386-14.197,4.186-5.281,6.317-10.687,.359-8.871Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4203.785,3278.76c-2.93,1.753-2.014,10.812-3.063,16.063-1.049,5.252-3.691,8.914-5.078,13.533-1.388,4.618,9.227,2.877,9.896-5.581,.671-8.457,.194-12.63,1.103-17.182,.91-4.552-.297-8.366-2.858-6.834Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4136.288,3295.862c-2.96,.819-12.533,4.415-17.041,7.301-4.509,2.886-8.528,6.962-9.647,8.923-1.12,1.961,9.322,.802,13.469-1.59,4.146-2.392,9.605-7.865,15.389-10.929,5.785-3.063,1.642-4.758-2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4230.595,3266.016c-3.354,.919-1.884,6.436-.679,12.065,1.206,5.629,.675,11.567,1.796,13.248,1.121,1.68,9.167-2.388,5.764-11.627-3.837-10.417-3.899-14.503-6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4129.973,3285.085c-3.675,.202-8.89,1.155-12.85,3.508-3.96,2.353-5.491,5.469-5.128,6.798,.363,1.329,7.52-2.688,10.756-4.206,3.236-1.518,7.087-1.856,11.441-3.44,2.913-1.061-1.444-2.812-4.218-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4157.499,3269.878c-3.6-.592-12.409-2.406-15.279-2.614-2.871-.21-6.135,.019-8.326,2.272s2.179,1.888,5.029,2.02c2.85,.133,8.815-1.661,13.031-.164,4.215,1.497,8.238,1.681,11.408,1.167,3.17-.513,3.31-3.033,.369-2.893-2.941,.141-3.699,.628-6.232,.211Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4162.999,3253.646c-2.347,.358-5.126,1.233-6.218,2.691-1.092,1.456,4.481,1.259,7.1,.544,2.619-.715,8.851-.926,12.45,.74,3.6,1.665,9.427,4.213,13.025,4.058,3.599-.155,6.12-.015,4.776-1.303-1.345-1.288-4.496-1.918-7.801-2.505-3.305-.587-8.806-3.058-12.064-3.823-3.258-.766-8.54-.816-11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4195.205,3241.875c-3.329,.192-10.321,.997-11.763,2.383-1.442,1.387,5.41,2.236,8.328,1.404,2.917-.832,9.849-.904,13.827,.327,3.978,1.231,9.691,2.153,12.121,.745,2.43-1.407-3.341-3.142-6.057-3.394-2.717-.252-12.788-1.679-16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4394.925,3269.876c-27.314-5.025-38.739-6.641-62.514-21.407-15.796-9.81-33.555-14.429-46.395-14.46,6.808-9.506,20.719-15.805,38.065-17.601,23.619-2.447,40.795,8.935,40.795,8.935,0,0-6.063,.888-10.65,.978-5.956,.118-10.396,.734-13.547,1.561-12.86,3.381-2.248,7.352-.342,6.964,6.587-1.339,15.263-5.84,27.558-4.798,5.332,.452,19.723,8.996,19.723,8.996,0,0-5.855,.082-12.128,1.986-6.793,2.061-20.093-.554-18.153,2.425,3.733,5.73,22.759,2.379,28.459,1.05,15.202-3.544,29.905,10.503,29.905,10.503-5.545-1.514-10.145-1.02-16.631-.92-4.756,.072-11.362-2.543-14.068-1.014-3.996,2.259,6.383,6.269,15.387,6.689,9.005,.42,17.159,1.821,23.627,10.259,7.518,9.808,12.751,26.402,12.751,26.402-10.051-10.3-26.855-23.792-41.842-26.549Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4392.567,3288.779c-6.668-9.486-14.565-11.323-16.171-9.846-3.211,2.954,17.054,21.417,17.054,21.417,0,0-15.762,3.765-29.15,1.069-7.679-1.547-11.858-13.012-15.878-19.446-2.988-4.785-5.573-7.019-8.311-7.147-2.142-.101-6.925,2.326-1.264,8.485,2.914,3.171,12.456,16,12.456,16,0,0-16.398,3.063-31.815-8.354-5.845-4.328-4.78-16.615-6.179-23.447-.973-4.756-2.75-10.54-5.746-5.629-.464,.76-2.495,6.263,.215,11.729,3.16,6.374,3.585,9.907,4.232,15.636-27.545-16.725-31.655-31.44-30.435-43.729,.419-4.221,1.978-8.068,4.44-11.507,12.84,.031,30.599,4.65,46.395,14.46,23.776,14.766,35.2,16.382,62.514,21.407,14.986,2.757,31.791,16.248,41.842,26.549,0,0-9.382,3.15-20.763,2.341-5.691-.404-17.815-1.993-23.436-9.987Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4428.449,3288.502s-17.57-13.003-30.722-16.564c-13.152-3.561-35.872-4.328-44.356-8.821-8.483-4.494-29.492-18.424-41.566-21.724-24.033-6.567-29.955-1.666-29.955-1.666,0,0,.425-5.387,1.982-6.079,5.992-2.665,17.126-2.169,28.808,1.93,11.68,4.099,15.792,7.492,27.249,15.282,10.052,6.836,17.041,11.265,27.236,12.724,10.195,1.46,24.517,1.591,33.125,4.824,9.177,3.447,24.8,14.762,28.199,20.095Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4357.053,3267.942c3.07,.935,7.044,9.361,9.864,12.371,2.82,3.009,7.721,7.491,9.75,10.363,2.03,2.872-2.564,5.755-7.87,.334-5.306-5.421-7.2-8.917-11.386-14.198-4.186-5.28-6.317-10.687-.358-8.87Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4327.156,3256.801c2.93,1.753,2.014,10.812,3.063,16.064,1.049,5.252,3.691,8.913,5.078,13.532,1.387,4.619-9.227,2.877-9.897-5.581-.671-8.457-.193-12.63-1.103-17.182-.909-4.551,.298-8.365,2.859-6.833Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4394.652,3273.903c2.961,.818,12.533,4.414,17.042,7.3,4.509,2.886,8.527,6.962,9.647,8.923,1.119,1.961-9.323,.803-13.47-1.589-4.147-2.392-9.604-7.865-15.389-10.928-5.784-3.063-1.641-4.759,2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4300.346,3244.057c3.354,.919,1.885,6.437,.679,12.066-1.206,5.629-.675,11.567-1.796,13.247-1.12,1.68-9.166-2.388-5.764-11.627,3.837-10.416,3.9-14.503,6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4400.968,3263.126c3.675,.202,8.89,1.155,12.851,3.508,3.96,2.353,5.491,5.469,5.127,6.799-.363,1.33-7.52-2.688-10.755-4.206-3.237-1.518-7.088-1.855-11.441-3.441-2.914-1.061,1.444-2.812,4.217-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4373.443,3247.92c3.6-.592,12.409-2.406,15.279-2.615,2.872-.21,6.136,.02,8.326,2.273,2.19,2.253-2.179,1.888-5.029,2.02-2.849,.132-8.815-1.662-13.03-.164-4.216,1.497-8.239,1.681-11.409,1.168-3.17-.513-3.31-3.034-.368-2.893,2.941,.141,3.699,.628,6.231,.212Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4367.943,3231.687c2.347,.357,5.125,1.234,6.218,2.691,1.091,1.457-4.482,1.259-7.101,.544-2.619-.715-8.851-.927-12.45,.739-3.599,1.665-9.426,4.212-13.025,4.058-3.599-.155-6.119-.016-4.775-1.304,1.344-1.288,4.496-1.917,7.801-2.505,3.305-.588,8.806-3.058,12.063-3.824s8.54-.815,11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4335.736,3219.916c3.328,.192,10.321,.997,11.763,2.384,1.442,1.386-5.41,2.235-8.327,1.403-2.917-.831-9.85-.903-13.828,.327-3.977,1.232-9.69,2.153-12.12,.746-2.43-1.407,3.34-3.142,6.058-3.394,2.716-.251,12.788-1.678,16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4299.215,3279.826s-23.873,38.912-19.282,57.063c4.592,18.151,16.208,31.268,19.282,51.834,2.004,13.405,.293,20.491,.293,20.491,0,0-3.764,4.462-7.077,.365,.573-5.45,.993-14.846-1.056-24.919-2.592-12.743-8.239-26.682-12.593-36.328-7.795-17.272-4.929-31.862,3.942-49.384,4.17-8.237,16.491-19.122,16.491-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4372.98,3354.602c-9.624-4.325-28.953-20.1-32.889-28.848-3.936-8.748-7.901-18.498-14.29-26.703-6.388-8.204-14.505-15.919-24.47-17.593-3.696-.62-7.221-1.117-10.2-1.498,2.69-1.382,5.747-2.427,9.236-4.028,15.545-7.131,37.831-2.127,49.056,4.089s15.881,10.267,15.881,10.267c0,0-8.148-.51-12.25-1.286-6.605-1.25-12.615-.305-13.343,1.655-1.456,3.922,1.653,3.864,8.284,2.857,6.632-1.007,16.926,.622,21.7,3.715,5.544,3.593,17.86,19.889,17.86,19.889,0,0-12.701-.676-25.971-2.387-5.957-.769-3.922,4.311-2.064,4.886,8.681,2.688,24.568-2.311,28.972,3.011,4.73,5.715,7.388,21.349,7.388,21.349,0,0-16.49,.252-23.153-1.142-6.662-1.394-11.035,2.184-5.667,4.106,5.369,1.922,23.383,2.166,28.761,4.465,3.619,4.193,4.757,14.105,4.661,19.639-.097,5.534-1.354,14.138-2.396,19.942-4.483-13.434-15.482-32.059-25.106-36.384Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4359.471,3361.01c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4359.471,3361.01c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4288.849,3281.328s12.931-1.216,23.412,6.72c7.363,5.575,13.54,11.004,19.588,27.203,4.399,11.781,17.34,24.775,23.23,29.404,5.889,4.628,14.248,8.192,24.011,16.705,9.762,8.512,17.069,24.593,17.069,24.593,0,0-6.563-19.485-15.807-27.171-9.243-7.687-20.014-11.016-29.135-21.312-9.12-10.296-13.475-22.086-16.582-28.928-3.106-6.841-12.556-19.072-20.132-23.621-7.577-4.549-20.939-10.029-25.654-3.592Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4360.217,3325.39c5.665,.447,13.222-.592,18.887,1.048,5.665,1.64,5.394,5.372,6.399,9.453,1.004,4.081-8.783,3.194-15.952,2.713-7.169-.482-13.079-6.468-16.145-9.495-3.065-3.027,1.3-4.153,6.812-3.719Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4344.32,3298.799c7.475-.732,14.722-.884,21.182,1.539,6.459,2.423,8.679,7.148,8.228,9.493-.452,2.344-6.664-.851-14.935-1.146-8.271-.294-13.71,2.613-17.452-1.058-3.742-3.671-3.867-8.158,2.978-8.827Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4321.996,3276.675c8.272-.391,14.287,1.307,18.403,3.842,4.116,2.534-1.242,4.172-6.28,3.814-5.037-.357-12.295-.645-17.774-4.055-5.48-3.41,.486-3.357,5.651-3.601Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4388.828,3355.451c4.721,.873,7.143,8.831,7.356,12.418,.212,3.587-3.381,.796-7.395-4.474-4.014-5.27-5.549-8.977,.039-7.944Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4372.526,3362.775c4.486,1.564,12.438,8.816,12.913,14.6,.474,5.785-8.827,5.382-13.457-1.485-4.629-6.866-8.857-16.394,.544-13.115Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4341.726,3343.334c3,2.647,6.292,16.81,6.317,22.889,.025,6.079-11.527,.772-14.969-5.778-3.442-6.551,1.648-23.29,8.652-17.111Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4318.943,3306.287c4.484,4.111,.397,11.374-.419,18.6-.817,7.225,.73,19.15-.863,22.54-1.592,3.388-11.257-1.771-12.709-10.311-1.452-8.541,1.722-21.552,4.05-26.2,2.328-4.647,6.659-7.637,9.941-4.628Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4297.514,3287.808c6.008-1.442,7.802,4.764,3.76,12.668-4.042,7.905-5.715,18.11-8.185,20.231-2.471,2.121-8.445-4.674-7.064-14.894,1.38-10.219,5.044-16.459,11.49-18.006Z",
    fill: "#2ca348",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4250.913,3298.751s23.874,38.912,19.282,57.063c-4.591,18.151-16.208,31.268-19.282,51.834-2.004,13.405-.293,20.491-.293,20.491,0,0,3.764,4.462,7.077,.364-.573-5.45-.993-14.846,1.056-24.918,2.592-12.744,8.239-26.682,12.593-36.329,7.795-17.272,4.929-31.861-3.943-49.383-4.17-8.237-16.49-19.122-16.49-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4188.095,3384.098c8.763-5.877,25.175-24.669,27.588-33.953,2.414-9.284,4.689-19.561,9.612-28.721,4.923-9.159,11.631-18.126,21.175-21.446,3.539-1.231,6.932-2.311,9.805-3.187-2.883-.911-6.073-1.429-9.781-2.422-16.52-4.425-37.652,4.244-47.676,12.253-10.024,8.01-13.936,12.784-13.936,12.784,0,0,7.947-1.868,11.862-3.321,6.302-2.339,12.385-2.415,13.432-.604,2.092,3.623-.982,4.086-7.689,4.205-6.706,.118-16.582,3.45-20.77,7.3-4.863,4.471-14.274,22.602-14.274,22.602,0,0,12.408-2.795,25.204-6.707,5.744-1.757,4.589,3.593,2.854,4.471-8.108,4.105-24.608,1.84-28.058,7.824-3.705,6.427-3.705,22.285-3.705,22.285,0,0,16.3-2.516,22.633-5.006,6.334-2.491,11.246,.303,6.275,3.098-4.97,2.794-22.689,6.054-27.606,9.223-2.865,4.741-2.326,14.703-1.302,20.143,1.024,5.439,3.705,13.711,5.705,19.258,2.167-13.996,9.889-34.2,18.652-40.078Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4202.486,3388.151c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4202.486,3388.151c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4258.754,3297.758s-12.952,.969-21.955,10.549c-6.324,6.73-11.504,13.117-14.751,30.102-2.361,12.352-12.943,27.331-17.973,32.882-5.03,5.55-12.673,10.465-20.871,20.493-8.197,10.029-12.705,27.106-12.705,27.106,0,0,3.204-20.309,11.029-29.437,7.824-9.127,17.884-14.215,25.15-25.894,7.266-11.68,9.583-24.033,11.498-31.299,1.916-7.266,9.181-20.907,15.888-26.662,6.706-5.754,18.961-13.396,24.689-7.841Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4195.78,3353.159c-5.51,1.39-13.134,1.633-18.444,4.2-5.31,2.566-4.417,6.199-4.724,10.391-.306,4.192,9.195,1.676,16.181,0,6.986-1.677,11.81-8.569,14.325-12.066,2.515-3.498-1.978-3.877-7.339-2.525Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4206.995,3324.28c-7.491,.532-14.662,1.596-20.623,5.068-5.962,3.471-7.359,8.501-6.52,10.737,.838,2.235,6.427-1.956,14.531-3.633,8.104-1.677,13.955,.277,17.029-3.97,3.074-4.246,2.445-8.69-4.416-8.203Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4225.295,3298.727c-8.221,1.002-13.866,3.684-17.499,6.872-3.633,3.188,1.924,3.905,6.831,2.708,4.906-1.196,12.013-2.697,16.843-6.977,4.83-4.28-1.042-3.228-6.175-2.603Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4172.613,3387.591c-4.507,1.652-5.562,9.903-5.17,13.475,.393,3.571,3.466,.218,6.54-5.65,3.074-5.868,3.967-9.781-1.37-7.824Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4189.912,3392.079c-4.16,2.294-10.785,10.776-10.283,16.557,.502,5.782,9.605,3.825,13.018-3.719,3.413-7.546,5.984-17.647-2.735-12.838Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4217.018,3367.751c-2.514,3.112-3.385,17.627-2.391,23.624,.994,5.997,11.493-1.171,13.789-8.205,2.295-7.035-5.529-22.684-11.398-15.418Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4233.268,3327.408c-3.731,4.805,1.515,11.28,3.53,18.267,2.016,6.986,2.491,19.002,4.629,22.076,2.138,3.074,10.801-3.633,10.801-12.296s-5.31-20.958-8.384-25.15c-3.074-4.192-7.845-6.413-10.576-2.897Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4251.296,3305.598c-6.164-.414-6.892,6.005-1.583,13.12,5.31,7.115,8.67,16.896,11.461,18.572,2.791,1.677,7.542-6.023,4.468-15.867-3.074-9.843-7.732-15.381-14.346-15.826Z",
    fill: "#2ca348",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4788.247,2905.549c28.146,19.625,57.318-8.363,88.855,11.754,6.412,4.089,11.714,10.244,15.736,16.833,5.904-10.444,5.752-26.41-13.614-40.193-20.365-14.493-29.536-16.358-47.754-19.819-18.217-3.46-18.888,6.331-28.489,12.104-9.602,5.773-15.379,.699-30.097,7.136-14.719,6.437-16.615,26.736-16.615,26.736,0,0,3.833-34.175,31.978-14.552Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4773.199,2915.966c5.773,9.601,22.928,18.227,33.474,20.244,18.542,3.546,52.222-7.936,66.155-2.992,4.804,1.704,16.47,7.184,20.01,.919-4.023-6.59-9.324-12.745-15.736-16.833-31.537-20.117-60.709,7.871-88.855-11.754-28.146-19.623-31.978,14.552-31.978,14.552,0,0,11.156-13.737,16.93-4.135Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4773.199,2915.966c5.773,9.601,22.928,18.227,33.474,20.244,18.542,3.546,51.104-7.79,66.155-2.992,4.857,1.547,16.47,7.184,20.01,.919-4.023-6.59-9.324-12.745-15.736-16.833-31.537-20.117-60.709,7.871-88.855-11.754-28.146-19.623-31.978,14.552-31.978,14.552,0,0,11.156-13.737,16.93-4.135Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4798.104,2888.347s10.855,3.345,23.655,8.202c12.103,4.593,24.246,4.026,38.298,4.576,5.282,.207,10.641,1.435,15.71,5.876,9.037,7.918,13.355,25.92,13.843,31.359,.309,3.459-1.237,21.195,1.58,31.4,4.098,14.843,12.945,22.792,12.945,22.792l3.025-2.428s-7.613-8.16-10.77-21.352c-2.882-12.04-1.282-28.908-2.282-34.8-2.284-13.45-7.048-25.641-17.496-32.621-9.723-6.494-28.701-2.374-42.631-5.688-13.928-3.314-30.998-9.435-30.998-9.435l-4.877,2.118Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4823.827,2901.17c-5.225-1.92-18.308-5.773-25.058-7.691-6.75-1.918-10.374,.648-12.912,2.606-2.539,1.958,1.717,5.362,9.327,7.868,7.611,2.504,20.236,4.824,26.731,2.818,6.495-2.006,8.467-3.193,1.912-5.6Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4829.007,2878.853c-5.261-.274-11.167,.749-12.97,3.544-1.803,2.794,8.739,9.469,18.84,8.909,10.101-.56,19.325-1.23,14.547-5.761-4.777-4.531-14.069-6.363-20.418-6.692Z",
    fill: "#6ebc3b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5018.479,2905.476c-28.127,19.652-57.326-8.307-88.843,11.839-6.409,4.096-11.705,10.256-15.719,16.849-5.914-10.438-5.778-26.405,13.576-40.206,20.35-14.513,29.519-16.387,47.733-19.864,18.213-3.478,18.895,6.312,28.502,12.076,9.607,5.764,15.38,.686,30.104,7.109,14.725,6.422,16.641,26.72,16.641,26.72,0,0-3.865-34.173-31.993-14.522Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5033.537,2915.877c-5.764,9.608-22.91,18.249-33.455,20.276-18.538,3.565-52.23-7.884-66.159-2.928-4.802,1.708-16.461,7.2-20.008,.938,4.015-6.593,9.311-12.754,15.719-16.849,31.517-20.146,60.716,7.813,88.843-11.839,28.128-19.652,31.993,14.522,31.993,14.522,0,0-11.17-13.727-16.934-4.12Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5033.537,2915.877c-5.764,9.608-22.91,18.249-33.455,20.276-18.538,3.565-51.111-7.741-66.159-2.928-4.854,1.553-16.461,7.2-20.008,.938,4.015-6.593,9.311-12.754,15.719-16.849,31.517-20.146,60.716,7.813,88.843-11.839,28.128-19.652,31.993,14.522,31.993,14.522,0,0-11.17-13.727-16.934-4.12Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5008.606,2888.284s-10.852,3.355-23.648,8.224c-12.098,4.605-24.242,4.049-38.293,4.614-5.281,.211-10.638,1.444-15.704,5.891-9.029,7.925-13.33,25.932-13.812,31.372-.307,3.459,1.257,21.193-1.55,31.401-4.083,14.847-12.924,22.804-12.924,22.804l-3.025-2.426s7.605-8.167,10.749-21.361c2.87-12.044,1.254-28.91,2.249-34.802,2.271-13.454,7.023-25.648,17.465-32.638,9.716-6.505,28.7-2.403,42.625-5.73,13.926-3.329,30.989-9.465,30.989-9.465l4.879,2.115Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4982.895,2901.129c5.223-1.924,18.302-5.79,25.05-7.713,6.748-1.924,10.375,.637,12.915,2.593,2.542,1.956-1.712,5.364-9.32,7.877-7.608,2.512-20.232,4.843-26.728,2.843-6.496-2-8.471-3.184-1.917-5.6Z",
    fill: "#2ca348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4977.693,2878.819c5.261-.279,11.168,.739,12.973,3.53,1.805,2.793-8.73,9.479-18.831,8.928-10.102-.55-19.325-1.21-14.553-5.747,4.772-4.536,14.063-6.376,20.411-6.712Z",
    fill: "#2ca348"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4953.435,2913.696c-3.298,1.454-8.88-.133-19.267,12.562-10.213,12.482-14.143,30.776-14.143,30.776,0,0-5.27,10.85-5.279,6.615-.004-2.134,4.119-11.966,5.279-16.849,4.219-17.752,18.697-38.704,37.09-38.406,14.792,.242-3.68,5.302-3.68,5.302Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4893.085,2954.878s3.861-8.771,10.47-10.849c6.609-2.076,13.17,5.468,13.121,13.004-.049,7.538-3.147,6.731-3.56,7.597-.413,.864-.182-9.64-2.26-13.043-2.076-3.404-5.674-.172-10.532,3.335-4.857,3.507-7.24-.045-7.24-.045Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5032.153,2958.947c-6.62-8.214-3.4-15.594-16.807-18.417-13.406-2.823-15.789-11.319-21.556-19.976-5.767-8.657-25.61-11.986-36.674-12.161,.664-.838,1.333-1.622,1.999-2.346,13.675-14.893,28.659-21.935,45.471-18.193,16.811,3.742,23.349,13.975,22.595,25.701-.755,11.727-1.786,16.148,9.954,22.509,11.74,6.362,6.468,17.819,5.659,24.953-.807,7.134,11.231,13.441,11.231,13.441-9.217-2.024-15.255-7.299-21.872-15.512Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5026.32,2975.5c-6.82-3.561-14.668-18.38-23.642-16.636-8.975,1.742-31.985,11.159-46.466,.281-18.113-13.608-9.077-38.173,.903-50.751,11.064,.175,30.907,3.504,36.674,12.161,5.767,8.656,8.15,17.153,21.556,19.976,13.407,2.823,10.187,10.203,16.807,18.417,6.617,8.214,12.655,13.489,21.872,15.512,0,0-20.885,4.604-27.704,1.041Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4961.729,2923.13c7.567-5.399,15.569,1.737,22.854,12.821,7.285,11.084,7.696,19.942-8.728,15.941-16.424-4-23.133-22.337-14.126-28.762Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5026.32,2975.5c-6.82-3.561-14.668-18.38-23.642-16.636-8.975,1.742-31.985,11.159-46.466,.281-18.113-13.608-9.077-38.173,.903-50.751,11.064,.175,30.907,3.504,36.674,12.161,5.767,8.656,8.15,17.153,21.556,19.976,13.407,2.823,10.187,10.203,16.807,18.417,6.617,8.214,12.655,13.489,21.872,15.512,0,0-20.885,4.604-27.704,1.041Z",
    fill: "#279136",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4986.355,2897.487c13.506-5.493,23.629-3.257,28.727,3.94,5.096,7.197-3.027,12.547-13.907,8.257-10.881-4.29-28.714-1.229-28.514-7.082,.2-5.853,5.192-1.655,13.694-5.114Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4957.116,2908.394s23.498-1.662,35.854,7.731c9.895,7.523,7.287,14.815,17.307,19.688,10.02,4.872,18.54,8.037,20.698,15.154,2.158,7.117,10.775,19.855,23.049,23.493-12.895-1.688-19.915-7.809-25.325-18.624-5.41-10.815-7.263-9.355-22.582-16.366-15.141-6.929-8.703-15.958-22.551-22.221-6.144-2.778-11.994-3.952-16.874-4.342-7.893-.631-13.257,.788-13.257,.788l3.681-5.302Z",
    fill: "#167227"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4868.465,2706.174s11.905,10.702,19.223,18.853c7.317,8.15,7.531,8.141,9.892,24.543,2.361,16.403-.033,99.68-2.826,137.296s8.035,72.344,8.035,72.344l5.757-2.802s-8.747-46.864-8.207-77.634c.54-30.77,4.541-107.683,2.449-132.056-1.684-19.624-4.813-21.62-6.541-31.07-1.729-9.449-11.189-21.675-11.189-21.675l-16.594,12.2Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4950.282,2737.218s-12.511,9.989-20.292,17.698c-7.78,7.709-7.994,7.688-11.309,23.924s-5.79,99.512-5.199,137.226c.592,37.714-12.246,71.751-12.246,71.751l-5.584-3.133s11.469-46.273,12.728-77.023c1.259-30.748,1.755-107.764,5.268-131.972,2.827-19.493,6.068-21.304,8.345-30.635,2.277-9.332,12.436-20.985,12.436-20.985l15.854,13.149Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4839.461,2774.627c4.571,3.073,23.376,.551,28.983,19.657,2.134,7.273,9.495,15.954,12.818,28.719,5.407,20.77,6.506,49.594,4.51,80.246-3.223,49.49,1.916,59.176,1.916,59.176l-7.051,5.743s2.262-92.972,.625-113.121c-1.938-23.847-11.121-53.71-17.687-53.987-6.566-.275-32.042-2.043-32.042-2.043l7.927-24.392Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4861.08,2773.006c3.677-6.078,4.222-14.331-2.249-18.73-9.999-6.797-18.458,.306-22.577,9.556-3.528-9.297-12.863-18.65-20.713-12.038-8.122,6.838-2.822,17.156,4.732,24.044-10.412,.272-21.328,5.41-20.435,15.881,1.036,12.147,14.307,12.517,24.649,8.377-.805,3.892-.767,7.879,.63,11.179,3.067,7.246,12.123,7.995,18.67,5.591,6.645-2.441,12.79-8.704,13.221-16.079,.263-4.512-2.356-7.753-4.802-11.328-1.036-1.513-2.045-2.963-3.072-4.378,4.974-2.764,9.693-8.352,11.946-12.074Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4844.51,2763.016c-3.364-2.627-7.664-1.47-10.121,1.781-2.116,2.799-2.558,6.673-2.423,10.445-1.941-3.05-4.355-5.751-7.441-7.834-3.899-2.631-9.713-4.06-13.212,.06-3.099,3.648-1.243,8.026,2.091,10.684,1.952,1.556,3.837,2.044,6.101,2.779-.442,.14-.906,.196-1.329,.389-3.033,1.384-5.258,4.576-3.509,7.851,1.704,3.191,5.964,3.664,9.159,3.235,1.599-.214,3.854-.67,5.788-1.532,.01,5.051,2.2,10.372,5.68,13.268,1,.832,1.994,.904,3.158,.408,8.933-3.817,8.863-17.553,1.772-23.062,6.079-5.143,11.353-12.954,4.287-18.471Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4836.196,2781.43c2.25-4.552-3.912-5.909-9.865-9.206-5.953-3.297-7.12,2.444-2.731,8.587,4.389,6.142,9.187,7.514,12.596,.619Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4965.306,2784.15c-4.57,3.073-23.375,.552-28.982,19.657-2.134,7.273-9.495,15.955-12.818,28.719-5.407,20.77-6.507,49.595-4.51,80.246,3.223,49.491-1.916,59.176-1.916,59.176l7.051,5.744s-2.263-92.973-.625-113.121c1.938-23.848,11.122-53.711,17.687-53.987,6.566-.276,32.042-2.043,32.042-2.043l-7.928-24.392Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4943.688,2782.53c-3.677-6.079-4.222-14.332,2.249-18.73,9.999-6.797,18.458,.305,22.577,9.556,3.528-9.297,12.863-18.651,20.713-12.038,8.122,6.838,2.822,17.155-4.732,24.044,10.412,.271,21.328,5.409,20.435,15.88-1.037,12.147-14.307,12.517-24.649,8.377,.805,3.892,.767,7.879-.63,11.179-3.067,7.246-12.124,7.995-18.67,5.591-6.645-2.44-12.79-8.704-13.221-16.079-.263-4.512,2.356-7.752,4.802-11.328,1.036-1.514,2.045-2.964,3.072-4.378-4.974-2.764-9.693-8.351-11.946-12.073Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4960.257,2772.54c3.364-2.628,7.665-1.471,10.122,1.781,2.116,2.798,2.558,6.672,2.423,10.444,1.941-3.05,4.355-5.751,7.441-7.834,3.899-2.631,9.712-4.06,13.212,.06,3.099,3.648,1.243,8.026-2.091,10.684-1.952,1.556-3.837,2.044-6.101,2.779,.442,.141,.906,.196,1.329,.389,3.033,1.384,5.258,4.576,3.509,7.851-1.705,3.191-5.964,3.664-9.159,3.236-1.599-.214-3.854-.67-5.788-1.532-.01,5.05-2.2,10.371-5.68,13.267-1,.832-1.994,.905-3.158,.409-8.933-3.818-8.863-17.553-1.772-23.063-6.079-5.142-11.354-12.954-4.288-18.47Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4968.571,2790.953c-2.251-4.552,3.912-5.909,9.865-9.206,5.953-3.296,7.12,2.444,2.731,8.587-4.389,6.142-9.187,7.514-12.596,.619Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4853.41,2928.927s10.824-6.132,22.364-6.594c11.541-.461,22.245,8.992,26.01,19.037,3.765,10.045,4.688,21.124,4.688,21.124l-4.688,.924s-2.213-16.547-6.264-24.43c-4.05-7.884-11.206-12.038-17.207-11.807-6.001,.23-8.369,4.155-16.152,5.815-7.784,1.661-8.751-4.069-8.751-4.069Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4791.222,2970.953c13.435-4.357,19.094-6.634,28.927-19.846,7.098-9.534,23.757-18.191,36.222-20.822-.986-.423-1.977-.871-2.961-1.358-25.383-12.551-38.872-17.445-65.61,5.063-26.738,22.51-31.778,29.406-32.951,53.655-1.173,24.249,5.199,38.948,5.199,38.948,2.68-41.149,17.737-51.284,31.174-55.64Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4805.214,3001.829c32.715,5.503,68.275-20.634,74.805-43.381,6.276-21.861-8.485-21.676-23.649-28.164-12.465,2.631-29.124,11.288-36.222,20.822-9.834,13.212-15.492,15.489-28.927,19.846-13.437,4.356-28.494,14.491-31.174,55.64,0,0,14.238-29.965,45.166-24.764Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4785.067,2948.338c-9.355,1.069-14.465,7.387-18.773,15.695-4.308,8.309,1.846,7.694,9.233,2.154,7.385-5.539,21.234-4.923,24.311-10.156,3.077-5.231-4.001-8.924-14.771-7.694Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4800.561,2982.019c-10.88,.698-15.495-1.521-20.111,4.941-4.617,6.463,4.617,7.848,13.386,4.155,8.771-3.693,19.85-4.17,30.467-9.075,6.621-3.058,6.895-13.143-3.529-10.782-10.479,2.373-10.552,10.14-20.213,10.761Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4805.214,3001.829c32.715,5.503,68.275-20.634,74.805-43.381,6.276-21.861-8.485-21.676-23.649-28.164-12.465,2.631-29.124,11.288-36.222,20.822-9.834,13.212-15.492,15.489-28.927,19.846-13.437,4.356-28.494,14.491-31.174,55.64,0,0,14.238-29.965,45.166-24.764Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4762.285,3008.863s1.085-29.75,24.166-40.367c11.624-5.348,20.887-3.46,25.214-10.048,6.438-9.802,11.617-16.5,19.18-20.698,12.326-6.84,22.565-8.823,22.565-8.823l9.871,3.989s-5.634-.163-24.667,6.959c-5.88,2.2-15.694,10.156-20.511,18.574-5.344,9.343-10.344,11.592-25.342,14.004-24.005,3.859-30.475,36.41-30.475,36.41Z",
    fill: "#167227"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4985.177,2991.629c-13.437-4.357-19.094-6.634-28.929-19.845-7.098-9.534-23.757-18.191-36.222-20.822,.987-.423,1.977-.871,2.961-1.358,25.385-12.55,38.873-17.445,65.61,5.063,26.738,22.511,31.779,29.407,32.951,53.656,1.173,24.249-5.199,38.948-5.199,38.948-2.679-41.15-17.737-51.284-31.172-55.641Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4971.182,3022.506c-32.715,5.502-68.275-20.635-74.804-43.381-6.277-21.861,8.484-21.676,23.648-28.164,12.466,2.631,29.124,11.288,36.222,20.822,9.834,13.211,15.492,15.488,28.929,19.845,13.435,4.357,28.493,14.491,31.172,55.641,0,0-14.237-29.966-45.166-24.764Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4991.331,2969.014c9.355,1.069,14.464,7.386,18.772,15.695,4.309,8.309-1.846,7.694-9.232,2.154-7.386-5.54-21.234-4.923-24.311-10.156-3.078-5.231,4-8.925,14.771-7.694Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4975.835,3002.695c10.88,.698,15.496-1.522,20.111,4.941,4.617,6.462-4.616,7.848-13.386,4.155-8.771-3.693-19.85-4.17-30.467-9.075-6.621-3.059-6.894-13.144,3.529-10.783,10.479,2.374,10.552,10.141,20.213,10.762Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4971.182,3022.506c-32.715,5.502-68.275-20.635-74.804-43.381-6.277-21.861,8.484-21.676,23.648-28.164,12.466,2.631,29.124,11.288,36.222,20.822,9.834,13.211,15.492,15.488,28.929,19.845,13.435,4.357,28.493,14.491,31.172,55.641,0,0-14.237-29.966-45.166-24.764Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5014.112,3029.539s-1.085-29.749-24.166-40.367c-11.624-5.347-20.886-3.459-25.213-10.047-6.438-9.803-11.617-16.5-19.181-20.698-12.326-6.84-22.565-8.823-22.565-8.823l-9.87,3.988s5.633-.163,24.666,6.96c5.88,2.2,15.695,10.156,20.512,18.574,5.344,9.343,10.344,11.592,25.343,14.003,24.004,3.86,30.474,36.41,30.474,36.41Z",
    fill: "#167227"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4871.776,3039.421c-.453-10.54-7.743-13.956,.462-24.929,8.204-10.972,4.385-18.926,3-29.236-1.385-10.309,11.32-25.911,19.515-33.347-1.052-.191-2.072-.337-3.05-.442-20.103-2.157-36.006,2.448-46.162,16.359-10.156,13.911-8.309,25.912,0,34.222,8.309,8.308,12.003,10.948,7.386,23.477-4.617,12.529,6.906,17.653,12.225,22.477,5.316,4.824,.44,17.51,.44,17.51,5.585-7.605,6.638-15.553,6.185-26.092Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4887.086,3048.002c2.77-7.178-1.12-23.489,6.771-28.105,7.892-4.617,31.391-12.738,35.083-30.469,4.619-22.179-18.386-34.661-34.187-37.518-8.194,7.435-20.9,23.038-19.515,33.347,1.384,10.31,5.204,18.264-3,29.236-8.205,10.973-.915,14.389-.462,24.929,.453,10.539-.599,18.486-6.185,26.092,0,0,18.725-10.332,21.495-17.51Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4901.018,2966.023c-9.248,.941-10.545,11.584-8.699,24.718,1.846,13.135,7.385,20.06,17.08,6.211,9.694-13.848,2.626-32.049-8.381-30.929Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4887.086,3048.002c2.77-7.178-1.12-23.489,6.771-28.105,7.892-4.617,31.391-12.738,35.083-30.469,4.619-22.179-18.386-34.661-34.187-37.518-8.194,7.435-20.9,23.038-19.515,33.347,1.384,10.31,5.204,18.264-3,29.236-8.205,10.973-.915,14.389-.462,24.929,.453,10.539-.599,18.486-6.185,26.092,0,0,18.725-10.332,21.495-17.51Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4865.592,2963.024c-13.771,4.79-19.897,13.154-18.974,21.925,.924,8.77,10.558,7.424,15.897-2.982,5.337-10.406,20.752-19.881,16.738-24.145-4.014-4.263-4.991,2.185-13.661,5.202Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4897.602,2948.1s-21.595,18.077-24.672,33.29c-2.464,12.183,4.309,15.937,0,26.212-4.308,10.276-8.617,18.277-5.54,25.048,3.077,6.77,5.018,22.025-1.799,32.862,8.57-9.782,9.8-19.014,6.723-30.708-3.077-11.695-.722-11.822,6.154-27.202,6.797-15.2-4-17.731,2.266-31.577,7.274-16.076,23.791-24.115,23.791-24.115l-6.924-3.809Z",
    fill: "#167227"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4910.181,2685.345c-3.538-6.665-12.468-11.466-19.832-8.728-2.464,.916-4.96,2.477-7.301,4.379,.787-11.367-2.358-24.028-14.837-22.459-5.705,.717-12.902,3.832-13.779,10.21-.572,4.158,1.446,10.497,4.234,15.322-3.297-.71-6.796-.821-9.24-.58-7.276,.716-10.748,6.722-10.824,13.558-.081,7.268,3.004,15.783,10.59,18.137,2.771,.861,5.695,.52,8.551-.461-1.256,2.725-1.802,5.454-.828,7.797,2.554,6.153,13.845,11.154,20.18,10.215,7.396-1.098,13.912-10.577,14.491-17.592,.177-2.144,.111-5.257-.394-8.392,12.143-1.257,25.39-9.355,18.99-21.407Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4881.953,2697.796c-1.284-.689-2.603-1.366-3.928-2.024,3.168-1.159,6.191-3.212,7.753-5.262,2.945-3.869,3.524-9.698-.528-13.042-3.303-2.726-8.548-2.702-11.339,.709-1.967,2.406-2.314,5.737-2.662,8.766-3.292-7.012-10.204-14.632-16.947-7.855-4.97,4.995-.251,10.759,5.519,13.452-6.022,2.135-10.879,7.699-7.562,13.961,2.059,3.886,7.183,7.003,11.525,4.956,2.216-1.047,3.433-3.299,4.681-5.283,.74-1.176,1.546-2.332,2.281-3.514,1.932,7.428,7.113,16.981,13.501,11.227,3.08-2.775,4.8-8.348,2.611-12.104-1.105-1.894-3.038-2.985-4.904-3.987Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4861.966,2689.028c-3.734,1.73,4.135,14.619,10.098,10.681,5.962-3.937,2.569-16.556-10.098-10.681Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4911.152,2712.08c3.922-6.447,13.118-10.718,20.308-7.555,2.406,1.058,4.807,2.761,7.033,4.798-.12-11.393,3.759-23.849,16.124-21.554,5.652,1.049,12.656,4.578,13.159,10.997,.327,4.185-2.057,10.395-5.121,15.05,3.332-.516,6.831-.422,9.258-.038,7.222,1.14,10.337,7.338,10.014,14.167-.343,7.261-3.921,15.58-11.632,17.489-2.817,.697-5.715,.186-8.509-.961,1.094,2.794,1.481,5.55,.371,7.833-2.909,5.992-14.472,10.326-20.742,9.018-7.319-1.527-13.271-11.37-13.439-18.409-.051-2.151,.196-5.254,.884-8.356-12.05-1.963-24.8-10.823-17.708-22.479Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4938.604,2726.159c1.323-.613,2.678-1.211,4.04-1.791-3.095-1.341-5.993-3.568-7.432-5.707-2.715-4.034-2.952-9.887,1.288-12.988,3.456-2.529,8.692-2.198,11.278,1.37,1.824,2.517,1.975,5.863,2.146,8.906,3.696-6.808,11.042-14.01,17.377-6.851,4.67,5.277-.378,10.756-6.295,13.106,5.887,2.485,10.41,8.322,6.733,14.38-2.282,3.759-7.579,6.572-11.794,4.273-2.152-1.174-3.234-3.494-4.364-5.546-.67-1.218-1.407-2.419-2.072-3.643-2.363,7.303-8.092,16.537-14.134,10.419-2.913-2.949-4.305-8.614-1.9-12.235,1.214-1.827,3.207-2.802,5.129-3.693Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4959.07,2718.573c3.626,1.946-4.982,14.352-10.704,10.073-5.722-4.279-1.597-16.678,10.704-10.073Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6571.442,2021.184c-1.235-28.213,1.792-78.654,2.515-86.724,.722-8.069-2.958-15.031-13.92-26.209-10.96-11.178-44.292-10.33-57.569-17.885-15.063-8.569-22.383-6.773-35.797-5.713-11.823,.935-21.394,14.856-21.394,14.856,0,0,15.727-12.869,33.092-4.299,17.365,8.57,36.009,22.047,52.955,23.319,16.946,1.272,35.705,5.265,35.33,17.946-.025,.817-.127,1.58-.288,2.301,1.421,7.212-1.946,19.141-2.543,26.806-.769,9.868-2.29,38.573,0,70.965,2.084,29.495,6.782,50.048,7.845,55.729,5.462,6.136,8.813,.764,8.813,.764,0,0-7.805-43.643-9.04-71.856Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6531.324,1918.529c-16.946-1.272-35.59-14.749-52.955-23.319-17.365-8.57-33.092,4.299-33.092,4.299,0,0,9.011-3.602,27.54-.421,18.528,3.181,25.898,17.36,49.685,24.029,23.787,6.669,35.084,5.999,41.322,10.777,1.392,1.067,2.135,2.81,2.543,4.882,.161-.721,.263-1.484,.288-2.301,.375-12.681-18.385-16.674-35.33-17.946Z",
    fill: "#478e19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6457.583,1887.825s22.68-3.047,27.062,.679c4.382,3.726,.794,10.461,4.451,11.006,3.657,.544,2.448-6.649,4.543-7.896,2.095-1.248,5.821,4.714,14.018,6.205,8.197,1.49,3.071,4.401,5.222,10.433,2.151,6.032,3.8,2.609,5.25-1.49,1.45-4.099,1.006-6.334,10.543-5.217,9.537,1.118,14.982,1.49,14.495,5.217-.486,3.726-.859,9.324,2.494,8.761,3.354-.564,2.493-8.761,4.6-8.016,2.107,.745,6.795,2.284,11.422,8.016,4.627,5.731,9.935,13.431,12.194,19.883,1.778-9.455-3.269-21.006-16.029-30.396-13.638-7.815-31.521-9.524-44.969-12.742-12.706-3.041-19.286-8.673-30.186-8.673-18.346,0-25.11,4.232-25.11,4.232Z",
    fill: "#6ebc3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6562.778,1957.613s8.504-4.095,16.103,12.995c6.791,15.273,5.589,44.95-1.676,71.778-7.266,26.827-9.617,33.593-10.551,44.46-1.037,12.069,2.554,22.198,4.629,28.969-5.562,3.977-8.202-.494-8.202-.494,0,0-8.453-18.042-3.871-38.223,4.581-20.182,13.524-27.992,16.877-56.503,3.353-28.511,1.118-44.141-5.03-50.857-6.148-6.716-9.653-7.834-9.653-7.834l1.374-4.291Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6611.408,1935.834s-8.504-4.095-16.103,12.996c-6.791,15.272-5.589,44.95,1.677,71.777,7.265,26.827,9.616,33.593,10.55,44.461,1.037,12.069-2.554,22.198-4.629,28.968,5.563,3.978,8.202-.493,8.202-.493,0,0,8.453-18.042,3.872-38.224-4.582-20.181-13.524-27.992-16.878-56.503-3.353-28.51-1.117-44.141,5.03-50.857,6.148-6.716,9.653-7.834,9.653-7.834l-1.374-4.292Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6457.745,1994.3c27.314-5.024,38.739-6.641,62.514-21.407,15.796-9.81,33.556-14.429,46.395-14.46-6.807-9.505-20.719-15.805-38.064-17.601-23.62-2.447-40.796,8.935-40.796,8.935,0,0,6.063,.887,10.649,.977,5.957,.118,10.397,.734,13.547,1.562,12.861,3.381,2.249,7.351,.342,6.964-6.586-1.339-15.262-5.839-27.557-4.798-5.332,.453-19.724,8.996-19.724,8.996,0,0,5.856,.082,12.128,1.986,6.792,2.061,20.093-.554,18.153,2.425-3.733,5.731-22.759,2.38-28.459,1.051-15.202-3.544-29.905,10.502-29.905,10.502,5.545-1.513,10.145-1.019,16.631-.92,4.757,.073,11.363-2.543,14.068-1.014,3.996,2.259-6.383,6.269-15.388,6.69-9.004,.42-17.158,1.82-23.627,10.259-7.518,9.808-12.751,26.403-12.751,26.403,10.05-10.301,26.855-23.792,41.842-26.55Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6460.102,2013.203c6.669-9.486,14.566-11.323,16.171-9.846,3.211,2.955-17.053,21.417-17.053,21.417,0,0,15.762,3.765,29.15,1.069,7.678-1.547,11.858-13.012,15.877-19.447,2.989-4.785,5.574-7.018,8.311-7.147,2.142-.1,6.925,2.326,1.265,8.485-2.914,3.171-12.456,16-12.456,16,0,0,16.398,3.063,31.816-8.354,5.844-4.328,4.779-16.615,6.178-23.447,.974-4.756,2.75-10.54,5.746-5.629,.464,.761,2.495,6.264-.215,11.73-3.16,6.373-3.585,9.906-4.232,15.635,27.544-16.725,31.656-31.44,30.435-43.728-.419-4.221-1.978-8.068-4.441-11.507-12.839,.03-30.598,4.65-46.395,14.46-23.775,14.766-35.199,16.383-62.514,21.407-14.986,2.758-31.791,16.248-41.842,26.55,0,0,9.382,3.15,20.763,2.34,5.69-.405,17.815-1.993,23.435-9.988Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6424.22,2012.926s17.57-13.003,30.722-16.564c13.152-3.561,35.872-4.327,44.356-8.821,8.484-4.494,29.493-18.424,41.567-21.725,24.033-6.567,29.955-1.666,29.955-1.666,0,0-.425-5.387-1.982-6.079-5.992-2.665-17.127-2.168-28.808,1.93-11.681,4.099-15.793,7.492-27.25,15.283-10.052,6.835-17.041,11.265-27.236,12.724-10.195,1.459-24.518,1.591-33.125,4.823-9.176,3.446-24.799,14.761-28.199,20.094Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6495.617,1992.366c-3.07,.936-7.045,9.361-9.865,12.371-2.819,3.009-7.72,7.492-9.75,10.363-2.03,2.872,2.564,5.756,7.871,.334,5.307-5.421,7.2-8.917,11.386-14.197,4.186-5.281,6.317-10.687,.359-8.871Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6525.513,1981.226c-2.93,1.753-2.014,10.812-3.063,16.063-1.049,5.252-3.691,8.914-5.078,13.533-1.388,4.618,9.227,2.877,9.896-5.581,.671-8.457,.194-12.63,1.103-17.182,.91-4.552-.297-8.366-2.858-6.834Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6458.017,1998.327c-2.96,.819-12.533,4.415-17.041,7.301-4.509,2.886-8.528,6.962-9.647,8.923-1.12,1.961,9.322,.802,13.469-1.59,4.146-2.392,9.605-7.865,15.389-10.929,5.785-3.063,1.642-4.758-2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6552.324,1968.482c-3.354,.919-1.884,6.436-.679,12.065,1.206,5.629,.675,11.567,1.796,13.248,1.121,1.68,9.167-2.388,5.764-11.627-3.837-10.417-3.899-14.503-6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6451.701,1987.551c-3.675,.202-8.89,1.155-12.85,3.508-3.96,2.353-5.491,5.469-5.128,6.798,.363,1.329,7.52-2.688,10.756-4.206,3.236-1.518,7.087-1.856,11.441-3.44,2.913-1.061-1.444-2.812-4.218-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6479.227,1972.344c-3.6-.592-12.409-2.406-15.279-2.614-2.871-.21-6.135,.019-8.326,2.272s2.179,1.888,5.029,2.02c2.85,.133,8.815-1.661,13.031-.164,4.215,1.497,8.238,1.681,11.408,1.167,3.17-.513,3.31-3.033,.369-2.893-2.941,.141-3.699,.628-6.232,.211Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6484.727,1956.112c-2.347,.358-5.126,1.233-6.218,2.691-1.092,1.456,4.481,1.259,7.1,.544,2.619-.715,8.851-.926,12.45,.74,3.6,1.665,9.427,4.213,13.025,4.058,3.599-.155,6.12-.015,4.776-1.303-1.345-1.288-4.496-1.918-7.801-2.505-3.305-.587-8.806-3.058-12.064-3.823-3.258-.766-8.54-.816-11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6516.933,1944.341c-3.329,.192-10.321,.997-11.763,2.383-1.442,1.387,5.41,2.236,8.328,1.404,2.917-.832,9.849-.904,13.827,.327,3.978,1.231,9.691,2.153,12.121,.745,2.43-1.407-3.341-3.142-6.057-3.394-2.717-.252-12.788-1.679-16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6716.653,1972.342c-27.314-5.025-38.739-6.641-62.514-21.407-15.796-9.81-33.555-14.429-46.395-14.46,6.808-9.506,20.719-15.805,38.065-17.601,23.619-2.447,40.795,8.935,40.795,8.935,0,0-6.063,.888-10.65,.978-5.956,.118-10.396,.734-13.547,1.561-12.86,3.381-2.248,7.352-.342,6.964,6.587-1.339,15.263-5.84,27.558-4.798,5.332,.452,19.723,8.996,19.723,8.996,0,0-5.855,.082-12.128,1.986-6.793,2.061-20.093-.554-18.153,2.425,3.733,5.73,22.759,2.379,28.459,1.05,15.202-3.544,29.905,10.503,29.905,10.503-5.545-1.514-10.145-1.02-16.631-.92-4.756,.072-11.362-2.543-14.068-1.014-3.996,2.259,6.383,6.269,15.387,6.689,9.005,.42,17.159,1.821,23.627,10.259,7.518,9.808,12.751,26.402,12.751,26.402-10.051-10.3-26.855-23.792-41.842-26.549Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6714.296,1991.244c-6.668-9.486-14.565-11.323-16.171-9.846-3.211,2.954,17.054,21.417,17.054,21.417,0,0-15.762,3.765-29.15,1.069-7.679-1.547-11.858-13.012-15.878-19.446-2.988-4.785-5.573-7.019-8.311-7.147-2.142-.101-6.925,2.326-1.264,8.485,2.914,3.171,12.456,16,12.456,16,0,0-16.398,3.063-31.815-8.354-5.845-4.328-4.78-16.615-6.179-23.447-.973-4.756-2.75-10.54-5.746-5.629-.464,.76-2.495,6.263,.215,11.729,3.16,6.374,3.585,9.907,4.232,15.636-27.545-16.725-31.655-31.44-30.435-43.729,.419-4.221,1.978-8.068,4.44-11.507,12.84,.031,30.599,4.65,46.395,14.46,23.776,14.766,35.2,16.382,62.514,21.407,14.986,2.757,31.791,16.248,41.842,26.549,0,0-9.382,3.15-20.763,2.341-5.691-.404-17.815-1.993-23.436-9.987Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6750.178,1990.968s-17.57-13.003-30.722-16.564c-13.152-3.561-35.872-4.328-44.356-8.821-8.483-4.494-29.492-18.424-41.566-21.724-24.033-6.567-29.955-1.666-29.955-1.666,0,0,.425-5.387,1.982-6.079,5.992-2.665,17.126-2.169,28.808,1.93,11.68,4.099,15.792,7.492,27.249,15.282,10.052,6.836,17.041,11.265,27.236,12.724,10.195,1.46,24.517,1.591,33.125,4.824,9.177,3.447,24.8,14.762,28.199,20.095Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6678.781,1970.408c3.07,.935,7.044,9.361,9.864,12.371,2.82,3.009,7.721,7.491,9.75,10.363,2.03,2.872-2.564,5.755-7.87,.334-5.306-5.421-7.2-8.917-11.386-14.198-4.186-5.28-6.317-10.687-.358-8.87Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6648.885,1959.267c2.93,1.753,2.014,10.812,3.063,16.064,1.049,5.252,3.691,8.913,5.078,13.532,1.387,4.619-9.227,2.877-9.897-5.581-.671-8.457-.193-12.63-1.103-17.182-.909-4.551,.298-8.365,2.859-6.833Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6716.381,1976.369c2.961,.818,12.533,4.414,17.042,7.3,4.509,2.886,8.527,6.962,9.647,8.923,1.119,1.961-9.323,.803-13.47-1.589-4.147-2.392-9.604-7.865-15.389-10.928-5.784-3.063-1.641-4.759,2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6622.074,1946.522c3.354,.919,1.885,6.437,.679,12.066-1.206,5.629-.675,11.567-1.796,13.247-1.12,1.68-9.166-2.388-5.764-11.627,3.837-10.416,3.9-14.503,6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6722.696,1965.591c3.675,.202,8.89,1.155,12.851,3.508,3.96,2.353,5.491,5.469,5.127,6.799-.363,1.33-7.52-2.688-10.755-4.206-3.237-1.518-7.088-1.855-11.441-3.441-2.914-1.061,1.444-2.812,4.217-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6695.171,1950.386c3.6-.592,12.409-2.406,15.279-2.615,2.872-.21,6.136,.02,8.326,2.273,2.19,2.253-2.179,1.888-5.029,2.02-2.849,.132-8.815-1.662-13.03-.164-4.216,1.497-8.239,1.681-11.409,1.168-3.17-.513-3.31-3.034-.368-2.893,2.941,.141,3.699,.628,6.231,.212Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6689.671,1934.153c2.347,.357,5.125,1.234,6.218,2.691,1.091,1.457-4.482,1.259-7.101,.544-2.619-.715-8.851-.927-12.45,.739-3.599,1.665-9.426,4.212-13.025,4.058-3.599-.155-6.119-.016-4.775-1.304,1.344-1.288,4.496-1.917,7.801-2.505,3.305-.588,8.806-3.058,12.063-3.824s8.54-.815,11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6657.464,1922.382c3.328,.192,10.321,.997,11.763,2.384,1.442,1.386-5.41,2.235-8.327,1.403-2.917-.831-9.85-.903-13.828,.327-3.977,1.232-9.69,2.153-12.12,.746-2.43-1.407,3.34-3.142,6.058-3.394,2.716-.251,12.788-1.678,16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6620.943,1982.292s-23.873,38.912-19.282,57.063c4.592,18.151,16.208,31.268,19.282,51.834,2.004,13.405,.293,20.491,.293,20.491,0,0-3.764,4.462-7.077,.365,.573-5.45,.993-14.846-1.056-24.919-2.592-12.743-8.239-26.682-12.593-36.328-7.795-17.272-4.929-31.862,3.942-49.384,4.17-8.237,16.491-19.122,16.491-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6694.708,2057.068c-9.624-4.325-28.953-20.1-32.889-28.848-3.936-8.748-7.901-18.498-14.29-26.703-6.388-8.204-14.505-15.919-24.47-17.593-3.696-.62-7.221-1.117-10.2-1.498,2.69-1.382,5.747-2.427,9.236-4.028,15.545-7.131,37.831-2.127,49.056,4.089s15.881,10.267,15.881,10.267c0,0-8.148-.51-12.25-1.286-6.605-1.25-12.615-.305-13.343,1.655-1.456,3.922,1.653,3.864,8.284,2.857,6.632-1.007,16.926,.622,21.7,3.715,5.544,3.593,17.86,19.889,17.86,19.889,0,0-12.701-.676-25.971-2.387-5.957-.769-3.922,4.311-2.064,4.886,8.681,2.688,24.568-2.311,28.972,3.011,4.73,5.715,7.388,21.349,7.388,21.349,0,0-16.49,.252-23.153-1.142-6.662-1.394-11.035,2.184-5.667,4.106,5.369,1.922,23.383,2.166,28.761,4.465,3.619,4.193,4.757,14.105,4.661,19.639-.097,5.534-1.354,14.138-2.396,19.942-4.483-13.434-15.482-32.059-25.106-36.384Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6681.199,2063.476c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6681.199,2063.476c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6610.577,1983.793s12.931-1.216,23.412,6.72c7.363,5.575,13.54,11.004,19.588,27.203,4.399,11.781,17.34,24.775,23.23,29.404,5.889,4.628,14.248,8.192,24.011,16.705,9.762,8.512,17.069,24.593,17.069,24.593,0,0-6.563-19.485-15.807-27.171-9.243-7.687-20.014-11.016-29.135-21.312-9.12-10.296-13.475-22.086-16.582-28.928-3.106-6.841-12.556-19.072-20.132-23.621-7.577-4.549-20.939-10.029-25.654-3.592Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6681.946,2027.856c5.665,.447,13.222-.592,18.887,1.048,5.665,1.64,5.394,5.372,6.399,9.453,1.004,4.081-8.783,3.194-15.952,2.713-7.169-.482-13.079-6.468-16.145-9.495-3.065-3.027,1.3-4.153,6.812-3.719Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6666.048,2001.265c7.475-.732,14.722-.884,21.182,1.539,6.459,2.423,8.679,7.148,8.228,9.493-.452,2.344-6.664-.851-14.935-1.146-8.271-.294-13.71,2.613-17.452-1.058-3.742-3.671-3.867-8.158,2.978-8.827Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6643.724,1979.141c8.272-.391,14.287,1.307,18.403,3.842,4.116,2.534-1.242,4.172-6.28,3.814-5.037-.357-12.295-.645-17.774-4.055-5.48-3.41,.486-3.357,5.651-3.601Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6710.556,2057.917c4.721,.873,7.143,8.831,7.356,12.418,.212,3.587-3.381,.796-7.395-4.474-4.014-5.27-5.549-8.977,.039-7.944Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6694.255,2065.241c4.486,1.564,12.438,8.816,12.913,14.6,.474,5.785-8.827,5.382-13.457-1.485-4.629-6.866-8.857-16.394,.544-13.115Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6663.454,2045.8c3,2.647,6.292,16.81,6.317,22.889,.025,6.079-11.527,.772-14.969-5.778-3.442-6.551,1.648-23.29,8.652-17.111Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6640.671,2008.753c4.484,4.111,.397,11.374-.419,18.6-.817,7.225,.73,19.15-.863,22.54-1.592,3.388-11.257-1.771-12.709-10.311-1.452-8.541,1.722-21.552,4.05-26.2,2.328-4.647,6.659-7.637,9.941-4.628Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6619.243,1990.274c6.008-1.442,7.802,4.764,3.76,12.668-4.042,7.905-5.715,18.11-8.185,20.231-2.471,2.121-8.445-4.674-7.064-14.894,1.38-10.219,5.044-16.459,11.49-18.006Z",
    fill: "#2ca348",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6572.642,2001.217s23.874,38.912,19.282,57.063c-4.591,18.151-16.208,31.268-19.282,51.834-2.004,13.405-.293,20.491-.293,20.491,0,0,3.764,4.462,7.077,.364-.573-5.45-.993-14.846,1.056-24.918,2.592-12.744,8.239-26.682,12.593-36.329,7.795-17.272,4.929-31.861-3.943-49.383-4.17-8.237-16.49-19.122-16.49-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6509.823,2086.564c8.763-5.877,25.175-24.669,27.588-33.953,2.414-9.284,4.689-19.561,9.612-28.721,4.923-9.159,11.631-18.126,21.175-21.446,3.539-1.231,6.932-2.311,9.805-3.187-2.883-.911-6.073-1.429-9.781-2.422-16.52-4.425-37.652,4.244-47.676,12.253-10.024,8.01-13.936,12.784-13.936,12.784,0,0,7.947-1.868,11.862-3.321,6.302-2.339,12.385-2.415,13.432-.604,2.092,3.623-.982,4.086-7.689,4.205-6.706,.118-16.582,3.45-20.77,7.3-4.863,4.471-14.274,22.602-14.274,22.602,0,0,12.408-2.795,25.204-6.707,5.744-1.757,4.589,3.593,2.854,4.471-8.108,4.105-24.608,1.84-28.058,7.824-3.705,6.427-3.705,22.285-3.705,22.285,0,0,16.3-2.516,22.633-5.006,6.334-2.491,11.246,.303,6.275,3.098-4.97,2.794-22.689,6.054-27.606,9.223-2.865,4.741-2.326,14.703-1.302,20.143,1.024,5.439,3.705,13.711,5.705,19.258,2.167-13.996,9.889-34.2,18.652-40.078Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6524.215,2090.616c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6524.215,2090.616c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6580.482,2000.224s-12.952,.969-21.955,10.549c-6.324,6.73-11.504,13.117-14.751,30.102-2.361,12.352-12.943,27.331-17.973,32.882-5.03,5.55-12.673,10.465-20.871,20.493-8.197,10.029-12.705,27.106-12.705,27.106,0,0,3.204-20.309,11.029-29.437,7.824-9.127,17.884-14.215,25.15-25.894,7.266-11.68,9.583-24.033,11.498-31.299,1.916-7.266,9.181-20.907,15.888-26.662,6.706-5.754,18.961-13.396,24.689-7.841Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6517.508,2055.625c-5.51,1.39-13.134,1.633-18.444,4.2-5.31,2.566-4.417,6.199-4.724,10.391-.306,4.192,9.195,1.676,16.181,0,6.986-1.677,11.81-8.569,14.325-12.066,2.515-3.498-1.978-3.877-7.339-2.525Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6528.724,2026.746c-7.491,.532-14.662,1.596-20.623,5.068-5.962,3.471-7.359,8.501-6.52,10.737,.838,2.235,6.427-1.956,14.531-3.633,8.104-1.677,13.955,.277,17.029-3.97,3.074-4.246,2.445-8.69-4.416-8.203Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6547.023,2001.193c-8.221,1.002-13.866,3.684-17.499,6.872-3.633,3.188,1.924,3.905,6.831,2.708,4.906-1.196,12.013-2.697,16.843-6.977,4.83-4.28-1.042-3.228-6.175-2.603Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6494.341,2090.057c-4.507,1.652-5.562,9.903-5.17,13.475,.393,3.571,3.466,.218,6.54-5.65,3.074-5.868,3.967-9.781-1.37-7.824Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6511.64,2094.545c-4.16,2.294-10.785,10.776-10.283,16.557,.502,5.782,9.605,3.825,13.018-3.719,3.413-7.546,5.984-17.647-2.735-12.838Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6538.746,2070.216c-2.514,3.112-3.385,17.627-2.391,23.624,.994,5.997,11.493-1.171,13.789-8.205,2.295-7.035-5.529-22.684-11.398-15.418Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6554.996,2029.874c-3.731,4.805,1.515,11.28,3.53,18.267,2.016,6.986,2.491,19.002,4.629,22.076,2.138,3.074,10.801-3.633,10.801-12.296s-5.31-20.958-8.384-25.15c-3.074-4.192-7.845-6.413-10.576-2.897Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6573.024,2008.064c-6.164-.414-6.892,6.005-1.583,13.12,5.31,7.115,8.67,16.896,11.461,18.572,2.791,1.677,7.542-6.023,4.468-15.867-3.074-9.843-7.732-15.381-14.346-15.826Z",
    fill: "#2ca348",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6372.494,2132.22c-1.235-28.213,1.792-78.654,2.515-86.724,.722-8.069-2.958-15.031-13.92-26.209-10.96-11.178-44.292-10.33-57.569-17.885-15.063-8.569-22.383-6.773-35.797-5.713-11.823,.935-21.394,14.856-21.394,14.856,0,0,15.727-12.869,33.092-4.299,17.365,8.57,36.009,22.047,52.955,23.319,16.946,1.272,35.705,5.265,35.33,17.946-.025,.817-.127,1.58-.288,2.301,1.421,7.212-1.946,19.141-2.543,26.806-.769,9.868-2.29,38.573,0,70.965,2.084,29.495,6.782,50.048,7.845,55.729,5.462,6.136,8.813,.764,8.813,.764,0,0-7.805-43.643-9.04-71.856Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6332.377,2029.565c-16.946-1.272-35.59-14.749-52.955-23.319-17.365-8.57-33.092,4.299-33.092,4.299,0,0,9.011-3.602,27.54-.421,18.528,3.181,25.898,17.36,49.685,24.029,23.787,6.669,35.084,5.999,41.322,10.777,1.392,1.067,2.135,2.81,2.543,4.882,.161-.721,.263-1.484,.288-2.301,.375-12.681-18.385-16.674-35.33-17.946Z",
    fill: "#478e19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6258.636,1998.86s22.68-3.047,27.062,.679c4.382,3.726,.794,10.461,4.451,11.006,3.657,.544,2.448-6.649,4.543-7.896,2.095-1.248,5.821,4.714,14.018,6.205,8.197,1.49,3.071,4.401,5.222,10.433,2.151,6.032,3.8,2.609,5.25-1.49,1.45-4.099,1.006-6.334,10.543-5.217,9.537,1.118,14.982,1.49,14.495,5.217-.486,3.726-.859,9.324,2.494,8.761,3.354-.564,2.493-8.761,4.6-8.016,2.107,.745,6.795,2.284,11.422,8.016,4.627,5.731,9.935,13.431,12.194,19.883,1.778-9.455-3.269-21.006-16.029-30.396-13.638-7.815-31.521-9.524-44.969-12.742-12.706-3.041-19.286-8.673-30.186-8.673-18.346,0-25.11,4.232-25.11,4.232Z",
    fill: "#6ebc3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6363.831,2068.649s8.504-4.095,16.103,12.995c6.791,15.273,5.589,44.95-1.676,71.778-7.266,26.827-9.617,33.593-10.551,44.46-1.037,12.069,2.554,22.198,4.629,28.969-5.562,3.977-8.202-.494-8.202-.494,0,0-8.453-18.042-3.871-38.223,4.581-20.182,13.524-27.992,16.877-56.503,3.353-28.511,1.118-44.141-5.03-50.857-6.148-6.716-9.653-7.834-9.653-7.834l1.374-4.291Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6412.461,2046.87s-8.504-4.095-16.103,12.996c-6.791,15.272-5.589,44.95,1.677,71.777,7.265,26.827,9.616,33.593,10.55,44.461,1.037,12.069-2.554,22.198-4.629,28.968,5.563,3.978,8.202-.493,8.202-.493,0,0,8.453-18.042,3.872-38.224-4.582-20.181-13.524-27.992-16.878-56.503-3.353-28.51-1.117-44.141,5.03-50.857,6.148-6.716,9.653-7.834,9.653-7.834l-1.374-4.292Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6258.797,2105.336c27.314-5.024,38.739-6.641,62.514-21.407,15.796-9.81,33.556-14.429,46.395-14.46-6.807-9.505-20.719-15.805-38.064-17.601-23.62-2.447-40.796,8.935-40.796,8.935,0,0,6.063,.887,10.649,.977,5.957,.118,10.397,.734,13.547,1.562,12.861,3.381,2.249,7.351,.342,6.964-6.586-1.339-15.262-5.839-27.557-4.798-5.332,.453-19.724,8.996-19.724,8.996,0,0,5.856,.082,12.128,1.986,6.792,2.061,20.093-.554,18.153,2.425-3.733,5.731-22.759,2.38-28.459,1.051-15.202-3.544-29.905,10.502-29.905,10.502,5.545-1.513,10.145-1.019,16.631-.92,4.757,.073,11.363-2.543,14.068-1.014,3.996,2.259-6.383,6.269-15.388,6.69-9.004,.42-17.158,1.82-23.627,10.259-7.518,9.808-12.751,26.403-12.751,26.403,10.05-10.301,26.855-23.792,41.842-26.55Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6261.154,2124.238c6.669-9.486,14.566-11.323,16.171-9.846,3.211,2.955-17.053,21.417-17.053,21.417,0,0,15.762,3.765,29.15,1.069,7.678-1.547,11.858-13.012,15.877-19.447,2.989-4.785,5.574-7.018,8.311-7.147,2.142-.1,6.925,2.326,1.265,8.485-2.914,3.171-12.456,16-12.456,16,0,0,16.398,3.063,31.816-8.354,5.844-4.328,4.779-16.615,6.178-23.447,.974-4.756,2.75-10.54,5.746-5.629,.464,.761,2.495,6.264-.215,11.73-3.16,6.373-3.585,9.906-4.232,15.635,27.544-16.725,31.656-31.44,30.435-43.728-.419-4.221-1.978-8.068-4.441-11.507-12.839,.03-30.598,4.65-46.395,14.46-23.775,14.766-35.199,16.383-62.514,21.407-14.986,2.758-31.791,16.248-41.842,26.55,0,0,9.382,3.15,20.763,2.34,5.69-.405,17.815-1.993,23.435-9.988Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6225.273,2123.962s17.57-13.003,30.722-16.564c13.152-3.561,35.872-4.327,44.356-8.821,8.484-4.494,29.493-18.424,41.567-21.725,24.033-6.567,29.955-1.666,29.955-1.666,0,0-.425-5.387-1.982-6.079-5.992-2.665-17.127-2.168-28.808,1.93-11.681,4.099-15.793,7.492-27.25,15.283-10.052,6.835-17.041,11.265-27.236,12.724-10.195,1.459-24.518,1.591-33.125,4.823-9.176,3.446-24.799,14.761-28.199,20.094Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6296.669,2103.402c-3.07,.936-7.045,9.361-9.865,12.371-2.819,3.009-7.72,7.492-9.75,10.363-2.03,2.872,2.564,5.756,7.871,.334,5.307-5.421,7.2-8.917,11.386-14.197,4.186-5.281,6.317-10.687,.359-8.871Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6326.565,2092.261c-2.93,1.753-2.014,10.812-3.063,16.063-1.049,5.252-3.691,8.914-5.078,13.533-1.388,4.618,9.227,2.877,9.896-5.581,.671-8.457,.194-12.63,1.103-17.182,.91-4.552-.297-8.366-2.858-6.834Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6259.069,2109.363c-2.96,.819-12.533,4.415-17.041,7.301-4.509,2.886-8.528,6.962-9.647,8.923-1.12,1.961,9.322,.802,13.469-1.59,4.146-2.392,9.605-7.865,15.389-10.929,5.785-3.063,1.642-4.758-2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6353.376,2079.517c-3.354,.919-1.884,6.436-.679,12.065,1.206,5.629,.675,11.567,1.796,13.248,1.121,1.68,9.167-2.388,5.764-11.627-3.837-10.417-3.899-14.503-6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6252.754,2098.586c-3.675,.202-8.89,1.155-12.85,3.508-3.96,2.353-5.491,5.469-5.128,6.798,.363,1.329,7.52-2.688,10.756-4.206,3.236-1.518,7.087-1.856,11.441-3.44,2.913-1.061-1.444-2.812-4.218-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6280.279,2083.38c-3.6-.592-12.409-2.406-15.279-2.614-2.871-.21-6.135,.019-8.326,2.272s2.179,1.888,5.029,2.02c2.85,.133,8.815-1.661,13.031-.164,4.215,1.497,8.238,1.681,11.408,1.167,3.17-.513,3.31-3.033,.369-2.893-2.941,.141-3.699,.628-6.232,.211Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6285.779,2067.148c-2.347,.358-5.126,1.233-6.218,2.691-1.092,1.456,4.481,1.259,7.1,.544,2.619-.715,8.851-.926,12.45,.74,3.6,1.665,9.427,4.213,13.025,4.058,3.599-.155,6.12-.015,4.776-1.303-1.345-1.288-4.496-1.918-7.801-2.505-3.305-.587-8.806-3.058-12.064-3.823-3.258-.766-8.54-.816-11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6317.986,2055.376c-3.329,.192-10.321,.997-11.763,2.383-1.442,1.387,5.41,2.236,8.328,1.404,2.917-.832,9.849-.904,13.827,.327,3.978,1.231,9.691,2.153,12.121,.745,2.43-1.407-3.341-3.142-6.057-3.394-2.717-.252-12.788-1.679-16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6517.705,2083.378c-27.314-5.025-38.739-6.641-62.514-21.407-15.796-9.81-33.555-14.429-46.395-14.46,6.808-9.506,20.719-15.805,38.065-17.601,23.619-2.447,40.795,8.935,40.795,8.935,0,0-6.063,.888-10.65,.978-5.956,.118-10.396,.734-13.547,1.561-12.86,3.381-2.248,7.352-.342,6.964,6.587-1.339,15.263-5.84,27.558-4.798,5.332,.452,19.723,8.996,19.723,8.996,0,0-5.855,.082-12.128,1.986-6.793,2.061-20.093-.554-18.153,2.425,3.733,5.73,22.759,2.379,28.459,1.05,15.202-3.544,29.905,10.503,29.905,10.503-5.545-1.514-10.145-1.02-16.631-.92-4.756,.072-11.362-2.543-14.068-1.014-3.996,2.259,6.383,6.269,15.387,6.689,9.005,.42,17.159,1.821,23.627,10.259,7.518,9.808,12.751,26.402,12.751,26.402-10.051-10.3-26.855-23.792-41.842-26.549Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6515.348,2102.28c-6.668-9.486-14.565-11.323-16.171-9.846-3.211,2.954,17.054,21.417,17.054,21.417,0,0-15.762,3.765-29.15,1.069-7.679-1.547-11.858-13.012-15.878-19.446-2.988-4.785-5.573-7.019-8.311-7.147-2.142-.101-6.925,2.326-1.264,8.485,2.914,3.171,12.456,16,12.456,16,0,0-16.398,3.063-31.815-8.354-5.845-4.328-4.78-16.615-6.179-23.447-.973-4.756-2.75-10.54-5.746-5.629-.464,.76-2.495,6.263,.215,11.729,3.16,6.374,3.585,9.907,4.232,15.636-27.545-16.725-31.655-31.44-30.435-43.729,.419-4.221,1.978-8.068,4.44-11.507,12.84,.031,30.599,4.65,46.395,14.46,23.776,14.766,35.2,16.382,62.514,21.407,14.986,2.757,31.791,16.248,41.842,26.549,0,0-9.382,3.15-20.763,2.341-5.691-.404-17.815-1.993-23.436-9.987Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6551.23,2102.003s-17.57-13.003-30.722-16.564c-13.152-3.561-35.872-4.328-44.356-8.821-8.483-4.494-29.492-18.424-41.566-21.724-24.033-6.567-29.955-1.666-29.955-1.666,0,0,.425-5.387,1.982-6.079,5.992-2.665,17.126-2.169,28.808,1.93,11.68,4.099,15.792,7.492,27.249,15.282,10.052,6.836,17.041,11.265,27.236,12.724,10.195,1.46,24.517,1.591,33.125,4.824,9.177,3.447,24.8,14.762,28.199,20.095Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6479.834,2081.444c3.07,.935,7.044,9.361,9.864,12.371,2.82,3.009,7.721,7.491,9.75,10.363,2.03,2.872-2.564,5.755-7.87,.334-5.306-5.421-7.2-8.917-11.386-14.198-4.186-5.28-6.317-10.687-.358-8.87Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6449.937,2070.302c2.93,1.753,2.014,10.812,3.063,16.064,1.049,5.252,3.691,8.913,5.078,13.532,1.387,4.619-9.227,2.877-9.897-5.581-.671-8.457-.193-12.63-1.103-17.182-.909-4.551,.298-8.365,2.859-6.833Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6517.433,2087.405c2.961,.818,12.533,4.414,17.042,7.3,4.509,2.886,8.527,6.962,9.647,8.923,1.119,1.961-9.323,.803-13.47-1.589-4.147-2.392-9.604-7.865-15.389-10.928-5.784-3.063-1.641-4.759,2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6423.127,2057.558c3.354,.919,1.885,6.437,.679,12.066-1.206,5.629-.675,11.567-1.796,13.247-1.12,1.68-9.166-2.388-5.764-11.627,3.837-10.416,3.9-14.503,6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6523.749,2076.627c3.675,.202,8.89,1.155,12.851,3.508,3.96,2.353,5.491,5.469,5.127,6.799-.363,1.33-7.52-2.688-10.755-4.206-3.237-1.518-7.088-1.855-11.441-3.441-2.914-1.061,1.444-2.812,4.217-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6496.223,2061.421c3.6-.592,12.409-2.406,15.279-2.615,2.872-.21,6.136,.02,8.326,2.273,2.19,2.253-2.179,1.888-5.029,2.02-2.849,.132-8.815-1.662-13.03-.164-4.216,1.497-8.239,1.681-11.409,1.168-3.17-.513-3.31-3.034-.368-2.893,2.941,.141,3.699,.628,6.231,.212Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6490.724,2045.189c2.347,.357,5.125,1.234,6.218,2.691,1.091,1.457-4.482,1.259-7.101,.544-2.619-.715-8.851-.927-12.45,.739-3.599,1.665-9.426,4.212-13.025,4.058-3.599-.155-6.119-.016-4.775-1.304,1.344-1.288,4.496-1.917,7.801-2.505,3.305-.588,8.806-3.058,12.063-3.824s8.54-.815,11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6458.517,2033.418c3.328,.192,10.321,.997,11.763,2.384,1.442,1.386-5.41,2.235-8.327,1.403-2.917-.831-9.85-.903-13.828,.327-3.977,1.232-9.69,2.153-12.12,.746-2.43-1.407,3.34-3.142,6.058-3.394,2.716-.251,12.788-1.678,16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6421.995,2093.328s-23.873,38.912-19.282,57.063c4.592,18.151,16.208,31.268,19.282,51.834,2.004,13.405,.293,20.491,.293,20.491,0,0-3.764,4.462-7.077,.365,.573-5.45,.993-14.846-1.056-24.919-2.592-12.743-8.239-26.682-12.593-36.328-7.795-17.272-4.929-31.862,3.942-49.384,4.17-8.237,16.491-19.122,16.491-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6495.76,2168.104c-9.624-4.325-28.953-20.1-32.889-28.848-3.936-8.748-7.901-18.498-14.29-26.703-6.388-8.204-14.505-15.919-24.47-17.593-3.696-.62-7.221-1.117-10.2-1.498,2.69-1.382,5.747-2.427,9.236-4.028,15.545-7.131,37.831-2.127,49.056,4.089s15.881,10.267,15.881,10.267c0,0-8.148-.51-12.25-1.286-6.605-1.25-12.615-.305-13.343,1.655-1.456,3.922,1.653,3.864,8.284,2.857,6.632-1.007,16.926,.622,21.7,3.715,5.544,3.593,17.86,19.889,17.86,19.889,0,0-12.701-.676-25.971-2.387-5.957-.769-3.922,4.311-2.064,4.886,8.681,2.688,24.568-2.311,28.972,3.011,4.73,5.715,7.388,21.349,7.388,21.349,0,0-16.49,.252-23.153-1.142-6.662-1.394-11.035,2.184-5.667,4.106,5.369,1.922,23.383,2.166,28.761,4.465,3.619,4.193,4.757,14.105,4.661,19.639-.097,5.534-1.354,14.138-2.396,19.942-4.483-13.434-15.482-32.059-25.106-36.384Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6482.251,2174.511c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6482.251,2174.511c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6411.629,2094.829s12.931-1.216,23.412,6.72c7.363,5.575,13.54,11.004,19.588,27.203,4.399,11.781,17.34,24.775,23.23,29.404,5.889,4.628,14.248,8.192,24.011,16.705,9.762,8.512,17.069,24.593,17.069,24.593,0,0-6.563-19.485-15.807-27.171-9.243-7.687-20.014-11.016-29.135-21.312-9.12-10.296-13.475-22.086-16.582-28.928-3.106-6.841-12.556-19.072-20.132-23.621-7.577-4.549-20.939-10.029-25.654-3.592Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6482.998,2138.891c5.665,.447,13.222-.592,18.887,1.048,5.665,1.64,5.394,5.372,6.399,9.453,1.004,4.081-8.783,3.194-15.952,2.713-7.169-.482-13.079-6.468-16.145-9.495-3.065-3.027,1.3-4.153,6.812-3.719Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6467.101,2112.3c7.475-.732,14.722-.884,21.182,1.539,6.459,2.423,8.679,7.148,8.228,9.493-.452,2.344-6.664-.851-14.935-1.146-8.271-.294-13.71,2.613-17.452-1.058-3.742-3.671-3.867-8.158,2.978-8.827Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6444.777,2090.176c8.272-.391,14.287,1.307,18.403,3.842,4.116,2.534-1.242,4.172-6.28,3.814-5.037-.357-12.295-.645-17.774-4.055-5.48-3.41,.486-3.357,5.651-3.601Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6511.608,2168.953c4.721,.873,7.143,8.831,7.356,12.418,.212,3.587-3.381,.796-7.395-4.474-4.014-5.27-5.549-8.977,.039-7.944Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6495.307,2176.276c4.486,1.564,12.438,8.816,12.913,14.6,.474,5.785-8.827,5.382-13.457-1.485-4.629-6.866-8.857-16.394,.544-13.115Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6464.507,2156.835c3,2.647,6.292,16.81,6.317,22.889,.025,6.079-11.527,.772-14.969-5.778-3.442-6.551,1.648-23.29,8.652-17.111Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6441.724,2119.788c4.484,4.111,.397,11.374-.419,18.6-.817,7.225,.73,19.15-.863,22.54-1.592,3.388-11.257-1.771-12.709-10.311-1.452-8.541,1.722-21.552,4.05-26.2,2.328-4.647,6.659-7.637,9.941-4.628Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6420.295,2101.31c6.008-1.442,7.802,4.764,3.76,12.668-4.042,7.905-5.715,18.11-8.185,20.231-2.471,2.121-8.445-4.674-7.064-14.894,1.38-10.219,5.044-16.459,11.49-18.006Z",
    fill: "#2ca348",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6373.694,2112.253s23.874,38.912,19.282,57.063c-4.591,18.151-16.208,31.268-19.282,51.834-2.004,13.405-.293,20.491-.293,20.491,0,0,3.764,4.462,7.077,.364-.573-5.45-.993-14.846,1.056-24.918,2.592-12.744,8.239-26.682,12.593-36.329,7.795-17.272,4.929-31.861-3.943-49.383-4.17-8.237-16.49-19.122-16.49-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6310.876,2197.599c8.763-5.877,25.175-24.669,27.588-33.953,2.414-9.284,4.689-19.561,9.612-28.721,4.923-9.159,11.631-18.126,21.175-21.446,3.539-1.231,6.932-2.311,9.805-3.187-2.883-.911-6.073-1.429-9.781-2.422-16.52-4.425-37.652,4.244-47.676,12.253-10.024,8.01-13.936,12.784-13.936,12.784,0,0,7.947-1.868,11.862-3.321,6.302-2.339,12.385-2.415,13.432-.604,2.092,3.623-.982,4.086-7.689,4.205-6.706,.118-16.582,3.45-20.77,7.3-4.863,4.471-14.274,22.602-14.274,22.602,0,0,12.408-2.795,25.204-6.707,5.744-1.757,4.589,3.593,2.854,4.471-8.108,4.105-24.608,1.84-28.058,7.824-3.705,6.427-3.705,22.285-3.705,22.285,0,0,16.3-2.516,22.633-5.006,6.334-2.491,11.246,.303,6.275,3.098-4.97,2.794-22.689,6.054-27.606,9.223-2.865,4.741-2.326,14.703-1.302,20.143,1.024,5.439,3.705,13.711,5.705,19.258,2.167-13.996,9.889-34.2,18.652-40.078Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6325.267,2201.652c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6325.267,2201.652c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6381.534,2111.259s-12.952,.969-21.955,10.549c-6.324,6.73-11.504,13.117-14.751,30.102-2.361,12.352-12.943,27.331-17.973,32.882-5.03,5.55-12.673,10.465-20.871,20.493-8.197,10.029-12.705,27.106-12.705,27.106,0,0,3.204-20.309,11.029-29.437,7.824-9.127,17.884-14.215,25.15-25.894,7.266-11.68,9.583-24.033,11.498-31.299,1.916-7.266,9.181-20.907,15.888-26.662,6.706-5.754,18.961-13.396,24.689-7.841Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6318.561,2166.661c-5.51,1.39-13.134,1.633-18.444,4.2-5.31,2.566-4.417,6.199-4.724,10.391-.306,4.192,9.195,1.676,16.181,0,6.986-1.677,11.81-8.569,14.325-12.066,2.515-3.498-1.978-3.877-7.339-2.525Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6329.776,2137.781c-7.491,.532-14.662,1.596-20.623,5.068-5.962,3.471-7.359,8.501-6.52,10.737,.838,2.235,6.427-1.956,14.531-3.633,8.104-1.677,13.955,.277,17.029-3.97,3.074-4.246,2.445-8.69-4.416-8.203Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6348.076,2112.228c-8.221,1.002-13.866,3.684-17.499,6.872-3.633,3.188,1.924,3.905,6.831,2.708,4.906-1.196,12.013-2.697,16.843-6.977,4.83-4.28-1.042-3.228-6.175-2.603Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6295.393,2201.093c-4.507,1.652-5.562,9.903-5.17,13.475,.393,3.571,3.466,.218,6.54-5.65,3.074-5.868,3.967-9.781-1.37-7.824Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6312.692,2205.581c-4.16,2.294-10.785,10.776-10.283,16.557,.502,5.782,9.605,3.825,13.018-3.719,3.413-7.546,5.984-17.647-2.735-12.838Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6339.799,2181.252c-2.514,3.112-3.385,17.627-2.391,23.624,.994,5.997,11.493-1.171,13.789-8.205,2.295-7.035-5.529-22.684-11.398-15.418Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6356.049,2140.909c-3.731,4.805,1.515,11.28,3.53,18.267,2.016,6.986,2.491,19.002,4.629,22.076,2.138,3.074,10.801-3.633,10.801-12.296s-5.31-20.958-8.384-25.15c-3.074-4.192-7.845-6.413-10.576-2.897Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6374.077,2119.1c-6.164-.414-6.892,6.005-1.583,13.12,5.31,7.115,8.67,16.896,11.461,18.572,2.791,1.677,7.542-6.023,4.468-15.867-3.074-9.843-7.732-15.381-14.346-15.826Z",
    fill: "#2ca348",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3591.822,3705.461c-1.235-28.213,1.792-78.654,2.515-86.724,.722-8.069-2.958-15.031-13.92-26.209-10.96-11.178-44.292-10.33-57.569-17.885-15.063-8.569-22.383-6.773-35.797-5.713-11.823,.935-21.394,14.856-21.394,14.856,0,0,15.727-12.869,33.092-4.299,17.365,8.57,36.009,22.047,52.955,23.319,16.946,1.272,35.705,5.265,35.33,17.946-.025,.817-.127,1.58-.288,2.301,1.421,7.212-1.946,19.141-2.543,26.806-.769,9.868-2.29,38.573,0,70.965,2.084,29.495,6.782,50.048,7.845,55.729,5.462,6.136,8.813,.764,8.813,.764,0,0-7.805-43.643-9.04-71.856Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3551.704,3602.806c-16.946-1.272-35.59-14.749-52.955-23.319-17.365-8.57-33.092,4.299-33.092,4.299,0,0,9.011-3.602,27.54-.421,18.528,3.181,25.898,17.36,49.685,24.029,23.787,6.669,35.084,5.999,41.322,10.777,1.392,1.067,2.135,2.81,2.543,4.882,.161-.721,.263-1.484,.288-2.301,.375-12.681-18.385-16.674-35.33-17.946Z",
    fill: "#478e19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3477.963,3572.102s22.68-3.047,27.062,.679c4.382,3.726,.794,10.461,4.451,11.006,3.657,.544,2.448-6.649,4.543-7.896,2.095-1.248,5.821,4.714,14.018,6.205,8.197,1.49,3.071,4.401,5.222,10.433,2.151,6.032,3.8,2.609,5.25-1.49,1.45-4.099,1.006-6.334,10.543-5.217,9.537,1.118,14.982,1.49,14.495,5.217-.486,3.726-.859,9.324,2.494,8.761,3.354-.564,2.493-8.761,4.6-8.016,2.107,.745,6.795,2.284,11.422,8.016,4.627,5.731,9.935,13.431,12.194,19.883,1.778-9.455-3.269-21.006-16.029-30.396-13.638-7.815-31.521-9.524-44.969-12.742-12.706-3.041-19.286-8.673-30.186-8.673-18.346,0-25.11,4.232-25.11,4.232Z",
    fill: "#6ebc3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3583.158,3641.891s8.504-4.095,16.103,12.995c6.791,15.273,5.589,44.95-1.676,71.778-7.266,26.827-9.617,33.593-10.551,44.46-1.037,12.069,2.554,22.198,4.629,28.969-5.562,3.977-8.202-.494-8.202-.494,0,0-8.453-18.042-3.871-38.223,4.581-20.182,13.524-27.992,16.877-56.503,3.353-28.511,1.118-44.141-5.03-50.857-6.148-6.716-9.653-7.834-9.653-7.834l1.374-4.291Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3631.788,3620.112s-8.504-4.095-16.103,12.996c-6.791,15.272-5.589,44.95,1.677,71.777,7.265,26.827,9.616,33.593,10.55,44.461,1.037,12.069-2.554,22.198-4.629,28.968,5.563,3.978,8.202-.493,8.202-.493,0,0,8.453-18.042,3.872-38.224-4.582-20.181-13.524-27.992-16.878-56.503-3.353-28.51-1.117-44.141,5.03-50.857,6.148-6.716,9.653-7.834,9.653-7.834l-1.374-4.292Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3478.125,3678.578c27.314-5.024,38.739-6.641,62.514-21.407,15.796-9.81,33.556-14.429,46.395-14.46-6.807-9.505-20.719-15.805-38.064-17.601-23.62-2.447-40.796,8.935-40.796,8.935,0,0,6.063,.887,10.649,.977,5.957,.118,10.397,.734,13.547,1.562,12.861,3.381,2.249,7.351,.342,6.964-6.586-1.339-15.262-5.839-27.557-4.798-5.332,.453-19.724,8.996-19.724,8.996,0,0,5.856,.082,12.128,1.986,6.792,2.061,20.093-.554,18.153,2.425-3.733,5.731-22.759,2.38-28.459,1.051-15.202-3.544-29.905,10.502-29.905,10.502,5.545-1.513,10.145-1.019,16.631-.92,4.757,.073,11.363-2.543,14.068-1.014,3.996,2.259-6.383,6.269-15.388,6.69-9.004,.42-17.158,1.82-23.627,10.259-7.518,9.808-12.751,26.403-12.751,26.403,10.05-10.301,26.855-23.792,41.842-26.55Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3480.482,3697.48c6.669-9.486,14.566-11.323,16.171-9.846,3.211,2.955-17.053,21.417-17.053,21.417,0,0,15.762,3.765,29.15,1.069,7.678-1.547,11.858-13.012,15.877-19.447,2.989-4.785,5.574-7.018,8.311-7.147,2.142-.1,6.925,2.326,1.265,8.485-2.914,3.171-12.456,16-12.456,16,0,0,16.398,3.063,31.816-8.354,5.844-4.328,4.779-16.615,6.178-23.447,.974-4.756,2.75-10.54,5.746-5.629,.464,.761,2.495,6.264-.215,11.73-3.16,6.373-3.585,9.906-4.232,15.635,27.544-16.725,31.656-31.44,30.435-43.728-.419-4.221-1.978-8.068-4.441-11.507-12.839,.03-30.598,4.65-46.395,14.46-23.775,14.766-35.199,16.383-62.514,21.407-14.986,2.758-31.791,16.248-41.842,26.55,0,0,9.382,3.15,20.763,2.34,5.69-.405,17.815-1.993,23.435-9.988Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3444.6,3697.203s17.57-13.003,30.722-16.564c13.152-3.561,35.872-4.327,44.356-8.821,8.484-4.494,29.493-18.424,41.567-21.725,24.033-6.567,29.955-1.666,29.955-1.666,0,0-.425-5.387-1.982-6.079-5.992-2.665-17.127-2.168-28.808,1.93-11.681,4.099-15.793,7.492-27.25,15.283-10.052,6.835-17.041,11.265-27.236,12.724-10.195,1.459-24.518,1.591-33.125,4.823-9.176,3.446-24.799,14.761-28.199,20.094Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3515.997,3676.644c-3.07,.936-7.045,9.361-9.865,12.371-2.819,3.009-7.72,7.492-9.75,10.363-2.03,2.872,2.564,5.756,7.871,.334,5.307-5.421,7.2-8.917,11.386-14.197,4.186-5.281,6.317-10.687,.359-8.871Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3545.893,3665.503c-2.93,1.753-2.014,10.812-3.063,16.063-1.049,5.252-3.691,8.914-5.078,13.533-1.388,4.618,9.227,2.877,9.896-5.581,.671-8.457,.194-12.63,1.103-17.182,.91-4.552-.297-8.366-2.858-6.834Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3478.397,3682.605c-2.96,.819-12.533,4.415-17.041,7.301-4.509,2.886-8.528,6.962-9.647,8.923-1.12,1.961,9.322,.802,13.469-1.59,4.146-2.392,9.605-7.865,15.389-10.929,5.785-3.063,1.642-4.758-2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3572.704,3652.759c-3.354,.919-1.884,6.436-.679,12.065,1.206,5.629,.675,11.567,1.796,13.248,1.121,1.68,9.167-2.388,5.764-11.627-3.837-10.417-3.899-14.503-6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3472.081,3671.828c-3.675,.202-8.89,1.155-12.85,3.508-3.96,2.353-5.491,5.469-5.128,6.798,.363,1.329,7.52-2.688,10.756-4.206,3.236-1.518,7.087-1.856,11.441-3.44,2.913-1.061-1.444-2.812-4.218-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3499.607,3656.621c-3.6-.592-12.409-2.406-15.279-2.614-2.871-.21-6.135,.019-8.326,2.272s2.179,1.888,5.029,2.02c2.85,.133,8.815-1.661,13.031-.164,4.215,1.497,8.238,1.681,11.408,1.167,3.17-.513,3.31-3.033,.369-2.893-2.941,.141-3.699,.628-6.232,.211Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3505.107,3640.39c-2.347,.358-5.126,1.233-6.218,2.691-1.092,1.456,4.481,1.259,7.1,.544,2.619-.715,8.851-.926,12.45,.74,3.6,1.665,9.427,4.213,13.025,4.058,3.599-.155,6.12-.015,4.776-1.303-1.345-1.288-4.496-1.918-7.801-2.505-3.305-.587-8.806-3.058-12.064-3.823-3.258-.766-8.54-.816-11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3537.313,3628.618c-3.329,.192-10.321,.997-11.763,2.383-1.442,1.387,5.41,2.236,8.328,1.404,2.917-.832,9.849-.904,13.827,.327,3.978,1.231,9.691,2.153,12.121,.745,2.43-1.407-3.341-3.142-6.057-3.394-2.717-.252-12.788-1.679-16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3737.033,3656.619c-27.314-5.025-38.739-6.641-62.514-21.407-15.796-9.81-33.555-14.429-46.395-14.46,6.808-9.506,20.719-15.805,38.065-17.601,23.619-2.447,40.795,8.935,40.795,8.935,0,0-6.063,.888-10.65,.978-5.956,.118-10.396,.734-13.547,1.561-12.86,3.381-2.248,7.352-.342,6.964,6.587-1.339,15.263-5.84,27.558-4.798,5.332,.452,19.723,8.996,19.723,8.996,0,0-5.855,.082-12.128,1.986-6.793,2.061-20.093-.554-18.153,2.425,3.733,5.73,22.759,2.379,28.459,1.05,15.202-3.544,29.905,10.503,29.905,10.503-5.545-1.514-10.145-1.02-16.631-.92-4.756,.072-11.362-2.543-14.068-1.014-3.996,2.259,6.383,6.269,15.387,6.689,9.005,.42,17.159,1.821,23.627,10.259,7.518,9.808,12.751,26.402,12.751,26.402-10.051-10.3-26.855-23.792-41.842-26.549Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3734.676,3675.522c-6.668-9.486-14.565-11.323-16.171-9.846-3.211,2.954,17.054,21.417,17.054,21.417,0,0-15.762,3.765-29.15,1.069-7.679-1.547-11.858-13.012-15.878-19.446-2.988-4.785-5.573-7.019-8.311-7.147-2.142-.101-6.925,2.326-1.264,8.485,2.914,3.171,12.456,16,12.456,16,0,0-16.398,3.063-31.815-8.354-5.845-4.328-4.78-16.615-6.179-23.447-.973-4.756-2.75-10.54-5.746-5.629-.464,.76-2.495,6.263,.215,11.729,3.16,6.374,3.585,9.907,4.232,15.636-27.545-16.725-31.655-31.44-30.435-43.729,.419-4.221,1.978-8.068,4.44-11.507,12.84,.031,30.599,4.65,46.395,14.46,23.776,14.766,35.2,16.382,62.514,21.407,14.986,2.757,31.791,16.248,41.842,26.549,0,0-9.382,3.15-20.763,2.341-5.691-.404-17.815-1.993-23.436-9.987Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3770.557,3675.245s-17.57-13.003-30.722-16.564c-13.152-3.561-35.872-4.328-44.356-8.821-8.483-4.494-29.492-18.424-41.566-21.724-24.033-6.567-29.955-1.666-29.955-1.666,0,0,.425-5.387,1.982-6.079,5.992-2.665,17.126-2.169,28.808,1.93,11.68,4.099,15.792,7.492,27.249,15.282,10.052,6.836,17.041,11.265,27.236,12.724,10.195,1.46,24.517,1.591,33.125,4.824,9.177,3.447,24.8,14.762,28.199,20.095Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3699.161,3654.685c3.07,.935,7.044,9.361,9.864,12.371,2.82,3.009,7.721,7.491,9.75,10.363,2.03,2.872-2.564,5.755-7.87,.334-5.306-5.421-7.2-8.917-11.386-14.198-4.186-5.28-6.317-10.687-.358-8.87Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3669.265,3643.544c2.93,1.753,2.014,10.812,3.063,16.064,1.049,5.252,3.691,8.913,5.078,13.532,1.387,4.619-9.227,2.877-9.897-5.581-.671-8.457-.193-12.63-1.103-17.182-.909-4.551,.298-8.365,2.859-6.833Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3736.761,3660.646c2.961,.818,12.533,4.414,17.042,7.3,4.509,2.886,8.527,6.962,9.647,8.923,1.119,1.961-9.323,.803-13.47-1.589-4.147-2.392-9.604-7.865-15.389-10.928-5.784-3.063-1.641-4.759,2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3642.454,3630.8c3.354,.919,1.885,6.437,.679,12.066-1.206,5.629-.675,11.567-1.796,13.247-1.12,1.68-9.166-2.388-5.764-11.627,3.837-10.416,3.9-14.503,6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3743.076,3649.869c3.675,.202,8.89,1.155,12.851,3.508,3.96,2.353,5.491,5.469,5.127,6.799-.363,1.33-7.52-2.688-10.755-4.206-3.237-1.518-7.088-1.855-11.441-3.441-2.914-1.061,1.444-2.812,4.217-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3715.551,3634.663c3.6-.592,12.409-2.406,15.279-2.615,2.872-.21,6.136,.02,8.326,2.273,2.19,2.253-2.179,1.888-5.029,2.02-2.849,.132-8.815-1.662-13.03-.164-4.216,1.497-8.239,1.681-11.409,1.168-3.17-.513-3.31-3.034-.368-2.893,2.941,.141,3.699,.628,6.231,.212Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3710.051,3618.431c2.347,.357,5.125,1.234,6.218,2.691,1.091,1.457-4.482,1.259-7.101,.544-2.619-.715-8.851-.927-12.45,.739-3.599,1.665-9.426,4.212-13.025,4.058-3.599-.155-6.119-.016-4.775-1.304,1.344-1.288,4.496-1.917,7.801-2.505,3.305-.588,8.806-3.058,12.063-3.824s8.54-.815,11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3677.844,3606.659c3.328,.192,10.321,.997,11.763,2.384,1.442,1.386-5.41,2.235-8.327,1.403-2.917-.831-9.85-.903-13.828,.327-3.977,1.232-9.69,2.153-12.12,.746-2.43-1.407,3.34-3.142,6.058-3.394,2.716-.251,12.788-1.678,16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3641.323,3666.569s-23.873,38.912-19.282,57.063c4.592,18.151,16.208,31.268,19.282,51.834,2.004,13.405,.293,20.491,.293,20.491,0,0-3.764,4.462-7.077,.365,.573-5.45,.993-14.846-1.056-24.919-2.592-12.743-8.239-26.682-12.593-36.328-7.795-17.272-4.929-31.862,3.942-49.384,4.17-8.237,16.491-19.122,16.491-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3715.088,3741.346c-9.624-4.325-28.953-20.1-32.889-28.848-3.936-8.748-7.901-18.498-14.29-26.703-6.388-8.204-14.505-15.919-24.47-17.593-3.696-.62-7.221-1.117-10.2-1.498,2.69-1.382,5.747-2.427,9.236-4.028,15.545-7.131,37.831-2.127,49.056,4.089s15.881,10.267,15.881,10.267c0,0-8.148-.51-12.25-1.286-6.605-1.25-12.615-.305-13.343,1.655-1.456,3.922,1.653,3.864,8.284,2.857,6.632-1.007,16.926,.622,21.7,3.715,5.544,3.593,17.86,19.889,17.86,19.889,0,0-12.701-.676-25.971-2.387-5.957-.769-3.922,4.311-2.064,4.886,8.681,2.688,24.568-2.311,28.972,3.011,4.73,5.715,7.388,21.349,7.388,21.349,0,0-16.49,.252-23.153-1.142-6.662-1.394-11.035,2.184-5.667,4.106,5.369,1.922,23.383,2.166,28.761,4.465,3.619,4.193,4.757,14.105,4.661,19.639-.097,5.534-1.354,14.138-2.396,19.942-4.483-13.434-15.482-32.059-25.106-36.384Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3701.579,3747.753c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3701.579,3747.753c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3630.957,3668.071s12.931-1.216,23.412,6.72c7.363,5.575,13.54,11.004,19.588,27.203,4.399,11.781,17.34,24.775,23.23,29.404,5.889,4.628,14.248,8.192,24.011,16.705,9.762,8.512,17.069,24.593,17.069,24.593,0,0-6.563-19.485-15.807-27.171-9.243-7.687-20.014-11.016-29.135-21.312-9.12-10.296-13.475-22.086-16.582-28.928-3.106-6.841-12.556-19.072-20.132-23.621-7.577-4.549-20.939-10.029-25.654-3.592Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3702.326,3712.133c5.665,.447,13.222-.592,18.887,1.048,5.665,1.64,5.394,5.372,6.399,9.453,1.004,4.081-8.783,3.194-15.952,2.713-7.169-.482-13.079-6.468-16.145-9.495-3.065-3.027,1.3-4.153,6.812-3.719Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3686.428,3685.542c7.475-.732,14.722-.884,21.182,1.539,6.459,2.423,8.679,7.148,8.228,9.493-.452,2.344-6.664-.851-14.935-1.146-8.271-.294-13.71,2.613-17.452-1.058-3.742-3.671-3.867-8.158,2.978-8.827Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3664.104,3663.418c8.272-.391,14.287,1.307,18.403,3.842,4.116,2.534-1.242,4.172-6.28,3.814-5.037-.357-12.295-.645-17.774-4.055-5.48-3.41,.486-3.357,5.651-3.601Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3730.936,3742.194c4.721,.873,7.143,8.831,7.356,12.418,.212,3.587-3.381,.796-7.395-4.474-4.014-5.27-5.549-8.977,.039-7.944Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3714.635,3749.518c4.486,1.564,12.438,8.816,12.913,14.6,.474,5.785-8.827,5.382-13.457-1.485-4.629-6.866-8.857-16.394,.544-13.115Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3683.834,3730.077c3,2.647,6.292,16.81,6.317,22.889,.025,6.079-11.527,.772-14.969-5.778-3.442-6.551,1.648-23.29,8.652-17.111Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3661.051,3693.03c4.484,4.111,.397,11.374-.419,18.6-.817,7.225,.73,19.15-.863,22.54-1.592,3.388-11.257-1.771-12.709-10.311-1.452-8.541,1.722-21.552,4.05-26.2,2.328-4.647,6.659-7.637,9.941-4.628Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3639.623,3674.551c6.008-1.442,7.802,4.764,3.76,12.668-4.042,7.905-5.715,18.11-8.185,20.231-2.471,2.121-8.445-4.674-7.064-14.894,1.38-10.219,5.044-16.459,11.49-18.006Z",
    fill: "#2ca348",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3593.022,3685.494s23.874,38.912,19.282,57.063c-4.591,18.151-16.208,31.268-19.282,51.834-2.004,13.405-.293,20.491-.293,20.491,0,0,3.764,4.462,7.077,.364-.573-5.45-.993-14.846,1.056-24.918,2.592-12.744,8.239-26.682,12.593-36.329,7.795-17.272,4.929-31.861-3.943-49.383-4.17-8.237-16.49-19.122-16.49-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3530.203,3770.841c8.763-5.877,25.175-24.669,27.588-33.953,2.414-9.284,4.689-19.561,9.612-28.721,4.923-9.159,11.631-18.126,21.175-21.446,3.539-1.231,6.932-2.311,9.805-3.187-2.883-.911-6.073-1.429-9.781-2.422-16.52-4.425-37.652,4.244-47.676,12.253-10.024,8.01-13.936,12.784-13.936,12.784,0,0,7.947-1.868,11.862-3.321,6.302-2.339,12.385-2.415,13.432-.604,2.092,3.623-.982,4.086-7.689,4.205-6.706,.118-16.582,3.45-20.77,7.3-4.863,4.471-14.274,22.602-14.274,22.602,0,0,12.408-2.795,25.204-6.707,5.744-1.757,4.589,3.593,2.854,4.471-8.108,4.105-24.608,1.84-28.058,7.824-3.705,6.427-3.705,22.285-3.705,22.285,0,0,16.3-2.516,22.633-5.006,6.334-2.491,11.246,.303,6.275,3.098-4.97,2.794-22.689,6.054-27.606,9.223-2.865,4.741-2.326,14.703-1.302,20.143,1.024,5.439,3.705,13.711,5.705,19.258,2.167-13.996,9.889-34.2,18.652-40.078Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3544.595,3774.894c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3544.595,3774.894c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3600.862,3684.501s-12.952,.969-21.955,10.549c-6.324,6.73-11.504,13.117-14.751,30.102-2.361,12.352-12.943,27.331-17.973,32.882-5.03,5.55-12.673,10.465-20.871,20.493-8.197,10.029-12.705,27.106-12.705,27.106,0,0,3.204-20.309,11.029-29.437,7.824-9.127,17.884-14.215,25.15-25.894,7.266-11.68,9.583-24.033,11.498-31.299,1.916-7.266,9.181-20.907,15.888-26.662,6.706-5.754,18.961-13.396,24.689-7.841Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3537.888,3739.903c-5.51,1.39-13.134,1.633-18.444,4.2-5.31,2.566-4.417,6.199-4.724,10.391-.306,4.192,9.195,1.676,16.181,0,6.986-1.677,11.81-8.569,14.325-12.066,2.515-3.498-1.978-3.877-7.339-2.525Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3549.103,3711.023c-7.491,.532-14.662,1.596-20.623,5.068-5.962,3.471-7.359,8.501-6.52,10.737,.838,2.235,6.427-1.956,14.531-3.633,8.104-1.677,13.955,.277,17.029-3.97,3.074-4.246,2.445-8.69-4.416-8.203Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3567.403,3685.47c-8.221,1.002-13.866,3.684-17.499,6.872-3.633,3.188,1.924,3.905,6.831,2.708,4.906-1.196,12.013-2.697,16.843-6.977,4.83-4.28-1.042-3.228-6.175-2.603Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3514.721,3774.335c-4.507,1.652-5.562,9.903-5.17,13.475,.393,3.571,3.466,.218,6.54-5.65,3.074-5.868,3.967-9.781-1.37-7.824Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3532.02,3778.822c-4.16,2.294-10.785,10.776-10.283,16.557,.502,5.782,9.605,3.825,13.018-3.719,3.413-7.546,5.984-17.647-2.735-12.838Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3559.126,3754.494c-2.514,3.112-3.385,17.627-2.391,23.624,.994,5.997,11.493-1.171,13.789-8.205,2.295-7.035-5.529-22.684-11.398-15.418Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3575.376,3714.151c-3.731,4.805,1.515,11.28,3.53,18.267,2.016,6.986,2.491,19.002,4.629,22.076,2.138,3.074,10.801-3.633,10.801-12.296s-5.31-20.958-8.384-25.15c-3.074-4.192-7.845-6.413-10.576-2.897Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3593.404,3692.342c-6.164-.414-6.892,6.005-1.583,13.12,5.31,7.115,8.67,16.896,11.461,18.572,2.791,1.677,7.542-6.023,4.468-15.867-3.074-9.843-7.732-15.381-14.346-15.826Z",
    fill: "#2ca348",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5803.931,2330.856c28.146,19.625,57.318-8.363,88.855,11.754,6.412,4.089,11.714,10.244,15.736,16.833,5.904-10.444,5.752-26.41-13.614-40.193-20.365-14.493-29.536-16.358-47.754-19.819-18.217-3.46-18.888,6.331-28.489,12.104-9.602,5.773-15.379,.699-30.097,7.136-14.719,6.437-16.615,26.736-16.615,26.736,0,0,3.833-34.175,31.978-14.552Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5788.882,2341.273c5.773,9.601,22.928,18.227,33.474,20.244,18.542,3.546,52.222-7.936,66.155-2.992,4.804,1.704,16.47,7.184,20.01,.919-4.023-6.59-9.324-12.745-15.736-16.833-31.537-20.117-60.709,7.871-88.855-11.754-28.146-19.623-31.978,14.552-31.978,14.552,0,0,11.156-13.737,16.93-4.135Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5788.882,2341.273c5.773,9.601,22.928,18.227,33.474,20.244,18.542,3.546,51.104-7.79,66.155-2.992,4.857,1.547,16.47,7.184,20.01,.919-4.023-6.59-9.324-12.745-15.736-16.833-31.537-20.117-60.709,7.871-88.855-11.754-28.146-19.623-31.978,14.552-31.978,14.552,0,0,11.156-13.737,16.93-4.135Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5813.788,2313.654s10.855,3.345,23.655,8.202c12.103,4.593,24.246,4.026,38.298,4.576,5.282,.207,10.641,1.435,15.71,5.876,9.037,7.918,13.355,25.92,13.843,31.359,.309,3.459-1.237,21.195,1.58,31.4,4.098,14.843,12.945,22.792,12.945,22.792l3.025-2.428s-7.613-8.16-10.77-21.352c-2.882-12.04-1.282-28.908-2.282-34.8-2.284-13.45-7.048-25.641-17.496-32.621-9.723-6.494-28.701-2.374-42.631-5.688-13.928-3.314-30.998-9.435-30.998-9.435l-4.877,2.118Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5839.511,2326.477c-5.225-1.92-18.308-5.773-25.058-7.691-6.75-1.918-10.374,.648-12.912,2.606-2.539,1.958,1.717,5.362,9.327,7.868,7.611,2.504,20.236,4.824,26.731,2.818,6.495-2.006,8.467-3.193,1.912-5.6Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5844.69,2304.16c-5.261-.274-11.167,.749-12.97,3.544-1.803,2.794,8.739,9.469,18.84,8.909,10.101-.56,19.325-1.23,14.547-5.761-4.777-4.531-14.069-6.363-20.418-6.692Z",
    fill: "#6ebc3b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6034.162,2330.783c-28.127,19.652-57.326-8.307-88.843,11.839-6.409,4.096-11.705,10.256-15.719,16.849-5.914-10.438-5.778-26.405,13.576-40.206,20.35-14.513,29.519-16.387,47.733-19.864,18.213-3.478,18.895,6.312,28.502,12.076,9.607,5.764,15.38,.686,30.104,7.109,14.725,6.422,16.641,26.72,16.641,26.72,0,0-3.865-34.173-31.993-14.522Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6049.221,2341.185c-5.764,9.608-22.91,18.249-33.455,20.276-18.538,3.565-52.23-7.884-66.159-2.928-4.802,1.708-16.461,7.2-20.008,.938,4.015-6.593,9.311-12.754,15.719-16.849,31.517-20.146,60.716,7.813,88.843-11.839,28.128-19.652,31.993,14.522,31.993,14.522,0,0-11.17-13.727-16.934-4.12Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6049.221,2341.185c-5.764,9.608-22.91,18.249-33.455,20.276-18.538,3.565-51.111-7.741-66.159-2.928-4.854,1.553-16.461,7.2-20.008,.938,4.015-6.593,9.311-12.754,15.719-16.849,31.517-20.146,60.716,7.813,88.843-11.839,28.128-19.652,31.993,14.522,31.993,14.522,0,0-11.17-13.727-16.934-4.12Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6024.29,2313.591s-10.852,3.355-23.648,8.224c-12.098,4.605-24.242,4.049-38.293,4.614-5.281,.211-10.638,1.444-15.704,5.891-9.029,7.925-13.33,25.932-13.812,31.372-.307,3.459,1.257,21.193-1.55,31.401-4.083,14.847-12.924,22.804-12.924,22.804l-3.025-2.426s7.605-8.167,10.749-21.361c2.87-12.044,1.254-28.91,2.249-34.802,2.271-13.454,7.023-25.648,17.465-32.638,9.716-6.505,28.7-2.403,42.625-5.73,13.926-3.329,30.989-9.465,30.989-9.465l4.879,2.115Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5998.579,2326.437c5.223-1.924,18.302-5.79,25.05-7.713,6.748-1.924,10.375,.637,12.915,2.593,2.542,1.956-1.712,5.364-9.32,7.877-7.608,2.512-20.232,4.843-26.728,2.843-6.496-2-8.471-3.184-1.917-5.6Z",
    fill: "#2ca348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5993.377,2304.126c5.261-.279,11.168,.739,12.973,3.53,1.805,2.793-8.73,9.479-18.831,8.928-10.102-.55-19.325-1.21-14.553-5.747,4.772-4.536,14.063-6.376,20.411-6.712Z",
    fill: "#2ca348"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5969.119,2339.003c-3.298,1.454-8.88-.133-19.267,12.562-10.213,12.482-14.143,30.776-14.143,30.776,0,0-5.27,10.85-5.279,6.615-.004-2.134,4.119-11.966,5.279-16.849,4.219-17.752,18.697-38.704,37.09-38.406,14.792,.242-3.68,5.302-3.68,5.302Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5908.768,2380.185s3.861-8.771,10.47-10.849c6.609-2.076,13.17,5.468,13.121,13.004-.049,7.538-3.147,6.731-3.56,7.597-.413,.864-.182-9.64-2.26-13.043-2.076-3.404-5.674-.172-10.532,3.335-4.857,3.507-7.24-.045-7.24-.045Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6047.837,2384.254c-6.62-8.214-3.4-15.594-16.807-18.417-13.406-2.823-15.789-11.319-21.556-19.976-5.767-8.657-25.61-11.986-36.674-12.161,.664-.838,1.333-1.622,1.999-2.346,13.675-14.893,28.659-21.935,45.471-18.193,16.811,3.742,23.349,13.975,22.595,25.701-.755,11.727-1.786,16.148,9.954,22.509,11.74,6.362,6.468,17.819,5.659,24.953-.807,7.134,11.231,13.441,11.231,13.441-9.217-2.024-15.255-7.299-21.872-15.512Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6042.004,2400.808c-6.82-3.561-14.668-18.38-23.642-16.636-8.975,1.742-31.985,11.159-46.466,.281-18.113-13.608-9.077-38.173,.903-50.751,11.064,.175,30.907,3.504,36.674,12.161,5.767,8.656,8.15,17.153,21.556,19.976,13.407,2.823,10.187,10.203,16.807,18.417,6.617,8.214,12.655,13.489,21.872,15.512,0,0-20.885,4.604-27.704,1.041Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5977.413,2348.437c7.567-5.399,15.569,1.737,22.854,12.821,7.285,11.084,7.696,19.942-8.728,15.941-16.424-4-23.133-22.337-14.126-28.762Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6042.004,2400.808c-6.82-3.561-14.668-18.38-23.642-16.636-8.975,1.742-31.985,11.159-46.466,.281-18.113-13.608-9.077-38.173,.903-50.751,11.064,.175,30.907,3.504,36.674,12.161,5.767,8.656,8.15,17.153,21.556,19.976,13.407,2.823,10.187,10.203,16.807,18.417,6.617,8.214,12.655,13.489,21.872,15.512,0,0-20.885,4.604-27.704,1.041Z",
    fill: "#279136",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6002.039,2322.794c13.506-5.493,23.629-3.257,28.727,3.94,5.096,7.197-3.027,12.547-13.907,8.257-10.881-4.29-28.714-1.229-28.514-7.082,.2-5.853,5.192-1.655,13.694-5.114Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5972.8,2333.701s23.498-1.662,35.854,7.731c9.895,7.523,7.287,14.815,17.307,19.688,10.02,4.872,18.54,8.037,20.698,15.154,2.158,7.117,10.775,19.855,23.049,23.493-12.895-1.688-19.915-7.809-25.325-18.624-5.41-10.815-7.263-9.355-22.582-16.366-15.141-6.929-8.703-15.958-22.551-22.221-6.144-2.778-11.994-3.952-16.874-4.342-7.893-.631-13.257,.788-13.257,.788l3.681-5.302Z",
    fill: "#167227"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5884.148,2131.481s11.905,10.702,19.223,18.853c7.317,8.15,7.531,8.141,9.892,24.543,2.361,16.403-.033,99.68-2.826,137.296-2.793,37.615,8.035,72.344,8.035,72.344l5.757-2.802s-8.747-46.864-8.207-77.634c.54-30.77,4.541-107.683,2.449-132.056-1.684-19.624-4.813-21.62-6.541-31.07-1.729-9.449-11.189-21.675-11.189-21.675l-16.594,12.2Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5965.966,2162.526s-12.511,9.989-20.292,17.698c-7.78,7.709-7.994,7.688-11.309,23.924-3.314,16.237-5.79,99.512-5.199,137.226,.592,37.714-12.246,71.751-12.246,71.751l-5.584-3.133s11.469-46.273,12.728-77.023c1.259-30.748,1.755-107.764,5.268-131.972,2.827-19.493,6.068-21.304,8.345-30.635,2.277-9.332,12.436-20.985,12.436-20.985l15.854,13.149Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5855.145,2199.934c4.571,3.073,23.376,.551,28.983,19.657,2.134,7.273,9.495,15.954,12.818,28.719,5.407,20.77,6.506,49.594,4.51,80.246-3.223,49.49,1.916,59.176,1.916,59.176l-7.051,5.743s2.262-92.972,.625-113.121c-1.938-23.847-11.121-53.71-17.687-53.987-6.566-.275-32.042-2.043-32.042-2.043l7.927-24.392Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5876.764,2198.314c3.677-6.078,4.222-14.331-2.249-18.73-9.999-6.797-18.458,.306-22.577,9.556-3.528-9.297-12.863-18.65-20.713-12.038-8.122,6.838-2.822,17.156,4.732,24.044-10.412,.272-21.328,5.41-20.435,15.881,1.036,12.147,14.307,12.517,24.649,8.377-.805,3.892-.767,7.879,.63,11.179,3.067,7.246,12.123,7.995,18.67,5.591,6.645-2.441,12.79-8.704,13.221-16.079,.263-4.512-2.356-7.753-4.802-11.328-1.036-1.513-2.045-2.963-3.072-4.378,4.974-2.764,9.693-8.352,11.946-12.074Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5860.194,2188.323c-3.364-2.627-7.664-1.47-10.121,1.781-2.116,2.799-2.558,6.673-2.423,10.445-1.941-3.05-4.355-5.751-7.441-7.834-3.899-2.631-9.713-4.06-13.212,.06-3.099,3.648-1.243,8.026,2.091,10.684,1.952,1.556,3.837,2.044,6.101,2.779-.442,.14-.906,.196-1.329,.389-3.033,1.384-5.258,4.576-3.509,7.851,1.704,3.191,5.964,3.664,9.159,3.235,1.599-.214,3.854-.67,5.788-1.532,.01,5.051,2.2,10.372,5.68,13.268,1,.832,1.994,.904,3.158,.408,8.933-3.817,8.863-17.553,1.772-23.062,6.079-5.143,11.353-12.954,4.287-18.471Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5851.88,2206.737c2.25-4.552-3.912-5.909-9.865-9.206-5.953-3.297-7.12,2.444-2.731,8.587,4.389,6.142,9.187,7.514,12.596,.619Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5980.99,2209.457c-4.57,3.073-23.375,.552-28.982,19.657-2.134,7.273-9.495,15.955-12.818,28.719-5.407,20.77-6.507,49.595-4.51,80.246,3.223,49.491-1.916,59.176-1.916,59.176l7.051,5.744s-2.263-92.973-.625-113.121c1.938-23.848,11.122-53.711,17.687-53.987,6.566-.276,32.042-2.043,32.042-2.043l-7.928-24.392Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5959.371,2207.838c-3.677-6.079-4.222-14.332,2.249-18.73,9.999-6.797,18.458,.305,22.577,9.556,3.528-9.297,12.863-18.651,20.713-12.038,8.122,6.838,2.822,17.155-4.732,24.044,10.412,.271,21.328,5.409,20.435,15.88-1.037,12.147-14.307,12.517-24.649,8.377,.805,3.892,.767,7.879-.63,11.179-3.067,7.246-12.124,7.995-18.67,5.591-6.645-2.44-12.79-8.704-13.221-16.079-.263-4.512,2.356-7.752,4.802-11.328,1.036-1.514,2.045-2.964,3.072-4.378-4.974-2.764-9.693-8.351-11.946-12.073Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5975.941,2197.847c3.364-2.628,7.665-1.471,10.122,1.781,2.116,2.798,2.558,6.672,2.423,10.444,1.941-3.05,4.355-5.751,7.441-7.834,3.899-2.631,9.712-4.06,13.212,.06,3.099,3.648,1.243,8.026-2.091,10.684-1.952,1.556-3.837,2.044-6.101,2.779,.442,.141,.906,.196,1.329,.389,3.033,1.384,5.258,4.576,3.509,7.851-1.705,3.191-5.964,3.664-9.159,3.236-1.599-.214-3.854-.67-5.788-1.532-.01,5.05-2.2,10.371-5.68,13.267-1,.832-1.994,.905-3.158,.409-8.933-3.818-8.863-17.553-1.772-23.063-6.079-5.142-11.354-12.954-4.288-18.47Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5984.255,2216.26c-2.251-4.552,3.912-5.909,9.865-9.206,5.953-3.296,7.12,2.444,2.731,8.587-4.389,6.142-9.187,7.514-12.596,.619Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5869.094,2354.235s10.824-6.132,22.364-6.594c11.541-.461,22.245,8.992,26.01,19.037,3.765,10.045,4.688,21.124,4.688,21.124l-4.688,.924s-2.213-16.547-6.264-24.43c-4.05-7.884-11.206-12.038-17.207-11.807-6.001,.23-8.369,4.155-16.152,5.815-7.784,1.661-8.751-4.069-8.751-4.069Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5806.905,2396.261c13.435-4.357,19.094-6.634,28.927-19.846,7.098-9.534,23.757-18.191,36.222-20.822-.986-.423-1.977-.871-2.961-1.358-25.383-12.551-38.872-17.445-65.61,5.063-26.738,22.51-31.778,29.406-32.951,53.655-1.173,24.249,5.199,38.948,5.199,38.948,2.68-41.149,17.737-51.284,31.174-55.64Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5820.898,2427.137c32.715,5.503,68.275-20.634,74.805-43.381,6.276-21.861-8.485-21.676-23.649-28.164-12.465,2.631-29.124,11.288-36.222,20.822-9.834,13.212-15.492,15.489-28.927,19.846-13.437,4.356-28.494,14.491-31.174,55.64,0,0,14.238-29.965,45.166-24.764Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5800.75,2373.645c-9.355,1.069-14.465,7.387-18.773,15.695-4.308,8.309,1.846,7.694,9.233,2.154,7.385-5.539,21.234-4.923,24.311-10.156,3.077-5.231-4.001-8.924-14.771-7.694Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5816.245,2407.326c-10.88,.698-15.495-1.521-20.111,4.941-4.617,6.463,4.617,7.848,13.386,4.155,8.771-3.693,19.85-4.17,30.467-9.075,6.621-3.058,6.895-13.143-3.529-10.782-10.479,2.373-10.552,10.14-20.213,10.761Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5820.898,2427.137c32.715,5.503,68.275-20.634,74.805-43.381,6.276-21.861-8.485-21.676-23.649-28.164-12.465,2.631-29.124,11.288-36.222,20.822-9.834,13.212-15.492,15.489-28.927,19.846-13.437,4.356-28.494,14.491-31.174,55.64,0,0,14.238-29.965,45.166-24.764Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5777.969,2434.17s1.085-29.75,24.166-40.367c11.624-5.348,20.887-3.46,25.214-10.048,6.438-9.802,11.617-16.5,19.18-20.698,12.326-6.84,22.565-8.823,22.565-8.823l9.871,3.989s-5.634-.163-24.667,6.959c-5.88,2.2-15.694,10.156-20.511,18.574-5.344,9.343-10.344,11.592-25.342,14.004-24.005,3.859-30.475,36.41-30.475,36.41Z",
    fill: "#167227"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6000.86,2416.936c-13.437-4.357-19.094-6.634-28.929-19.845-7.098-9.534-23.757-18.191-36.222-20.822,.987-.423,1.977-.871,2.961-1.358,25.385-12.55,38.873-17.445,65.61,5.063,26.738,22.511,31.779,29.407,32.951,53.656,1.173,24.249-5.199,38.948-5.199,38.948-2.679-41.15-17.737-51.284-31.172-55.641Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5986.866,2447.813c-32.715,5.502-68.275-20.635-74.804-43.381-6.277-21.861,8.484-21.676,23.648-28.164,12.466,2.631,29.124,11.288,36.222,20.822,9.834,13.211,15.492,15.488,28.929,19.845,13.435,4.357,28.493,14.491,31.172,55.641,0,0-14.237-29.966-45.166-24.764Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6007.015,2394.322c9.355,1.069,14.464,7.386,18.772,15.695,4.309,8.309-1.846,7.694-9.232,2.154-7.386-5.54-21.234-4.923-24.311-10.156-3.078-5.231,4-8.925,14.771-7.694Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5991.519,2428.003c10.88,.698,15.496-1.522,20.111,4.941,4.617,6.462-4.616,7.848-13.386,4.155-8.771-3.693-19.85-4.17-30.467-9.075-6.621-3.059-6.894-13.144,3.529-10.783,10.479,2.374,10.552,10.141,20.213,10.762Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5986.866,2447.813c-32.715,5.502-68.275-20.635-74.804-43.381-6.277-21.861,8.484-21.676,23.648-28.164,12.466,2.631,29.124,11.288,36.222,20.822,9.834,13.211,15.492,15.488,28.929,19.845,13.435,4.357,28.493,14.491,31.172,55.641,0,0-14.237-29.966-45.166-24.764Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6029.795,2454.846s-1.085-29.749-24.166-40.367c-11.624-5.347-20.886-3.459-25.213-10.047-6.438-9.803-11.617-16.5-19.181-20.698-12.326-6.84-22.565-8.823-22.565-8.823l-9.87,3.988s5.633-.163,24.666,6.96c5.88,2.2,15.695,10.156,20.512,18.574,5.344,9.343,10.344,11.592,25.343,14.003,24.004,3.86,30.474,36.41,30.474,36.41Z",
    fill: "#167227"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5887.46,2464.728c-.453-10.54-7.743-13.956,.462-24.929,8.204-10.972,4.385-18.926,3-29.236-1.385-10.309,11.32-25.911,19.515-33.347-1.052-.191-2.072-.337-3.05-.442-20.103-2.157-36.006,2.448-46.162,16.359-10.156,13.911-8.309,25.912,0,34.222,8.309,8.308,12.003,10.948,7.386,23.477-4.617,12.529,6.906,17.653,12.225,22.477,5.316,4.824,.44,17.51,.44,17.51,5.585-7.605,6.638-15.553,6.185-26.092Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5902.77,2473.309c2.77-7.178-1.12-23.489,6.771-28.105,7.892-4.617,31.391-12.738,35.083-30.469,4.619-22.179-18.386-34.661-34.187-37.518-8.194,7.435-20.9,23.038-19.515,33.347,1.384,10.31,5.204,18.264-3,29.236-8.205,10.973-.915,14.389-.462,24.929,.453,10.539-.599,18.486-6.185,26.092,0,0,18.725-10.332,21.495-17.51Z",
    fill: "#5caa29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5916.701,2391.33c-9.248,.941-10.545,11.584-8.699,24.718,1.846,13.135,7.385,20.06,17.08,6.211,9.694-13.848,2.626-32.049-8.381-30.929Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5902.77,2473.309c2.77-7.178-1.12-23.489,6.771-28.105,7.892-4.617,31.391-12.738,35.083-30.469,4.619-22.179-18.386-34.661-34.187-37.518-8.194,7.435-20.9,23.038-19.515,33.347,1.384,10.31,5.204,18.264-3,29.236-8.205,10.973-.915,14.389-.462,24.929,.453,10.539-.599,18.486-6.185,26.092,0,0,18.725-10.332,21.495-17.51Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5881.276,2388.331c-13.771,4.79-19.897,13.154-18.974,21.925,.924,8.77,10.558,7.424,15.897-2.982,5.337-10.406,20.752-19.881,16.738-24.145-4.014-4.263-4.991,2.185-13.661,5.202Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5913.286,2373.408s-21.595,18.077-24.672,33.29c-2.464,12.183,4.309,15.937,0,26.212-4.308,10.276-8.617,18.277-5.54,25.048,3.077,6.77,5.018,22.025-1.799,32.862,8.57-9.782,9.8-19.014,6.723-30.708-3.077-11.695-.722-11.822,6.154-27.202,6.797-15.2-4-17.731,2.266-31.577,7.274-16.076,23.791-24.115,23.791-24.115l-6.924-3.809Z",
    fill: "#167227"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5925.865,2110.652c-3.538-6.665-12.468-11.466-19.832-8.728-2.464,.916-4.96,2.477-7.301,4.379,.787-11.367-2.358-24.028-14.837-22.459-5.705,.717-12.902,3.832-13.779,10.21-.572,4.158,1.446,10.497,4.234,15.322-3.297-.71-6.796-.821-9.24-.58-7.276,.716-10.748,6.722-10.824,13.558-.081,7.268,3.004,15.783,10.59,18.137,2.771,.861,5.695,.52,8.551-.461-1.256,2.725-1.802,5.454-.828,7.797,2.554,6.153,13.845,11.154,20.18,10.215,7.396-1.098,13.912-10.577,14.491-17.592,.177-2.144,.111-5.257-.394-8.392,12.143-1.257,25.39-9.355,18.99-21.407Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5897.637,2123.103c-1.284-.689-2.603-1.366-3.928-2.024,3.168-1.159,6.191-3.212,7.753-5.262,2.945-3.869,3.524-9.698-.528-13.042-3.303-2.726-8.548-2.702-11.339,.709-1.967,2.406-2.314,5.737-2.662,8.766-3.292-7.012-10.204-14.632-16.947-7.855-4.97,4.995-.251,10.759,5.519,13.452-6.022,2.135-10.879,7.699-7.562,13.961,2.059,3.886,7.183,7.003,11.525,4.956,2.216-1.047,3.433-3.299,4.681-5.283,.74-1.176,1.546-2.332,2.281-3.514,1.932,7.428,7.113,16.981,13.501,11.227,3.08-2.775,4.8-8.348,2.611-12.104-1.105-1.894-3.038-2.985-4.904-3.987Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5877.65,2114.336c-3.734,1.73,4.135,14.619,10.098,10.681,5.962-3.937,2.569-16.556-10.098-10.681Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5926.835,2137.388c3.922-6.447,13.118-10.718,20.308-7.555,2.406,1.058,4.807,2.761,7.033,4.798-.12-11.393,3.759-23.849,16.124-21.554,5.652,1.049,12.656,4.578,13.159,10.997,.327,4.185-2.057,10.395-5.121,15.05,3.332-.516,6.831-.422,9.258-.038,7.222,1.14,10.337,7.338,10.014,14.167-.343,7.261-3.921,15.58-11.632,17.489-2.817,.697-5.715,.186-8.509-.961,1.094,2.794,1.481,5.55,.371,7.833-2.909,5.992-14.472,10.326-20.742,9.018-7.319-1.527-13.271-11.37-13.439-18.409-.051-2.151,.196-5.254,.884-8.356-12.05-1.963-24.8-10.823-17.708-22.479Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5954.288,2151.467c1.323-.613,2.678-1.211,4.04-1.791-3.095-1.341-5.993-3.568-7.432-5.707-2.715-4.034-2.952-9.887,1.288-12.988,3.456-2.529,8.692-2.198,11.278,1.37,1.824,2.517,1.975,5.863,2.146,8.906,3.696-6.808,11.042-14.01,17.377-6.851,4.67,5.277-.378,10.756-6.295,13.106,5.887,2.485,10.41,8.322,6.733,14.38-2.282,3.759-7.579,6.572-11.794,4.273-2.152-1.174-3.234-3.494-4.364-5.546-.67-1.218-1.407-2.419-2.072-3.643-2.363,7.303-8.092,16.537-14.134,10.419-2.913-2.949-4.305-8.614-1.9-12.235,1.214-1.827,3.207-2.802,5.129-3.693Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5974.753,2143.881c3.626,1.946-4.982,14.352-10.704,10.073-5.722-4.279-1.597-16.678,10.704-10.073Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4025.795,3428.782c-1.235-28.213,1.792-78.654,2.515-86.724,.722-8.069-2.958-15.031-13.92-26.209-10.96-11.178-44.292-10.33-57.569-17.885-15.063-8.569-22.383-6.773-35.797-5.713-11.823,.935-21.394,14.856-21.394,14.856,0,0,15.727-12.869,33.092-4.299,17.365,8.57,36.009,22.047,52.955,23.319,16.946,1.272,35.705,5.265,35.33,17.946-.025,.817-.127,1.58-.288,2.301,1.421,7.212-1.946,19.141-2.543,26.806-.769,9.868-2.29,38.573,0,70.965,2.084,29.495,6.782,50.048,7.845,55.729,5.462,6.136,8.813,.764,8.813,.764,0,0-7.805-43.643-9.04-71.856Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3985.678,3326.127c-16.946-1.272-35.59-14.749-52.955-23.319-17.365-8.57-33.092,4.299-33.092,4.299,0,0,9.011-3.602,27.54-.421,18.528,3.181,25.898,17.36,49.685,24.029,23.787,6.669,35.084,5.999,41.322,10.777,1.392,1.067,2.135,2.81,2.543,4.882,.161-.721,.263-1.484,.288-2.301,.375-12.681-18.385-16.674-35.33-17.946Z",
    fill: "#478e19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3911.937,3295.422s22.68-3.047,27.062,.679c4.382,3.726,.794,10.461,4.451,11.006,3.657,.544,2.448-6.649,4.543-7.896,2.095-1.248,5.821,4.714,14.018,6.205,8.197,1.49,3.071,4.401,5.222,10.433,2.151,6.032,3.8,2.609,5.25-1.49,1.45-4.099,1.006-6.334,10.543-5.217,9.537,1.118,14.982,1.49,14.495,5.217-.486,3.726-.859,9.324,2.494,8.761,3.354-.564,2.493-8.761,4.6-8.016,2.107,.745,6.795,2.284,11.422,8.016,4.627,5.731,9.935,13.431,12.194,19.883,1.778-9.455-3.269-21.006-16.029-30.396-13.638-7.815-31.521-9.524-44.969-12.742-12.706-3.041-19.286-8.673-30.186-8.673-18.346,0-25.11,4.232-25.11,4.232Z",
    fill: "#6ebc3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4017.132,3365.211s8.504-4.095,16.103,12.995c6.791,15.273,5.589,44.95-1.676,71.778-7.266,26.827-9.617,33.593-10.551,44.46-1.037,12.069,2.554,22.198,4.629,28.969-5.562,3.977-8.202-.494-8.202-.494,0,0-8.453-18.042-3.871-38.223,4.581-20.182,13.524-27.992,16.877-56.503,3.353-28.511,1.118-44.141-5.03-50.857-6.148-6.716-9.653-7.834-9.653-7.834l1.374-4.291Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4065.762,3343.432s-8.504-4.095-16.103,12.996c-6.791,15.272-5.589,44.95,1.677,71.777,7.265,26.827,9.616,33.593,10.55,44.461,1.037,12.069-2.554,22.198-4.629,28.968,5.563,3.978,8.202-.493,8.202-.493,0,0,8.453-18.042,3.872-38.224-4.582-20.181-13.524-27.992-16.878-56.503-3.353-28.51-1.117-44.141,5.03-50.857,6.148-6.716,9.653-7.834,9.653-7.834l-1.374-4.292Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3912.098,3401.898c27.314-5.024,38.739-6.641,62.514-21.407,15.796-9.81,33.556-14.429,46.395-14.46-6.807-9.505-20.719-15.805-38.064-17.601-23.62-2.447-40.796,8.935-40.796,8.935,0,0,6.063,.887,10.649,.977,5.957,.118,10.397,.734,13.547,1.562,12.861,3.381,2.249,7.351,.342,6.964-6.586-1.339-15.262-5.839-27.557-4.798-5.332,.453-19.724,8.996-19.724,8.996,0,0,5.856,.082,12.128,1.986,6.792,2.061,20.093-.554,18.153,2.425-3.733,5.731-22.759,2.38-28.459,1.051-15.202-3.544-29.905,10.502-29.905,10.502,5.545-1.513,10.145-1.019,16.631-.92,4.757,.073,11.363-2.543,14.068-1.014,3.996,2.259-6.383,6.269-15.388,6.69-9.004,.42-17.158,1.82-23.627,10.259-7.518,9.808-12.751,26.403-12.751,26.403,10.05-10.301,26.855-23.792,41.842-26.55Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3914.455,3420.801c6.669-9.486,14.566-11.323,16.171-9.846,3.211,2.955-17.053,21.417-17.053,21.417,0,0,15.762,3.765,29.15,1.069,7.678-1.547,11.858-13.012,15.877-19.447,2.989-4.785,5.574-7.018,8.311-7.147,2.142-.1,6.925,2.326,1.265,8.485-2.914,3.171-12.456,16-12.456,16,0,0,16.398,3.063,31.816-8.354,5.844-4.328,4.779-16.615,6.178-23.447,.974-4.756,2.75-10.54,5.746-5.629,.464,.761,2.495,6.264-.215,11.73-3.16,6.373-3.585,9.906-4.232,15.635,27.544-16.725,31.656-31.44,30.435-43.728-.419-4.221-1.978-8.068-4.441-11.507-12.839,.03-30.598,4.65-46.395,14.46-23.775,14.766-35.199,16.383-62.514,21.407-14.986,2.758-31.791,16.248-41.842,26.55,0,0,9.382,3.15,20.763,2.34,5.69-.405,17.815-1.993,23.435-9.988Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3878.574,3420.524s17.57-13.003,30.722-16.564c13.152-3.561,35.872-4.327,44.356-8.821,8.484-4.494,29.493-18.424,41.567-21.725,24.033-6.567,29.955-1.666,29.955-1.666,0,0-.425-5.387-1.982-6.079-5.992-2.665-17.127-2.168-28.808,1.93-11.681,4.099-15.793,7.492-27.25,15.283-10.052,6.835-17.041,11.265-27.236,12.724-10.195,1.459-24.518,1.591-33.125,4.823-9.176,3.446-24.799,14.761-28.199,20.094Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3949.971,3399.964c-3.07,.936-7.045,9.361-9.865,12.371-2.819,3.009-7.72,7.492-9.75,10.363-2.03,2.872,2.564,5.756,7.871,.334,5.307-5.421,7.2-8.917,11.386-14.197,4.186-5.281,6.317-10.687,.359-8.871Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3979.867,3388.823c-2.93,1.753-2.014,10.812-3.063,16.063-1.049,5.252-3.691,8.914-5.078,13.533-1.388,4.618,9.227,2.877,9.896-5.581,.671-8.457,.194-12.63,1.103-17.182,.91-4.552-.297-8.366-2.858-6.834Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3912.37,3405.925c-2.96,.819-12.533,4.415-17.041,7.301-4.509,2.886-8.528,6.962-9.647,8.923-1.12,1.961,9.322,.802,13.469-1.59,4.146-2.392,9.605-7.865,15.389-10.929,5.785-3.063,1.642-4.758-2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4006.677,3376.08c-3.354,.919-1.884,6.436-.679,12.065,1.206,5.629,.675,11.567,1.796,13.248,1.121,1.68,9.167-2.388,5.764-11.627-3.837-10.417-3.899-14.503-6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3906.055,3395.149c-3.675,.202-8.89,1.155-12.85,3.508-3.96,2.353-5.491,5.469-5.128,6.798,.363,1.329,7.52-2.688,10.756-4.206,3.236-1.518,7.087-1.856,11.441-3.44,2.913-1.061-1.444-2.812-4.218-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3933.58,3379.942c-3.6-.592-12.409-2.406-15.279-2.614-2.871-.21-6.135,.019-8.326,2.272s2.179,1.888,5.029,2.02c2.85,.133,8.815-1.661,13.031-.164,4.215,1.497,8.238,1.681,11.408,1.167,3.17-.513,3.31-3.033,.369-2.893-2.941,.141-3.699,.628-6.232,.211Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3939.08,3363.71c-2.347,.358-5.126,1.233-6.218,2.691-1.092,1.456,4.481,1.259,7.1,.544,2.619-.715,8.851-.926,12.45,.74,3.6,1.665,9.427,4.213,13.025,4.058,3.599-.155,6.12-.015,4.776-1.303-1.345-1.288-4.496-1.918-7.801-2.505-3.305-.587-8.806-3.058-12.064-3.823-3.258-.766-8.54-.816-11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3971.287,3351.938c-3.329,.192-10.321,.997-11.763,2.383-1.442,1.387,5.41,2.236,8.328,1.404,2.917-.832,9.849-.904,13.827,.327,3.978,1.231,9.691,2.153,12.121,.745,2.43-1.407-3.341-3.142-6.057-3.394-2.717-.252-12.788-1.679-16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4171.006,3379.94c-27.314-5.025-38.739-6.641-62.514-21.407-15.796-9.81-33.555-14.429-46.395-14.46,6.808-9.506,20.719-15.805,38.065-17.601,23.619-2.447,40.795,8.935,40.795,8.935,0,0-6.063,.888-10.65,.978-5.956,.118-10.396,.734-13.547,1.561-12.86,3.381-2.248,7.352-.342,6.964,6.587-1.339,15.263-5.84,27.558-4.798,5.332,.452,19.723,8.996,19.723,8.996,0,0-5.855,.082-12.128,1.986-6.793,2.061-20.093-.554-18.153,2.425,3.733,5.73,22.759,2.379,28.459,1.05,15.202-3.544,29.905,10.503,29.905,10.503-5.545-1.514-10.145-1.02-16.631-.92-4.756,.072-11.362-2.543-14.068-1.014-3.996,2.259,6.383,6.269,15.387,6.689,9.005,.42,17.159,1.821,23.627,10.259,7.518,9.808,12.751,26.402,12.751,26.402-10.051-10.3-26.855-23.792-41.842-26.549Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4168.649,3398.842c-6.668-9.486-14.565-11.323-16.171-9.846-3.211,2.954,17.054,21.417,17.054,21.417,0,0-15.762,3.765-29.15,1.069-7.679-1.547-11.858-13.012-15.878-19.446-2.988-4.785-5.573-7.019-8.311-7.147-2.142-.101-6.925,2.326-1.264,8.485,2.914,3.171,12.456,16,12.456,16,0,0-16.398,3.063-31.815-8.354-5.845-4.328-4.78-16.615-6.179-23.447-.973-4.756-2.75-10.54-5.746-5.629-.464,.76-2.495,6.263,.215,11.729,3.16,6.374,3.585,9.907,4.232,15.636-27.545-16.725-31.655-31.44-30.435-43.729,.419-4.221,1.978-8.068,4.44-11.507,12.84,.031,30.599,4.65,46.395,14.46,23.776,14.766,35.2,16.382,62.514,21.407,14.986,2.757,31.791,16.248,41.842,26.549,0,0-9.382,3.15-20.763,2.341-5.691-.404-17.815-1.993-23.436-9.987Z",
    fill: "#5baa27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4204.531,3398.566s-17.57-13.003-30.722-16.564c-13.152-3.561-35.872-4.328-44.356-8.821-8.483-4.494-29.492-18.424-41.566-21.724-24.033-6.567-29.955-1.666-29.955-1.666,0,0,.425-5.387,1.982-6.079,5.992-2.665,17.126-2.169,28.808,1.93,11.68,4.099,15.792,7.492,27.249,15.282,10.052,6.836,17.041,11.265,27.236,12.724,10.195,1.46,24.517,1.591,33.125,4.824,9.177,3.447,24.8,14.762,28.199,20.095Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4133.135,3378.006c3.07,.935,7.044,9.361,9.864,12.371,2.82,3.009,7.721,7.491,9.75,10.363,2.03,2.872-2.564,5.755-7.87,.334-5.306-5.421-7.2-8.917-11.386-14.198-4.186-5.28-6.317-10.687-.358-8.87Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4103.238,3366.865c2.93,1.753,2.014,10.812,3.063,16.064,1.049,5.252,3.691,8.913,5.078,13.532,1.387,4.619-9.227,2.877-9.897-5.581-.671-8.457-.193-12.63-1.103-17.182-.909-4.551,.298-8.365,2.859-6.833Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4170.734,3383.967c2.961,.818,12.533,4.414,17.042,7.3,4.509,2.886,8.527,6.962,9.647,8.923,1.119,1.961-9.323,.803-13.47-1.589-4.147-2.392-9.604-7.865-15.389-10.928-5.784-3.063-1.641-4.759,2.17-3.706Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4076.428,3354.12c3.354,.919,1.885,6.437,.679,12.066-1.206,5.629-.675,11.567-1.796,13.247-1.12,1.68-9.166-2.388-5.764-11.627,3.837-10.416,3.9-14.503,6.881-13.686Z",
    fill: "#6ebc3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4177.05,3373.189c3.675,.202,8.89,1.155,12.851,3.508,3.96,2.353,5.491,5.469,5.127,6.799-.363,1.33-7.52-2.688-10.755-4.206-3.237-1.518-7.088-1.855-11.441-3.441-2.914-1.061,1.444-2.812,4.217-2.66Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4149.524,3357.983c3.6-.592,12.409-2.406,15.279-2.615,2.872-.21,6.136,.02,8.326,2.273,2.19,2.253-2.179,1.888-5.029,2.02-2.849,.132-8.815-1.662-13.03-.164-4.216,1.497-8.239,1.681-11.409,1.168-3.17-.513-3.31-3.034-.368-2.893,2.941,.141,3.699,.628,6.231,.212Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4144.025,3341.751c2.347,.357,5.125,1.234,6.218,2.691,1.091,1.457-4.482,1.259-7.101,.544-2.619-.715-8.851-.927-12.45,.739-3.599,1.665-9.426,4.212-13.025,4.058-3.599-.155-6.119-.016-4.775-1.304,1.344-1.288,4.496-1.917,7.801-2.505,3.305-.588,8.806-3.058,12.063-3.824s8.54-.815,11.268-.4Z",
    fill: "#8cdd58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4111.818,3329.98c3.328,.192,10.321,.997,11.763,2.384,1.442,1.386-5.41,2.235-8.327,1.403-2.917-.831-9.85-.903-13.828,.327-3.977,1.232-9.69,2.153-12.12,.746-2.43-1.407,3.34-3.142,6.058-3.394,2.716-.251,12.788-1.678,16.455-1.466Z",
    fill: "#8cdd58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4075.296,3389.89s-23.873,38.912-19.282,57.063c4.592,18.151,16.208,31.268,19.282,51.834,2.004,13.405,.293,20.491,.293,20.491,0,0-3.764,4.462-7.077,.365,.573-5.45,.993-14.846-1.056-24.919-2.592-12.743-8.239-26.682-12.593-36.328-7.795-17.272-4.929-31.862,3.942-49.384,4.17-8.237,16.491-19.122,16.491-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4149.061,3464.666c-9.624-4.325-28.953-20.1-32.889-28.848-3.936-8.748-7.901-18.498-14.29-26.703-6.388-8.204-14.505-15.919-24.47-17.593-3.696-.62-7.221-1.117-10.2-1.498,2.69-1.382,5.747-2.427,9.236-4.028,15.545-7.131,37.831-2.127,49.056,4.089s15.881,10.267,15.881,10.267c0,0-8.148-.51-12.25-1.286-6.605-1.25-12.615-.305-13.343,1.655-1.456,3.922,1.653,3.864,8.284,2.857,6.632-1.007,16.926,.622,21.7,3.715,5.544,3.593,17.86,19.889,17.86,19.889,0,0-12.701-.676-25.971-2.387-5.957-.769-3.922,4.311-2.064,4.886,8.681,2.688,24.568-2.311,28.972,3.011,4.73,5.715,7.388,21.349,7.388,21.349,0,0-16.49,.252-23.153-1.142-6.662-1.394-11.035,2.184-5.667,4.106,5.369,1.922,23.383,2.166,28.761,4.465,3.619,4.193,4.757,14.105,4.661,19.639-.097,5.534-1.354,14.138-2.396,19.942-4.483-13.434-15.482-32.059-25.106-36.384Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4135.553,3471.073c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4135.553,3471.073c-1.654-6.392-6.216-3.217-5.557,.661,.659,3.878,4.346,22.221,4.346,22.221,0,0-16.627-6.748-28.309-16.446-7.719-6.408-2.318-20.304-1.612-29.489,.706-9.185-2.683-10.599-5.048-8.018-1.92,2.096-.643,8.986-1.347,15.058-1.174,10.12-.971,19.135-.971,19.135,0,0-10.813-5.335-18.003-15.342-5.409-7.529,.11-27.908,1.277-30.831,2.188-5.474-1.689-5.6-3.042-2.884-1.181,2.373-2.597,7.223-3.901,12.078-1.9,7.07-1.774,11.765-2.28,14.914-7.94-7.389-19.745-26.389-15.467-44.288,2.709-11.337,6.469-15.198,11.574-17.82,2.98,.381,6.505,.878,10.2,1.498,9.965,1.674,18.082,9.389,24.47,17.593,6.39,8.205,10.354,17.955,14.29,26.703,3.936,8.748,23.265,24.523,32.889,28.848,9.624,4.325,20.623,22.95,25.106,36.384-11.486-.652-23.855-.066-33.344-5.645-3.984-10.095-3.617-17.941-5.271-24.332Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4064.93,3391.391s12.931-1.216,23.412,6.72c7.363,5.575,13.54,11.004,19.588,27.203,4.399,11.781,17.34,24.775,23.23,29.404,5.889,4.628,14.248,8.192,24.011,16.705,9.762,8.512,17.069,24.593,17.069,24.593,0,0-6.563-19.485-15.807-27.171-9.243-7.687-20.014-11.016-29.135-21.312-9.12-10.296-13.475-22.086-16.582-28.928-3.106-6.841-12.556-19.072-20.132-23.621-7.577-4.549-20.939-10.029-25.654-3.592Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4136.299,3435.453c5.665,.447,13.222-.592,18.887,1.048,5.665,1.64,5.394,5.372,6.399,9.453,1.004,4.081-8.783,3.194-15.952,2.713-7.169-.482-13.079-6.468-16.145-9.495-3.065-3.027,1.3-4.153,6.812-3.719Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4120.402,3408.862c7.475-.732,14.722-.884,21.182,1.539,6.459,2.423,8.679,7.148,8.228,9.493-.452,2.344-6.664-.851-14.935-1.146-8.271-.294-13.71,2.613-17.452-1.058-3.742-3.671-3.867-8.158,2.978-8.827Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4098.078,3386.738c8.272-.391,14.287,1.307,18.403,3.842,4.116,2.534-1.242,4.172-6.28,3.814-5.037-.357-12.295-.645-17.774-4.055-5.48-3.41,.486-3.357,5.651-3.601Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4164.91,3465.515c4.721,.873,7.143,8.831,7.356,12.418,.212,3.587-3.381,.796-7.395-4.474-4.014-5.27-5.549-8.977,.039-7.944Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4148.608,3472.838c4.486,1.564,12.438,8.816,12.913,14.6,.474,5.785-8.827,5.382-13.457-1.485-4.629-6.866-8.857-16.394,.544-13.115Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4117.808,3453.398c3,2.647,6.292,16.81,6.317,22.889,.025,6.079-11.527,.772-14.969-5.778-3.442-6.551,1.648-23.29,8.652-17.111Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4095.025,3416.35c4.484,4.111,.397,11.374-.419,18.6-.817,7.225,.73,19.15-.863,22.54-1.592,3.388-11.257-1.771-12.709-10.311-1.452-8.541,1.722-21.552,4.05-26.2,2.328-4.647,6.659-7.637,9.941-4.628Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4073.596,3397.872c6.008-1.442,7.802,4.764,3.76,12.668-4.042,7.905-5.715,18.11-8.185,20.231-2.471,2.121-8.445-4.674-7.064-14.894,1.38-10.219,5.044-16.459,11.49-18.006Z",
    fill: "#2ca348",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4026.995,3408.815s23.874,38.912,19.282,57.063c-4.591,18.151-16.208,31.268-19.282,51.834-2.004,13.405-.293,20.491-.293,20.491,0,0,3.764,4.462,7.077,.364-.573-5.45-.993-14.846,1.056-24.918,2.592-12.744,8.239-26.682,12.593-36.329,7.795-17.272,4.929-31.861-3.943-49.383-4.17-8.237-16.49-19.122-16.49-19.122Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3964.177,3494.162c8.763-5.877,25.175-24.669,27.588-33.953,2.414-9.284,4.689-19.561,9.612-28.721,4.923-9.159,11.631-18.126,21.175-21.446,3.539-1.231,6.932-2.311,9.805-3.187-2.883-.911-6.073-1.429-9.781-2.422-16.52-4.425-37.652,4.244-47.676,12.253-10.024,8.01-13.936,12.784-13.936,12.784,0,0,7.947-1.868,11.862-3.321,6.302-2.339,12.385-2.415,13.432-.604,2.092,3.623-.982,4.086-7.689,4.205-6.706,.118-16.582,3.45-20.77,7.3-4.863,4.471-14.274,22.602-14.274,22.602,0,0,12.408-2.795,25.204-6.707,5.744-1.757,4.589,3.593,2.854,4.471-8.108,4.105-24.608,1.84-28.058,7.824-3.705,6.427-3.705,22.285-3.705,22.285,0,0,16.3-2.516,22.633-5.006,6.334-2.491,11.246,.303,6.275,3.098-4.97,2.794-22.689,6.054-27.606,9.223-2.865,4.741-2.326,14.703-1.302,20.143,1.024,5.439,3.705,13.711,5.705,19.258,2.167-13.996,9.889-34.2,18.652-40.078Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3978.568,3498.214c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#208e3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3978.568,3498.214c.559-6.579,5.589-4.214,5.589-.281s-.559,22.636-.559,22.636c0,0,15.26-9.44,25.15-20.959,6.536-7.611-1.118-20.405-3.353-29.342-2.236-8.936,.869-10.898,3.633-8.749,2.244,1.744,2.14,8.75,3.853,14.618,2.854,9.781,4.166,18.701,4.166,18.701,0,0,9.765-7.071,15.176-18.142,4.071-8.329-4.786-27.494-6.427-30.18-3.074-5.03,.727-5.804,2.515-3.354,1.562,2.141,3.772,6.686,5.871,11.254,3.058,6.652,3.721,11.301,4.748,14.32,6.589-8.615,15.041-29.325,7.825-46.253-4.572-10.723-8.925-13.898-14.397-15.629-2.874,.876-6.266,1.956-9.805,3.187-9.543,3.32-16.252,12.287-21.175,21.446-4.923,9.16-7.198,19.437-9.612,28.721-2.413,9.284-18.825,28.076-27.588,33.953-8.763,5.877-16.485,26.082-18.652,40.078,11.214-2.568,23.506-4.064,31.926-11.154,2.235-10.619,.558-18.293,1.117-24.87Z",
    fill: "#167227",
    "mix-blend-mode": "multiply",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4034.835,3407.821s-12.952,.969-21.955,10.549c-6.324,6.73-11.504,13.117-14.751,30.102-2.361,12.352-12.943,27.331-17.973,32.882-5.03,5.55-12.673,10.465-20.871,20.493-8.197,10.029-12.705,27.106-12.705,27.106,0,0,3.204-20.309,11.029-29.437,7.824-9.127,17.884-14.215,25.15-25.894,7.266-11.68,9.583-24.033,11.498-31.299,1.916-7.266,9.181-20.907,15.888-26.662,6.706-5.754,18.961-13.396,24.689-7.841Z",
    fill: "#167227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3971.862,3463.223c-5.51,1.39-13.134,1.633-18.444,4.2-5.31,2.566-4.417,6.199-4.724,10.391-.306,4.192,9.195,1.676,16.181,0,6.986-1.677,11.81-8.569,14.325-12.066,2.515-3.498-1.978-3.877-7.339-2.525Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3983.077,3434.343c-7.491,.532-14.662,1.596-20.623,5.068-5.962,3.471-7.359,8.501-6.52,10.737,.838,2.235,6.427-1.956,14.531-3.633,8.104-1.677,13.955,.277,17.029-3.97,3.074-4.246,2.445-8.69-4.416-8.203Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4001.377,3408.79c-8.221,1.002-13.866,3.684-17.499,6.872-3.633,3.188,1.924,3.905,6.831,2.708,4.906-1.196,12.013-2.697,16.843-6.977,4.83-4.28-1.042-3.228-6.175-2.603Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3948.694,3497.655c-4.507,1.652-5.562,9.903-5.17,13.475,.393,3.571,3.466,.218,6.54-5.65,3.074-5.868,3.967-9.781-1.37-7.824Z",
    fill: "#2ca348",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3965.993,3502.143c-4.16,2.294-10.785,10.776-10.283,16.557,.502,5.782,9.605,3.825,13.018-3.719,3.413-7.546,5.984-17.647-2.735-12.838Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3993.1,3477.814c-2.514,3.112-3.385,17.627-2.391,23.624,.994,5.997,11.493-1.171,13.789-8.205,2.295-7.035-5.529-22.684-11.398-15.418Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4009.35,3437.471c-3.731,4.805,1.515,11.28,3.53,18.267,2.016,6.986,2.491,19.002,4.629,22.076,2.138,3.074,10.801-3.633,10.801-12.296s-5.31-20.958-8.384-25.15c-3.074-4.192-7.845-6.413-10.576-2.897Z",
    fill: "#2ca348",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4027.378,3415.662c-6.164-.414-6.892,6.005-1.583,13.12,5.31,7.115,8.67,16.896,11.461,18.572,2.791,1.677,7.542-6.023,4.468-15.867-3.074-9.843-7.732-15.381-14.346-15.826Z",
    fill: "#2ca348",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 2828.838,
    y1: 3936.444,
    x2: 2858.203,
    y2: 4289.949,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2857.638,
    y1: 3953.385,
    x2: 2887.003,
    y2: 4306.89,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2882.627,
    y1: 3967.502,
    x2: 2911.991,
    y2: 4321.007,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2909.309,
    y1: 3982.749,
    x2: 2938.674,
    y2: 4336.254,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2936.415,
    y1: 3997.996,
    x2: 2965.779,
    y2: 4351.501,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2964.368,
    y1: 4014.09,
    x2: 2993.732,
    y2: 4367.596,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2993.168,
    y1: 4030.184,
    x2: 3022.532,
    y2: 4383.69,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3022.815,
    y1: 4048.82,
    x2: 3052.179,
    y2: 4402.325,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3052.462,
    y1: 4066.608,
    x2: 3081.826,
    y2: 4420.113,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3082.109,
    y1: 4082.702,
    x2: 3111.473,
    y2: 4436.207,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3110.061,
    y1: 4100.49,
    x2: 3139.426,
    y2: 4453.995,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3133.779,
    y1: 4113.196,
    x2: 3163.144,
    y2: 4466.701,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3160.038,
    y1: 4129.29,
    x2: 3189.402,
    y2: 4482.795,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3190.532,
    y1: 4147.925,
    x2: 3219.897,
    y2: 4501.431,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3216.791,
    y1: 4161.478,
    x2: 3232.32,
    y2: 4433.948,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3241.638,
    y1: 4173.902,
    x2: 3062.909,
    y2: 4409.384,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3221.308,
    y1: 4160.349,
    x2: 3042.579,
    y2: 4395.831,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3198.438,
    y1: 4150.184,
    x2: 3019.709,
    y2: 4385.666,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3177.261,
    y1: 4138.325,
    x2: 2998.532,
    y2: 4373.807,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3158.203,
    y1: 4124.773,
    x2: 2979.473,
    y2: 4360.254,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3137.873,
    y1: 4111.22,
    x2: 2959.144,
    y2: 4346.702,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3115.003,
    y1: 4101.055,
    x2: 2936.274,
    y2: 4336.537,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3093.826,
    y1: 4089.196,
    x2: 2915.097,
    y2: 4324.678,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3073.497,
    y1: 4075.643,
    x2: 2894.768,
    y2: 4311.125,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3053.167,
    y1: 4062.09,
    x2: 2874.438,
    y2: 4297.572,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3030.297,
    y1: 4051.926,
    x2: 2851.568,
    y2: 4287.408,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3009.12,
    y1: 4040.067,
    x2: 2830.391,
    y2: 4275.549,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2989.638,
    y1: 4027.361,
    x2: 2817.262,
    y2: 4245.055,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2969.309,
    y1: 4013.808,
    x2: 2805.403,
    y2: 4219.643,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2946.438,
    y1: 4003.643,
    x2: 2804.556,
    y2: 4184.914,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2925.262,
    y1: 3991.785,
    x2: 2802.862,
    y2: 4144.255,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2903.238,
    y1: 3979.079,
    x2: 2806.25,
    y2: 4097.667,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2882.909,
    y1: 3965.526,
    x2: 2804.556,
    y2: 4064.631,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2860.038,
    y1: 3955.361,
    x2: 2804.556,
    y2: 4029.055,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2838.862,
    y1: 3943.502,
    x2: 2800.321,
    y2: 3990.09,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3238.295,
    y1: 4378.075,
    x2: 3168.579,
    y2: 4471.219,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3234.907,
    y1: 4345.887,
    x2: 3148.25,
    y2: 4457.666,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3239.989,
    y1: 4296.758,
    x2: 3125.379,
    y2: 4447.501,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3239.989,
    y1: 4262.875,
    x2: 3104.203,
    y2: 4435.642,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3241.683,
    y1: 4217.134,
    x2: 3085.144,
    y2: 4422.09,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 2861.049,
    y1: 3816.219,
    x2: 3019.166,
    y2: 4044.36,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2876.86,
    y1: 3801.537,
    x2: 3034.978,
    y2: 4029.678,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2904.531,
    y1: 3789.114,
    x2: 3062.648,
    y2: 4017.254,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2931.637,
    y1: 3774.431,
    x2: 3089.754,
    y2: 4002.572,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2955.354,
    y1: 3762.008,
    x2: 3113.472,
    y2: 3990.149,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2981.331,
    y1: 3746.196,
    x2: 3139.448,
    y2: 3974.337,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3007.307,
    y1: 3731.514,
    x2: 3154.978,
    y2: 3951.749,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2914.131,
    y1: 3784.596,
    x2: 2870.743,
    y2: 4143.654,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2943.166,
    y1: 3764.314,
    x2: 2899.778,
    y2: 4123.372,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2974.79,
    y1: 3742.855,
    x2: 2931.402,
    y2: 4101.913,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3005.284,
    y1: 3729.302,
    x2: 2961.896,
    y2: 4088.36,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3035.778,
    y1: 3713.49,
    x2: 2992.39,
    y2: 4072.548,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3067.401,
    y1: 3695.42,
    x2: 3024.013,
    y2: 4054.478,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2839.025,
    y1: 3828.643,
    x2: 2997.143,
    y2: 4056.784,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2820.955,
    y1: 3841.066,
    x2: 2979.072,
    y2: 4069.207,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2801.755,
    y1: 3852.361,
    x2: 2959.872,
    y2: 4080.501,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2781.425,
    y1: 3864.784,
    x2: 2939.543,
    y2: 4092.925,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2762.225,
    y1: 3874.949,
    x2: 2920.343,
    y2: 4103.089,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2743.025,
    y1: 3885.113,
    x2: 2901.143,
    y2: 4113.254,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2763.755,
    y1: 3864.243,
    x2: 2729.473,
    y2: 4180.454,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2792.79,
    y1: 3843.961,
    x2: 2749.402,
    y2: 4203.019,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2824.414,
    y1: 3822.502,
    x2: 2781.025,
    y2: 4181.56,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2854.908,
    y1: 3808.949,
    x2: 2811.519,
    y2: 4168.007,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2885.402,
    y1: 3793.137,
    x2: 2842.013,
    y2: 4152.195,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3099.307,
    y1: 3671.702,
    x2: 3055.919,
    y2: 4030.76,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3130.366,
    y1: 3653.067,
    x2: 3086.978,
    y2: 4012.125,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3154.695,
    y1: 3686.902,
    x2: 3122.554,
    y2: 3997.443,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3031.872,
    y1: 3718.526,
    x2: 3159.213,
    y2: 3914.478,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3051.213,
    y1: 3704.126,
    x2: 3153.566,
    y2: 3862.525,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3073.872,
    y1: 3695.231,
    x2: 3151.872,
    y2: 3817.914,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3092.26,
    y1: 3684.29,
    x2: 3154.695,
    y2: 3780.643,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3113.031,
    y1: 3673.737,
    x2: 3153.001,
    y2: 3734.337,
    fill: "#fff",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3150.902,3993.604c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3124.926,3620.005s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3132.079,4019.816s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3143.561,4000.098c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 2743.286,
    y1: 3908.522,
    x2: 2772.65,
    y2: 4262.027,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2769.544,
    y1: 3924.616,
    x2: 2798.909,
    y2: 4278.121,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2800.039,
    y1: 3943.251,
    x2: 2829.403,
    y2: 4296.756,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2826.297,
    y1: 3956.804,
    x2: 2841.827,
    y2: 4229.274,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2847.802,
    y1: 4173.401,
    x2: 2778.086,
    y2: 4266.545,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2844.413,
    y1: 4141.213,
    x2: 2757.756,
    y2: 4252.992,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2849.496,
    y1: 4092.083,
    x2: 2734.886,
    y2: 4242.827,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2849.496,
    y1: 4058.201,
    x2: 2713.709,
    y2: 4230.968,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 2848.092,
    y1: 4025.73,
    x2: 2778.376,
    y2: 4118.874,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2844.704,
    y1: 3993.542,
    x2: 2758.046,
    y2: 4105.321,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2849.786,
    y1: 3944.413,
    x2: 2735.176,
    y2: 4095.157,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2849.786,
    y1: 3910.531,
    x2: 2713.999,
    y2: 4083.298,
    fill: "none",
    stroke: "#0da600",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2869.26,4309.981c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2843.284,3936.382s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2850.437,4336.193s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2861.919,4316.475c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2765.373,4239.241c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2739.397,3865.642s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2746.549,4265.453s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2758.032,4245.735c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5318.804,5734.024c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5292.827,5360.425s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5299.98,5760.236s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5311.463,5740.518c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5768.309,6002.823c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5742.332,5629.224s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5749.485,6029.035s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5760.968,6009.318c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3252.549,4528.944c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3226.573,4155.345s.565-9.035,13.553-12.988l5.082,10.729-18.635,2.259Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3233.726,4555.156s6.024,1.882,16.188-13.553l-10.541-6.776-5.647,20.329Z",
    fill: "#a06600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3245.208,4535.438c0,11-5.336,20-11.859,20s-11.859-9-11.859-20v-366.587c0-11,5.336-20,11.859-20s11.859,9,11.859,20v366.587Z",
    fill: "#e29700"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "2311.469 4201.745 2311.469 4213.792 2334.057 4210.78 2311.469 4201.745",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4012.924,4983.579l-147.388,86.4s-18.635,10.165-37.271-1.694l-1516.797-866.539,33.882-18.635,1482.35,852.987s24.847,13.553,40.659,3.388l123.106-71.153,21.459,15.247Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7134.112,4878.295c-17.146,32.586-27.036,60.802-36.632,105.403-5.683,26.418-1.737,58.206,2.425,79.804,.573,2.971,1.143,5.686,1.699,8.232,2.826,2.6,5.451,5.58,7.509,8.725,10.124-24.149,40.544-98.5,51.124-144.561,9.13-39.748,13.5-84.098,15.258-106.198,.698-8.795,.996-14.173,.996-14.173,0,0-25.235,30.182-42.38,62.768Z",
    fill: "#3d7c14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7097.48,4983.698c9.597-44.601,19.486-72.815,36.632-105.402,17.145-32.588,42.38-62.769,42.38-62.769,0,0-.298,5.378-.998,14.173-8.885,23.4-35.429,66.567-45.514,91.948-14.134,35.57-23.661,116.322-30.077,141.854-4.16-21.598-8.107-53.386-2.424-79.804Z",
    fill: "#167227",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7070.212,5060.312c.584-4.496,1.373-11.409,1.951-19.919,1.494-21.945,1.531-53.977-7.336-79.503-14.97-43.095-28.229-69.894-49.225-100.143-20.996-30.25-49.726-57.125-49.726-57.125,0,0,.952,5.302,2.721,13.945,4.44,21.722,14.194,65.206,28.107,103.542,16.649,45.873,57.974,119.092,69.563,139.289,1.316-.102,2.63-.075,3.944-.086Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7064.827,4960.89c-14.968-43.095-28.229-69.892-49.225-100.143-20.996-30.249-49.726-57.125-49.726-57.125,0,0,.952,5.302,2.72,13.946,11.676,22.14,43.291,61.743,56.4,85.703,18.371,33.579,37.683,112.564,47.167,137.121,1.494-21.944,1.53-53.976-7.336-79.502Z",
    fill: "#97c941",
    "mix-blend-mode": "lighten",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7053.726,4867.48s9.996,29.329,13.259,88.447c2.311,41.862,.271,83.609-1.119,104.478,4.544-.386,9.076-.119,13.538,.643-.767-29.851-2.924-109.857-4.659-136.624-2.148-33.15-12.179-56.944-12.179-56.944,0,0,7.285-15.435,2.261-26.485-5.023-11.05-29.632-3.708-29.632-3.708,0,0,1.699,18.487,8.734,23.46,7.035,4.973,9.797,6.733,9.797,6.733Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7049.662,4760.523c-8.953-5.623-15.739-.054-18.403,7.701-5.413-5.506-12.422-7.945-19.184-.963-4.39,4.532-5.646,12.086-5.128,18.161,.323,3.787,2.257,10.541,6.72,11.179,.367,2.326,2.425,3.795,4.465,3.891,5.456,15.178,17.036,30.623,31.729,36.087,15.392,5.725,23.297-5.435,22.54-19.538-.902-16.786-7.17-46.74-22.738-56.518Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7038.172,4780.856c-3.762-8.985-10.051-6.64-14.282-2.628-.019-.43-4.36-7-9.945-7.035-29.284-.183-15.959,55.639,.992,68.914,8.015,6.277,14.3,6.679,17.36-3.81,.468-1.604,.705-3.211,.969-4.817,18.254,2.812,8.257-42.621,4.905-50.624Z",
    fill: "#ff9803"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7068.868,4803.219c-3.04-8.471-7.123-23.477-16.72-26.961,9.904,17.385,15.164,44.125,11.522,54.24-4.973,13.813-19.741,7.613-19.741,7.613,0,0-10.093,17.25-23.613,3.989-9.468-9.288-13.224-29.588-14.755-42.248-1.174,5.002-1.246,10.401-.534,15.215,2.104,14.205,9.363,31.07,21.32,39.799,7.863,5.74,18.453,6.92,25.257,.444,4.769,.237,9.766-1.178,13.802-4.454,14.808-12.018,8.867-32.566,3.462-47.637Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7043.929,4838.111s14.769,6.2,19.741-7.613c3.642-10.115-1.618-36.855-11.522-54.24-2.27-.824-4.842-1.013-7.788-.307-5.965,1.43-9.497,5.715-11.199,10.87-3.707-3.121-9.108-4.427-14.278-2.793-7.692,2.432-11.654,8.714-13.322,15.825,1.53,12.66,5.286,32.959,14.755,42.248,13.52,13.261,23.613-3.989,23.613-3.989Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7043.929,4838.111s14.769,6.2,19.741-7.613c3.642-10.115-1.618-36.855-11.522-54.24-2.27-.824-4.842-1.013-7.788-.307-5.965,1.43-9.497,5.715-11.199,10.87-3.707-3.121-9.108-4.427-14.278-2.793-7.692,2.432-11.654,8.714-13.322,15.825,1.53,12.66,5.286,32.959,14.755,42.248,13.52,13.261,23.613-3.989,23.613-3.989Z",
    fill: "#ffab03",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7072.983,5060.253c2.822,.12,5.615,.495,8.378,1.082,.404-50.68,5.667-135.084,11.593-158.065,4.58-17.76,11.081-47.868,15.636-69.528-5.47-16.226-10.663-27.948-10.663-27.948,0,0-18.215,67.493-24.578,112.848-6.363,45.356-3.724,98.386-.899,119.935,.915,6.981,.808,13.886,.534,21.677Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7089.609,5063.918c1.973-8.028,3.911-17.104,5.677-27.551,7.981-47.238,27.408-109.294,25.749-145.76-.842-18.529-6.793-40.101-12.446-56.864-4.554,21.66-11.056,51.768-15.636,69.528-5.926,22.98-11.189,107.385-11.593,158.065,2.805,.596,5.554,1.465,8.248,2.582Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7089.609,5063.918c1.973-8.028,3.911-17.104,5.677-27.551,7.981-47.238,27.408-109.294,25.749-145.76-.842-18.529-6.793-40.101-12.446-56.864-4.554,21.66-11.056,51.768-15.636,69.528-5.926,22.98-11.189,107.385-11.593,158.065,2.805,.596,5.554,1.465,8.248,2.582Z",
    fill: "#167227",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7218.113,4903.044c-24.848,27.174-41.569,51.96-62.159,92.671-11.758,23.243-16.094,53.499-17.692,75.313,4.379-1.078,8.836-1.905,13.494-2.291,2.66-.22,5.605-.189,8.621-.027,21.331-28.844,52.14-72.244,68.402-103.321,18.91-36.135,34.383-77.927,41.685-98.86,2.906-8.33,4.558-13.456,4.558-13.456,0,0-32.063,22.797-56.91,49.971Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7218.113,4903.044c-24.848,27.174-41.569,51.96-62.159,92.671-11.758,23.243-16.094,53.499-17.692,75.313,.416-.102,.838-.189,1.257-.285,13.36-25.727,41.716-97.077,63.606-126.81,16.191-21.995,52.814-57.02,67.34-77.403,2.906-8.33,4.558-13.456,4.558-13.456,0,0-32.063,22.797-56.91,49.971Z",
    fill: "#97c941",
    "mix-blend-mode": "lighten",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7131.367,5073.015c4.007-1.319,8.054-2.445,12.228-3.2,2.034-21.952,5.416-50.748,10.882-79.306,11.131-58.153,24.955-85.884,24.955-85.884,0,0,2.974-1.376,10.609-5.364,7.636-3.989,11.79-22.084,11.79-22.084,0,0-23.408-10.563-29.863-.282-6.455,10.279-1.297,26.55-1.297,26.55,0,0-13.118,22.239-19.675,54.806-4.349,21.601-13.766,78.683-19.629,114.765Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7197.745,4799.168c9.624-4.377,15.606,2.048,17.21,10.09,6.101-4.734,13.372-6.214,19.142,1.608,3.744,5.079,3.982,12.731,2.656,18.684-.827,3.709-3.645,10.145-8.153,10.18-.674,2.256-2.911,3.437-4.944,3.26-7.434,14.314-20.975,28.074-36.265,31.526-16.019,3.617-22.362-8.499-19.728-22.374,3.137-16.515,13.349-45.362,30.083-52.974Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7206.416,4820.855c4.93-8.402,10.848-5.238,14.506-.697,.076-.424,5.255-6.355,10.795-5.644,29.045,3.73,8.385,57.273-10.188,68.164-8.782,5.15-15.064,4.71-16.695-6.093-.25-1.653-.271-3.277-.317-4.904-18.467,.347-2.491-43.343,1.899-50.826Z",
    fill: "#ff9803"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7173.009,4838.917c4.143-7.989,10.195-22.316,20.17-24.486-12.136,15.905-20.922,41.704-18.663,52.214,3.082,14.354,18.548,10.182,18.548,10.182,0,0,7.699,18.443,22.868,7.108,10.624-7.94,17.058-27.557,20.266-39.899,.495,5.115-.154,10.475-1.504,15.15-3.981,13.797-13.429,29.542-26.444,36.595-8.559,4.638-19.213,4.393-25.09-2.932-4.759-.403-9.522-2.473-13.085-6.259-13.069-13.889-4.438-33.458,2.933-47.672Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7193.064,4876.827s-15.466,4.172-18.548-10.182c-2.258-10.51,6.527-36.309,18.663-52.214,2.359-.513,4.935-.358,7.761,.736,5.72,2.214,8.647,6.932,9.646,12.268,4.09-2.598,9.619-3.17,14.523-.86,7.298,3.437,10.386,10.193,11.089,17.461-3.208,12.342-9.642,31.959-20.266,39.899-15.169,11.335-22.868-7.108-22.868-7.108Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7193.064,4876.827s-15.466,4.172-18.548-10.182c-2.258-10.51,6.527-36.309,18.663-52.214,2.359-.513,4.935-.358,7.761,.736,5.72,2.214,8.647,6.932,9.646,12.268,4.09-2.598,9.619-3.17,14.523-.86,7.298,3.437,10.386,10.193,11.089,17.461-3.208,12.342-9.642,31.959-20.266,39.899-15.169,11.335-22.868-7.108-22.868-7.108Z",
    fill: "#ffab03",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7128.379,5073.972c3.225-1.171,6.496-2.108,9.801-2.926,5.697-21.329,15.216-72.936,14.97-118.338-.248-45.799-9.283-115.12-9.283-115.12,0,0-6.711,10.923-14.301,26.274,1.621,22.075,4.042,52.78,6.209,70.994,2.473,20.783-1.949,88.832-7.395,139.116Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7116.298,5078.772c1.608-.573,3.148-1.131,4.462-1.717,2.534-1.128,5.068-2.156,7.618-3.084,5.447-50.284,9.869-118.333,7.395-139.116-2.166-18.214-4.588-48.919-6.209-70.994-7.841,15.857-16.619,36.441-19.929,54.692-6.513,35.917,4.449,100.01,6.049,147.892,.145,4.336,.364,8.397,.613,12.327Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7116.298,5078.772c1.608-.573,3.148-1.131,4.462-1.717,2.534-1.128,5.068-2.156,7.618-3.084,5.447-50.284,9.869-118.333,7.395-139.116-2.166-18.214-4.588-48.919-6.209-70.994-7.841,15.857-16.619,36.441-19.929,54.692-6.513,35.917,4.449,100.01,6.049,147.892,.145,4.336,.364,8.397,.613,12.327Z",
    fill: "#167227",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7091.021,5064.402c.486,.22,.999,.517,1.5,.781-7.206-17.173-17.018-35.977-29.711-50.138-30.45-33.973-53.03-53.57-84.078-73.365-31.048-19.796-67.928-33.493-67.928-33.493,0,0,2.925,4.523,7.894,11.813,12.485,18.321,38.273,54.666,65.911,84.656,16.649,18.065,41.774,40.123,64.988,59.398,13.543-4.838,28.353-5.584,41.424,.347Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7091.021,5064.402c.486,.22,.999,.517,1.5,.781-7.206-17.173-17.018-35.977-29.711-50.138-30.45-33.973-53.03-53.57-84.078-73.365-31.048-19.796-67.928-33.493-67.928-33.493,0,0,2.925,4.523,7.894,11.813,19.319,15.914,63.774,40.237,85.119,57.277,21.665,17.295,52.935,56.305,75.487,83.754,3.996,.674,7.943,1.657,11.718,3.37Z",
    fill: "#167227",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6847.596,5214.455c3.44,1.905,6.68,4.234,9.655,6.792,.369-.12,.716-.273,1.09-.387,11.893-28.688,38.826-95.826,48.658-138.633,9.13-39.75,13.5-84.099,15.259-106.2,.698-8.795,.996-14.173,.996-14.173,0,0-25.235,30.182-42.38,62.769-17.146,32.586-27.036,60.801-36.632,105.402-5.683,26.418-1.737,58.206,2.425,79.804,.31,1.61,.621,3.137,.929,4.627Z",
    fill: "#3d7c14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6844.242,5130.025c9.597-44.601,19.486-72.817,36.632-105.403,17.145-32.588,42.38-62.769,42.38-62.769,0,0-.298,5.378-.998,14.174-8.884,23.399-35.429,66.565-45.514,91.947-14.134,35.57-23.661,116.322-30.077,141.854-4.16-21.598-8.107-53.385-2.424-79.803Z",
    fill: "#167227",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6817.012,5206.341c.58-4.505,1.349-11.3,1.915-19.622,1.493-21.944,1.53-53.977-7.337-79.503-14.968-43.095-28.229-69.892-49.225-100.143-20.996-30.249-49.726-57.125-49.726-57.125,0,0,.952,5.302,2.721,13.946,4.44,21.72,14.194,65.205,28.107,103.541,16.509,45.487,57.263,117.833,69.251,138.742,1.436,.054,2.893,.061,4.294,.165Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6811.589,5107.216c-14.968-43.095-28.229-69.892-49.225-100.141-20.996-30.25-49.726-57.127-49.726-57.127,0,0,.952,5.302,2.72,13.946,11.676,22.14,43.291,61.743,56.4,85.704,18.371,33.577,37.683,112.562,47.167,137.121,1.494-21.945,1.53-53.977-7.336-79.503Z",
    fill: "#97c941",
    "mix-blend-mode": "lighten",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6800.488,5013.807s9.996,29.329,13.259,88.448c2.291,41.477,.307,82.862-1.082,103.919,4.73,.18,9.299,.574,13.502,1.232-.766-29.828-2.926-109.882-4.66-136.656-2.148-33.151-12.179-56.944-12.179-56.944,0,0,7.285-15.435,2.261-26.485-5.023-11.049-29.632-3.708-29.632-3.708,0,0,1.698,18.489,8.734,23.46,7.035,4.973,9.798,6.733,9.798,6.733Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6796.424,4906.849c-8.953-5.623-15.739-.054-18.403,7.701-5.413-5.506-12.421-7.943-19.184-.963-4.39,4.533-5.646,12.086-5.128,18.162,.323,3.786,2.257,10.54,6.72,11.177,.367,2.326,2.425,3.795,4.465,3.891,5.456,15.18,17.036,30.623,31.728,36.088,15.392,5.724,23.297-5.436,22.54-19.539-.902-16.785-7.17-46.738-22.738-56.518Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6784.936,4927.184c-3.764-8.985-10.051-6.64-14.283-2.629-.019-.43-4.36-7-9.945-7.035-29.284-.183-15.959,55.639,.992,68.914,8.015,6.277,14.3,6.679,17.36-3.809,.468-1.605,.706-3.212,.969-4.817,18.254,2.81,8.257-42.622,4.907-50.624Z",
    fill: "#ff9803"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6815.63,4949.546c-3.04-8.471-7.123-23.478-16.72-26.962,9.904,17.385,15.164,44.125,11.522,54.24-4.973,13.813-19.741,7.613-19.741,7.613,0,0-10.093,17.25-23.613,3.989-9.468-9.287-13.224-29.588-14.755-42.248-1.174,5.002-1.246,10.401-.534,15.215,2.104,14.205,9.363,31.072,21.319,39.799,7.863,5.741,18.454,6.921,25.257,.446,4.769,.236,9.766-1.179,13.802-4.454,14.808-12.02,8.867-32.567,3.462-47.637Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6790.691,4984.437s14.769,6.2,19.741-7.613c3.642-10.115-1.618-36.855-11.522-54.24-2.269-.823-4.842-1.013-7.788-.307-5.965,1.432-9.497,5.715-11.199,10.87-3.707-3.121-9.108-4.426-14.278-2.793-7.692,2.432-11.654,8.716-13.322,15.825,1.53,12.66,5.286,32.961,14.755,42.248,13.52,13.261,23.613-3.989,23.613-3.989Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6790.691,4984.437s14.769,6.2,19.741-7.613c3.642-10.115-1.618-36.855-11.522-54.24-2.269-.823-4.842-1.013-7.788-.307-5.965,1.432-9.497,5.715-11.199,10.87-3.707-3.121-9.108-4.426-14.278-2.793-7.692,2.432-11.654,8.716-13.322,15.825,1.53,12.66,5.286,32.961,14.755,42.248,13.52,13.261,23.613-3.989,23.613-3.989Z",
    fill: "#ffab03",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6819.744,5206.638c2.938,.288,5.723,.666,8.378,1.136,.396-50.667,5.664-135.18,11.595-158.176,4.58-17.762,11.081-47.868,15.635-69.528-5.47-16.226-10.663-27.949-10.663-27.949,0,0-18.215,67.493-24.578,112.849-6.363,45.355-3.724,98.384-.899,119.933,.917,6.998,.808,13.921,.533,21.735Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6832.911,5208.675c1.185,.276,2.39,.612,3.607,.992,1.921-7.885,3.808-16.787,5.53-26.975,7.981-47.238,27.408-109.294,25.749-145.759-.842-18.53-6.793-40.101-12.446-56.864-4.554,21.66-11.056,51.767-15.635,69.528-5.93,22.996-11.198,107.51-11.595,158.176,1.626,.289,3.306,.553,4.79,.9Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6832.911,5208.675c1.185,.276,2.39,.612,3.607,.992,1.921-7.885,3.808-16.787,5.53-26.975,7.981-47.238,27.408-109.294,25.749-145.759-.842-18.53-6.793-40.101-12.446-56.864-4.554,21.66-11.056,51.767-15.635,69.528-5.93,22.996-11.198,107.51-11.595,158.176,1.626,.289,3.306,.553,4.79,.9Z",
    fill: "#167227",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6964.875,5049.37c-24.847,27.174-41.567,51.961-62.159,92.671-11.626,22.982-15.989,52.804-17.632,74.563,2.472-.1,4.962-.218,7.331-.189,4.044,.048,8.485,.418,12.937,1.038,21.362-28.789,53.468-73.782,70.19-105.737,18.91-36.135,34.383-77.927,41.685-98.86,2.906-8.33,4.558-13.456,4.558-13.456,0,0-32.063,22.797-56.91,49.971Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6964.875,5049.37c-24.847,27.174-41.567,51.961-62.159,92.671-11.626,22.982-15.989,52.804-17.632,74.563,.492-.021,.97-.023,1.459-.038,13.471-26.155,41.6-96.771,63.344-126.308,16.192-21.996,52.814-57.02,67.34-77.403,2.906-8.33,4.558-13.456,4.558-13.456,0,0-32.063,22.797-56.91,49.971Z",
    fill: "#97c941",
    "mix-blend-mode": "lighten",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6918.73,5023.221c-6.455,10.281-1.297,26.55-1.297,26.55,0,0-13.118,22.241-19.675,54.807-4.259,21.147-13.373,76.306-19.257,112.474,4.024-.365,7.978-.574,11.825-.583,2.03-21.993,5.421-50.937,10.913-79.634,11.131-58.153,24.956-85.884,24.956-85.884,0,0,2.972-1.376,10.607-5.364,7.638-3.988,11.79-22.083,11.79-22.083,0,0-23.408-10.563-29.863-.284Z",
    fill: "#529e21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6944.507,4945.495c9.624-4.377,15.606,2.048,17.211,10.09,6.1-4.734,13.371-6.214,19.14,1.609,3.744,5.078,3.981,12.731,2.656,18.683-.827,3.709-3.645,10.145-8.153,10.181-.674,2.256-2.91,3.436-4.944,3.26-7.434,14.313-20.975,28.072-36.265,31.525-16.019,3.617-22.362-8.499-19.728-22.374,3.137-16.514,13.349-45.362,30.083-52.974Z",
    fill: "#ffab03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6953.178,4967.181c4.93-8.402,10.848-5.237,14.506-.696,.076-.425,5.255-6.355,10.796-5.644,29.044,3.73,8.384,57.272-10.189,68.164-8.782,5.15-15.064,4.708-16.695-6.095-.25-1.653-.271-3.277-.317-4.904-18.467,.349-2.491-43.343,1.899-50.826Z",
    fill: "#ff9803"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6919.771,4985.243c4.143-7.989,10.195-22.316,20.17-24.486-12.136,15.906-20.922,41.704-18.663,52.215,3.082,14.353,18.548,10.181,18.548,10.181,0,0,7.699,18.444,22.868,7.108,10.625-7.94,17.058-27.555,20.266-39.899,.495,5.115-.154,10.475-1.504,15.15-3.981,13.797-13.429,29.543-26.444,36.595-8.559,4.638-19.213,4.395-25.09-2.932-4.758-.403-9.522-2.473-13.085-6.258-13.069-13.889-4.437-33.459,2.933-47.674Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6939.826,5023.153s-15.466,4.172-18.548-10.181c-2.258-10.511,6.527-36.309,18.663-52.215,2.359-.513,4.935-.358,7.761,.736,5.72,2.216,8.647,6.933,9.646,12.27,4.092-2.599,9.619-3.17,14.523-.862,7.3,3.437,10.386,10.193,11.089,17.461-3.208,12.343-9.641,31.959-20.266,39.899-15.169,11.337-22.868-7.108-22.868-7.108Z",
    fill: "#ffc802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6939.826,5023.153s-15.466,4.172-18.548-10.181c-2.258-10.511,6.527-36.309,18.663-52.215,2.359-.513,4.935-.358,7.761,.736,5.72,2.216,8.647,6.933,9.646,12.27,4.092-2.599,9.619-3.17,14.523-.862,7.3,3.437,10.386,10.193,11.089,17.461-3.208,12.343-9.641,31.959-20.266,39.899-15.169,11.337-22.868-7.108-22.868-7.108Z",
    fill: "#ffab03",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6875.462,5217.381c3.262-.378,6.472-.653,9.672-.78,5.714-21.73,15.021-72.64,14.778-117.567-.247-45.799-9.283-115.121-9.283-115.121,0,0-6.711,10.925-14.301,26.275,1.621,22.075,4.042,52.78,6.209,70.994,2.425,20.376-1.775,86.241-7.074,136.2Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6862.799,5219.614c4.145-1.02,8.38-1.735,12.664-2.232,5.299-49.959,9.499-115.824,7.074-136.2-2.166-18.214-4.588-48.919-6.209-70.994-7.841,15.857-16.619,36.441-19.929,54.692-6.513,35.917,4.449,100.01,6.049,147.892,.082,2.422,.236,4.558,.351,6.842Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6862.799,5219.614c4.145-1.02,8.38-1.735,12.664-2.232,5.299-49.959,9.499-115.824,7.074-136.2-2.166-18.214-4.588-48.919-6.209-70.994-7.841,15.857-16.619,36.441-19.929,54.692-6.513,35.917,4.449,100.01,6.049,147.892,.082,2.422,.236,4.558,.351,6.842Z",
    fill: "#167227",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6832.911,5208.675c1.937,.452,3.932,1.086,5.938,1.813-7.167-16.896-16.835-35.234-29.277-49.116-30.45-33.971-53.03-53.57-84.078-73.365-31.048-19.796-67.928-33.492-67.928-33.492,0,0,2.926,4.522,7.894,11.813,12.485,18.32,38.273,54.665,65.911,84.655,15.75,17.089,39.071,37.727,61.2,56.229,14.026-2.102,29.326-1.112,40.341,1.463Z",
    fill: "#478c1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6832.911,5208.675c1.937,.452,3.932,1.086,5.938,1.813-7.167-16.896-16.835-35.234-29.277-49.116-30.45-33.971-53.03-53.57-84.078-73.365-31.048-19.796-67.928-33.492-67.928-33.492,0,0,2.926,4.522,7.894,11.813,19.319,15.913,63.774,40.236,85.119,57.276,21.673,17.302,52.961,56.338,75.514,83.788,2.389,.373,4.708,.789,6.819,1.283Z",
    fill: "#167227",
    opacity: 0.5
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.e1b6fa3655b49a5951d67771569a00cc.svg";
export { ForwardRef as ReactComponent };